/* Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01

/*
  GENERATED FILE — DO NOT EDIT DIRECTLY
  Output : assets/slb.guard.js
  Source : slb_src/slices/guard/
  Build  : slb_build/build_guard.mjs
  SHA256 : f55d2aaa90b418da66ad332cbeb7d7c03b6196c3ac1653c36300bfef542cd3f3
  Built  : 2026-09-19 16:54:01.298Z
*/

/* Build-Version: SLB_VISUAL_A11Y_P4_V100_20260719_01 */

/*
  Phase 2: Global error guard + consistent retry UX
  - SLB pages only
  - No console noise unless debug enabled
*/
(function(){
  'use strict';

  function _safeStr(v){ try{return String(v);}catch(_e){return '';} }

  function isSLBPath_(){
    try{
      var p = _safeStr(location.pathname||'');
      p = p.toLowerCase();
      return (
        p === '/pages/saam-law-bank' || p.indexOf('/pages/saam-law-bank/') === 0 ||
        p === '/pages/chat' || p.indexOf('/pages/chat') === 0 ||
        /* SLB Dark QC page (template: page.slb-dark-qc) */
        p === '/pages/slb-dark-qc' || p.indexOf('/pages/slb-dark-qc') === 0
      );
    }catch(_e){ return false; }
  }

  if(!isSLBPath_()) return;

  // ============================================================
  // Phase 1 (Dark Mode Engine - SLB only)
  // - Tokens only (CSS variables), no component styling here.
  // - Default is LIGHT; dark can be enabled via:
  //     ?slbtheme=dark
  //     localStorage SLB_THEME = 'dark'
  // - Provides window.SLBTheme.{get,set,toggle}
  // NOTE: We intentionally avoid touching layout/theme.liquid.
  // ============================================================
  (function(){
    var THEME_KEY = 'SLB_THEME';
    function _qs_(k){
      try{
        var s = _safeStr(location.search||'');
        if(!s) return '';
        var m = s.match(new RegExp('[?&]'+k+'=([^&]+)'));
        return m ? decodeURIComponent(m[1]||'') : '';
      }catch(_e){ return ''; }
    }
    function _getSaved_(){
      try{ return _safeStr(localStorage.getItem(THEME_KEY)||''); }catch(_e){ return ''; }
    }
    function _save_(v){
      try{ localStorage.setItem(THEME_KEY, v); }catch(_e){}
    }
    function _normMaybe_(v){
      v = _safeStr(v||'').toLowerCase();
      if(v === 'dark' || v === 'light') return v;
      return '';
    }
    function ensureTokensStyle_(){
      try{
        if(document.getElementById('slbThemeTokens')) return;
        var css = '' +
          ':root{\n' +
          '  --slb-ty-orange:#ef5e14;\n' +
          '  --slb-ty-dark:#0f1517;\n' +
          '  --slb-bg:#ffffff;\n' +
          '  --slb-panel:#ffffff;\n' +
          '  --slb-panel-2:#f7f7f7;\n' +
          '  --slb-text:#0f1517;\n' +
          '  --slb-text-muted:#6b7680;\n' +
          '  --slb-muted:#6b7680;\n' +
          '  --slb-border:rgba(15,21,23,.14);\n' +
          '  --slb-border-alpha:0.14;\n' +
          '  --slb-input-bg:#ffffff;\n' +
          '  --slb-input-text:#0f1517;\n' +
          '  --slb-input-ph:rgba(15,21,23,.45);\n' +
          '  --slb-btn-bg:#ef5e14;\n' +
          '  --slb-btn-text:#ffffff;\n' +
          '  --slb-btn-muted-bg:#e9ecef;\n' +
          '  --slb-btn-muted-text:#0f1517;\n' +
          '  --slb-zebra-a:rgba(15,21,23,.03);\n' +
          '  --slb-zebra-b:rgba(15,21,23,.06);\n' +
          '  --bg:var(--slb-bg) !important;\n' +
          '  --card:var(--slb-panel) !important;\n' +
          '  --soft:var(--slb-panel-2) !important;\n' +
          '  --text:var(--slb-text) !important;\n' +
          '  --muted:var(--slb-text-muted) !important;\n' +
          '  --border2:rgba(15,21,23,.14);\n' +
          '}\n' +
          ':root[data-slb-theme="dark"]{\n' +
          '  --slb-bg:#0b1113;\n' +
          '  --slb-panel:#0f1517;\n' +
          '  --slb-panel-2:#131c1f;\n' +
          '  --slb-text:#e9eef2;\n' +
          '  --slb-text-muted:#9aa6ad;\n' +
          '  --slb-muted:#9aa6ad;\n' +
          '  --slb-border:rgba(226,230,234,0.3);\n' +
          '  --slb-border-alpha:0.3;\n' +
          '  --slb-input-bg:#0c1214;\n' +
          '  --slb-input-text:#e9eef2;\n' +
          '  --slb-input-ph:#7d8a92;\n' +
          '  --slb-btn-bg:#172125;\n' +
          '  --slb-btn-text:#e9eef2;\n' +
          '  --slb-btn-muted-bg:#444444;\n' +
          '  --slb-btn-muted-text:#e9eef2;\n' +
          '  --slb-zebra-a:#242424;\n' +
          '  --slb-zebra-b:#171717;\n' +
          '  --bg:var(--slb-bg) !important;\n' +
          '  --card:var(--slb-panel) !important;\n' +
          '  --soft:var(--slb-panel-2) !important;\n' +
          '  --text:var(--slb-text) !important;\n' +
          '  --muted:var(--slb-text-muted) !important;\n' +
          '  --border2:rgba(226,230,234,0.3);\n' +
          '}\n';
                        // FIX: Diary Read dark wrappers + zebra
        css += `/* FIX diary read + folds */
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbFold{background:var(--slb-panel)!important;border-color:var(--slb-border)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbFoldHeader{background:var(--slb-panel-2)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbFoldTitle{color:var(--slb-text)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbDiaryWriteBody label{color:var(--slb-text)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbDiaryWriteBody input{color:var(--slb-text)!important;background:var(--slb-input-bg)!important;border-color:var(--slb-border)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadLeft{background:var(--slb-panel)!important;border-color:var(--slb-border)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadRight{background:var(--slb-panel)!important;border-color:var(--slb-border)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadMeta{color:var(--slb-text-muted)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadList .slbDiaryReadItem:nth-child(odd){background:var(--slb-zebra-a)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadList .slbDiaryReadItem:nth-child(even){background:var(--slb-zebra-b)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadList .slbDiaryReadItem{color:var(--slb-text)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadList .slbDiaryReadItem small{color:var(--slb-text-muted)!important;}
`;
var st = document.createElement('style');
        st.id = 'slbThemeTokens';
        st.type = 'text/css';
        st.appendChild(document.createTextNode(css));
        (document.head||document.documentElement).appendChild(st);
      }catch(_e){}
    }
    function ensureComponentsStyle_(){
      try{
        if(document.getElementById('slbThemeComponents')) return;
        var css = '' +
          ':root[data-slb-theme="dark"]{\n' +
          '  /* Map SLB UI vars to dark tokens (used across saamlawbank.css) */\n' +
          '  --bg:var(--slb-bg) !important;\n' +
          '  --card:var(--slb-panel) !important;\n' +
          '  --soft:var(--slb-panel-2) !important;\n' +
          '  --text:var(--slb-text) !important;\n' +
          '  --muted:var(--slb-text-muted) !important;\n' +
          '  --border2:var(--slb-border) !important;\n' +
          '  --border:var(--slb-border) !important;\n' +
          '  --ty-border:var(--slb-border) !important;\n' +
          '  --ty-border-2:rgba(255,255,255,.10);\n' +

          '  --ty-grey-ui:rgba(255,255,255,.10);\n' +
          '  --ty-line:rgba(239,94,20,.28);\n' +
          '\n' +
          '  /* Zebra tokens (tables/lists) */\n' +
          '  --ty-surface:#151d20;\n' +
          '  --ty-surface-2:#0f1517;\n' +
          '  --ty-surface-3:#1d2a30;\n' +
          '  --ty-hover:#21343a;\n' +
          '  --ty-active:#243b42;\n' +
          '  --ty-head-muted-bg:#243b42;\n' +
          '  --ty-head-muted-fg:#f7f7f7;\n' +
          '  --ty-head-brand-bg:var(--slb-ty-orange);\n' +
          '  --ty-head-brand-fg:#ffffff;\n' +
          '}\n' +
          '\n' +
          ':root[data-slb-theme="dark"] body{\n' +
          '  background:var(--bg) !important;\n' +
          '  color:var(--slb-text) !important;\n' +
          '}\n' +
          '\n' +
          '/* Dark mode: override .tyw light variable reset (Wealth Courtyard / Cosmic Pouch) */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard).tyw{\n' +
          '  --bg:var(--slb-bg) !important;\n' +
          '  --card:var(--slb-panel) !important;\n' +
          '  --soft:var(--slb-panel-2) !important;\n' +
          '  --text:var(--slb-text) !important;\n' +
          '  --muted:var(--slb-text-muted) !important;\n' +
          '  --border:var(--slb-border) !important;\n' +
          '  --border2:var(--slb-border) !important;\n' +
          '  --ty-line: rgba(239,94,20,.28) !important;\n' +
          '\n' +
          '  /* Dark zebra tokens to match SLB dark */\n' +
          '  --ty-surface:#151d20 !important;\n' +
          '  --ty-surface-2:#0f1517 !important;\n' +
          '  --ty-surface-3:#1d2a30 !important;\n' +
          '  --ty-hover:#21343a !important;\n' +
          '  --ty-active:#243b42 !important;\n' +
          '  --ty-head-muted-bg:#243b42 !important;\n' +
          '  --ty-head-muted-fg:#f7f7f7 !important;\n' +
          '  --ty-head-brand-bg:var(--slb-ty-orange) !important;\n' +
          '  --ty-head-brand-fg:#ffffff !important;\n' +
          '}\n' +
          '\n' +
          '/* SLB blank header shell */\n' +
          ':root[data-slb-theme="dark"] .tyBlankHeader{\n' +
          '  background:var(--bg) !important;\n' +
          '  border-bottom:1px solid var(--border2) !important;\n' +
          '}\n' +
          '\n' +
          '/* Sticky topbar */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .topbar{\n' +
          '  background:rgba(21,29,32,.92) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '  box-shadow:0 8px 22px rgba(0,0,0,.45) !important;\n' +
          '}\n' +
          '@supports ((-webkit-backdrop-filter: blur(8px)) or (backdrop-filter: blur(8px))){\n' +
          '  :root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .topbar{\n' +
          '    background:rgba(21,29,32,.78) !important;\n' +
          '    -webkit-backdrop-filter: blur(8px);\n' +
          '    backdrop-filter: blur(8px);\n' +
          '  }\n' +
          '}\n' +
          '\n' +
          '/* General inputs/selects/textarea inside SLB */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) input:not([type=checkbox]):not([type=radio]):not([type=range]):not([type=color]):not([type=button]):not([type=submit]):not([type=reset]):not([type=hidden]),\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) select,\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) textarea{\n' +
          '  background:var(--slb-input-bg) !important;\n' +
          '  color:var(--slb-input-text) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) input::placeholder,\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) textarea::placeholder{\n' +
          '  color:rgba(170,180,190,.72) !important;\n' +
          '}\n' +
          '\n' +
          '/* Viewer boxes (read-only rich content) */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .richDisplay,\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbLibCommentRich{\n' +
          '  background:var(--card) !important;\n' +
          '  color:var(--slb-text) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '}\n' +
          '/* Wealth Courtyard / Cosmic Pouch: dark surfaces */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .card{\n' +
          '  background:var(--card) !important;\n' +
          '  color:var(--text) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '  box-shadow:0 12px 24px rgba(0,0,0,.35) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .card :is(h1,h2,h3,h4,h5,h6,label){\n' +
          '  color:var(--text) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .note,\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .muted{\n' +
          '  color:var(--muted) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .badge{\n' +
          '  background:rgba(21,29,32,.55) !important;\n' +
          '  color:var(--text) !important;\n' +
          '  border-color:rgba(255,255,255,.10) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .hr{\n' +
          '  border-color:rgba(255,255,255,.10) !important;\n' +
          '}\n' +
          '/* Tables inside Wealth Courtyard (offers/market/txns) */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .tableWrap{\n' +
          '  background:var(--card) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .tableWrap table{\n' +
          '  background:transparent !important;\n' +
          '  color:var(--text) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .tableWrap thead th{\n' +
          '  background:var(--soft) !important;\n' +
          '  color:var(--text) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .tableWrap tbody td{\n' +
          '  color:var(--text) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .tableWrap tbody tr:nth-child(odd) td{\n' +
          '  background:var(--ty-surface-2) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .tableWrap tbody tr:nth-child(even) td{\n' +
          '  background:var(--ty-surface) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .tableWrap tbody tr:hover td{\n' +
          '  background:var(--ty-hover) !important;\n' +
          '}\n' +
          '/* Orders/Sales: force Market-style dark header + remove listing border (hard override) */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(#slbOrdersPanel,#slbSalesPanel) .tableWrap{\n' +
          '  border:none !important;\n' +
          '  box-shadow:none !important;\n' +
          '  background:transparent !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(#slbOrdersPanel,#slbSalesPanel) .tableWrap table{\n' +
          '  border:none !important;\n' +
          '}\n' +
          '/* TXNS: force Market-style dark header + remove listing border (hard override) */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .card[data-panel="txns"] .tableWrap{\n' +
          '  border:none !important;\n' +
          '  box-shadow:none !important;\n' +
          '  background:transparent !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .card[data-panel="txns"] .tableWrap table{\n' +
          '  border:none !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(#tywTxnsHead,#tywAdmTxnsHead) th{\n' +
          '  background:#3a1f09 !important;\n  background-clip:padding-box !important;\n  box-shadow:0 2px 0 rgba(0,0,0,.55) !important;\n' +
          '  border-color:rgba(239,94,20,.35) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(#slbOrdersPanel,#slbSalesPanel) .tableWrap thead th{\n' +
          '  background:#3a1f09 !important;\n  background-clip:padding-box !important;\n  box-shadow:0 2px 0 rgba(0,0,0,.55) !important;\n' +
          '}\n' +
          '/* ATM / quick buttons */\n' +
          '/* ANNIV: force Market-style dark header + remove listing border (hard override) */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbAnnivPanel .tableWrap{\n' +
          '  border:none !important;\n' +
          '  box-shadow:none !important;\n' +
          '  background:transparent !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbAnnivPanel .tableWrap table{\n' +
          '  border:none !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbAnnivPanel #slbAnnivTable thead th{\n' +
          '  background:#3a1f09 !important;\n  background-clip:padding-box !important;\n  box-shadow:0 2px 0 rgba(0,0,0,.55) !important;\n' +
          '  border-color:rgba(239,94,20,.35) !important;\n' +
          '  position:sticky !important;\n' +
          '  top:0 !important;\n' +
          '  z-index:5 !important;\n' +
          '}\n' +

          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbAnnivPanel #slbAnnivTable thead th:first-child{\n' +
          '  width:420px !important;\n' +
          '  max-width:420px !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .atmDisplayInput{\n' +
          '  background:var(--slb-input-bg) !important;\n' +
          '  color:var(--slb-input-text) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .atmWrap{\n' +
          '  background:rgba(21,29,32,0.85) !important;\n' +
          '  border-color:rgba(239,94,20,0.30) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .atmDisplay{\n' +
          '  background:rgba(255,255,255,.06) !important;\n' +
          '  color:var(--slb-text) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .qBtn{\n' +
          '  background:rgba(255,255,255,.10) !important;\n' +
          '  color:var(--text) !important;\n' +
          '  border-color:rgba(255,255,255,.12) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .qBtn:hover{\n' +
          '  background:rgba(255,255,255,.14) !important;\n' +
          '}\n' +
                    '/* CMR top inputs (extra safety) */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCmrPanel :is(.slbCmrTagInput,.slbCmrNotesText){\n' +
          '  background:var(--slb-input-bg) !important;\n' +
          '  color:var(--slb-input-text) !important;\n' +
          '  border-color:var(--slb-border) !important;\n' +
          '}\n' +
                    '/* CMR v2 (#tycmRoot) dark */\n' +
          ':root[data-slb-theme="dark"] #tycmRoot{ color:var(--slb-text) !important; }\n' +
          ':root[data-slb-theme="dark"] #tycmRoot :is(.tycm-field-label,.tycm-check,.tycm-stepTitle,.tycm-sectionTitle){ color:var(--slb-text) !important; }\n' +
          ':root[data-slb-theme="dark"] #tycmRoot .tycm-radio{ color:var(--slb-text) !important; }\n' +
          ':root[data-slb-theme="dark"] #tycmRoot .tycm-radio.active{ background:rgba(255,255,255,.10) !important; box-shadow:0 10px 20px rgba(0,0,0,.35) !important; }\n' +
          ':root[data-slb-theme="dark"] #tycmRoot :is(.tycm-metaGrid > div, .tycm-metaFull){ background:rgba(21,29,32,0.88) !important; border-color:rgba(255,255,255,.12) !important; }\n' +
          ':root[data-slb-theme="dark"] #tycmRoot input:not([type=checkbox]):not([type=radio]):not([type=range]):not([type=color]),\n' +
          ':root[data-slb-theme="dark"] #tycmRoot select,\n' +
          ':root[data-slb-theme="dark"] #tycmRoot textarea{ background:var(--slb-input-bg) !important; color:var(--slb-input-text) !important; border-color:rgba(255,255,255,.14) !important; }\n' +
          ':root[data-slb-theme="dark"] #tycmRoot input::placeholder,\n' +
          ':root[data-slb-theme="dark"] #tycmRoot textarea::placeholder{ color:rgba(232,238,242,.55) !important; }\n' +
          '\n' +
          '/* SDR records panel (SLB wrapper) dark */\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel details.slbSdrDetails{ background:var(--slb-panel) !important; border-color:var(--slb-border) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel summary.slbSdrSummary{ background:var(--slb-panel-2) !important; color:var(--slb-text) !important; border-bottom:1px solid var(--slb-border) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel :is(.slbSdrList,.slbSdrViewer){ background:var(--slb-panel) !important; border-color:var(--slb-border) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel :is(.slbSdrListHead,.slbSdrViewerHead){ background:var(--slb-panel-2) !important; border-color:var(--slb-border) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel :is(.slbSdrViewerTitle,.slbSdrItemDate,.slbSdrCard h4,.slbSdrCard .content){ color:var(--slb-text) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel :is(.slbSdrMeta,.slbSdrItemAge,.slbSdrItemSnip,.slbSdrSmall){ color:var(--slb-text-muted) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel .slbSdrList .slbSdrItem:nth-of-type(odd){ background:var(--slb-zebra-a) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel .slbSdrList .slbSdrItem:nth-of-type(even){ background:var(--slb-zebra-b) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel .slbSdrItem:hover{ background:var(--ty-hover) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel .slbSdrItem.active{ background:#3a1f09 !important;\n  background-clip:padding-box !important;\n  box-shadow:0 2px 0 rgba(0,0,0,.55) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel :is(.slbSdrTop input,.slbSdrFinalText,.slbSdrNotesText){ background:var(--slb-input-bg) !important; color:var(--slb-input-text) !important; border-color:rgba(255,255,255,.14) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel :is(.slbSdrTop .btn,.slbSdrViewerBtns .btn,.slbSdrBtnRow .btn){ background:rgba(255,255,255,.08) !important; color:var(--slb-text) !important; border-color:rgba(255,255,255,.14) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel :is(.slbSdrBtnRow .btn.primary,.slbSdrTop .btn.primary){ background:var(--slb-action-orange-bg,var(--ty-orange,#ef5e14)) !important; border-color:var(--slb-action-orange-border,var(--ty-orange,#ef5e14)) !important; color:#fff !important; box-shadow:var(--slb-action-orange-shadow,none) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbSdrPanel :is(.slbSdrViewerBtns .btn.danger){ background:#b42318 !important; border-color:#b42318 !important; color:#fff !important; }\n' +
	          ':root[data-slb-theme="dark"] #slbSdrPanel .slbSdrCard{ border-color:rgba(255,255,255,.12) !important; }\n' +
          '/* ---- DCR (Dark) ---- */\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel details.slbDcrDetails{ background:var(--slb-panel) !important; border-color:var(--slb-border) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel summary.slbDcrSummary{ background:var(--slb-panel-2) !important; color:var(--slb-text) !important; border-bottom:1px solid var(--slb-border) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel :is(.slbDcrList,.slbDcrViewer){ background:var(--slb-panel) !important; border-color:var(--slb-border) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel :is(.slbDcrListHead,.slbDcrViewerHead){ background:var(--slb-panel-2) !important; border-color:var(--slb-border) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel :is(.slbDcrViewerTitle,.slbDcrItemDate,.slbDcrCard h4,.slbDcrCard .content,.slbDcrReport){ color:var(--slb-text) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel :is(.slbDcrMeta,.slbDcrItemAge,.slbDcrItemSnip,.slbDcrSmall){ color:var(--slb-text-muted) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel .slbDcrList .slbDcrItem:nth-of-type(odd){ background:var(--slb-zebra-a) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel .slbDcrList .slbDcrItem:nth-of-type(even){ background:var(--slb-zebra-b) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel .slbDcrItem:hover{ background:var(--ty-hover) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel .slbDcrItem.active{ background:#3a1f09 !important;\n  background-clip:padding-box !important;\n  box-shadow:0 2px 0 rgba(0,0,0,.55) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel :is(.slbDcrTop input,.slbDcrFinalText,.slbDcrNotesText){ background:var(--slb-input-bg) !important; color:var(--slb-input-text) !important; border-color:rgba(255,255,255,.14) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel :is(.slbDcrTop .btn,.slbDcrViewerBtns .btn,.slbDcrBtnRow .btn){ background:rgba(255,255,255,.08) !important; color:var(--slb-text) !important; border-color:rgba(255,255,255,.14) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel :is(.slbDcrBtnRow .btn.primary,.slbDcrTop .btn.primary){ background:var(--slb-action-orange-bg,var(--ty-orange,#ef5e14)) !important; border-color:var(--slb-action-orange-border,var(--ty-orange,#ef5e14)) !important; color:#fff !important; box-shadow:var(--slb-action-orange-shadow,none) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel :is(.slbDcrViewerBtns .btn.danger){ background:#b42318 !important; border-color:#b42318 !important; color:#fff !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel .slbDcrCard{ background:var(--slb-panel) !important; border-color:rgba(255,255,255,.12) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel .slbDcrMetaBox{ background:rgba(255,255,255,.05) !important; border-color:var(--slb-border) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel :is(.inp,.seg,.dcrTypeSeg){ background:var(--slb-input-bg) !important; border-color:rgba(255,255,255,.14) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel :is(.segBtn,.dcrTypeBtn,.slbLabel){ color:var(--slb-text) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDcrPanel .muted{ color:var(--slb-text-muted) !important; }\n' +

          '/* ---- DDR (Dark) ---- */\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel details.slbSwrDetails{ background:var(--slb-panel) !important; border-color:var(--slb-border) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel summary.slbSwrSummary{ background:var(--slb-panel-2) !important; color:var(--slb-text) !important; border-bottom:1px solid var(--slb-border) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel :is(.slbSwrList,.slbSwrViewer,.slbDdrMetaGrid .field,.slbDdrBoardZone){ background:var(--slb-panel) !important; border-color:var(--slb-border) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel :is(.slbSwrListHead,.slbSwrViewerHead){ background:var(--slb-panel-2) !important; border-color:var(--slb-border) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel :is(.slbSwrViewerTitle,.slbSwrItemDate,.slbSwrCard h4,.slbSwrCard .content){ color:var(--slb-text) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel :is(.slbSwrMeta,.slbSwrItemAge,.slbSwrItemSnip,.slbSwrSmall,.slbDdrMetaGrid label){ color:var(--slb-text-muted) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel .slbSwrList .slbSwrItem:nth-of-type(odd){ background:var(--slb-zebra-a) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel .slbSwrList .slbSwrItem:nth-of-type(even){ background:var(--slb-zebra-b) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel .slbSwrItem:hover{ background:var(--ty-hover) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel .slbSwrItem.active{ background:#3a1f09 !important;\n  background-clip:padding-box !important;\n  box-shadow:0 2px 0 rgba(0,0,0,.55) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel :is(.slbDdrMetaGrid input,.slbDdrMetaGrid select,.slbSwrNotesText){ background:var(--slb-input-bg) !important; color:var(--slb-input-text) !important; border-color:rgba(255,255,255,.14) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel :is(.slbSwrViewerBtns .btn,.slbSwrBtnRow .btn,.slbDdrMetaGrid .btn){ background:rgba(255,255,255,.08) !important; color:var(--slb-text) !important; border-color:rgba(255,255,255,.14) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel :is(.slbSwrBtnRow .btn.primary){ background:var(--slb-action-orange-bg,var(--ty-orange,#ef5e14)) !important; border-color:var(--slb-action-orange-border,var(--ty-orange,#ef5e14)) !important; color:#fff !important; box-shadow:var(--slb-action-orange-shadow,none) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel :is(.slbSwrViewerBtns .btn.danger){ background:#b42318 !important; border-color:#b42318 !important; color:#fff !important; }\n' +

          ':root[data-slb-theme="dark"] #slbDdrPanel .slbDdrHero{ background:var(--slb-panel) !important; border-color:var(--slb-border) !important; box-shadow:0 10px 24px rgba(0,0,0,.35) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel :is(.seg){ background:rgba(255,255,255,.06) !important; border-color:rgba(255,255,255,.14) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel :is(.segBtn,.slbSwrViewerTitle,.slbSwrItemDate,.slbSwrCard h4,.slbSwrCard .content,.slbDdrMetaGrid label.chkRow){ color:var(--slb-text) !important; }\n' +
          ':root[data-slb-theme="dark"] #slbDdrPanel :is(.slbSwrCard){ border-color:rgba(255,255,255,.12) !important; background:rgba(255,255,255,.04) !important; }\n' +

          '\n' +
'/* SDR tool embed */\n' +
          ':root[data-slb-theme="dark"] #slbSdrToolHost{\n' +
          '  --bg:#0f1517;--card:#151c20;--text:#e8eef2;--muted:rgba(232,238,242,.72);--line:rgba(255,255,255,.12);--soft:rgba(255,255,255,.06);--chip:rgba(255,255,255,.07);--shadow:0 10px 24px rgba(0,0,0,.35);\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] #slbSdrToolHost :is(.hero,.field,.section){\n' +
          '  background:var(--card) !important;\n' +
          '  border-color:var(--line) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] #slbSdrToolHost input[type="text"],\n' +
          ':root[data-slb-theme="dark"] #slbSdrToolHost input[type="date"],\n' +
          ':root[data-slb-theme="dark"] #slbSdrToolHost textarea{\n' +
          '  background:rgba(255,255,255,.06) !important;\n' +
          '  color:var(--text) !important;\n' +
          '  border-color:rgba(255,255,255,.14) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] #slbSdrToolHost .seg{background:rgba(255,255,255,.05) !important;border-color:rgba(255,255,255,.14) !important;}\n' +
          ':root[data-slb-theme="dark"] #slbSdrToolHost .segBtn{color:var(--text) !important;}\n' +
          ':root[data-slb-theme="dark"] #slbSdrToolHost .segBtn.active{background:rgba(255,255,255,.10) !important;}\n' +
'/* Overview anniversary UI */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivStatus{\n' +
          '  color:var(--slb-text-muted) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivWrap.tyl-lunar-card,\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCCalendarPanel #ccalTodayWrap.tyl-lunar-card{\n' +
          '  background:linear-gradient(135deg, rgba(239,94,20,0.18), rgba(0,0,0,0)) !important;\n' +
          '  border:1px solid rgba(239,94,20,0.35) !important;\n' +
          '  box-shadow:0 10px 24px rgba(0,0,0,0.35) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivWrap .tyl-toggle-btn.btn:not(.orange):not(.global-orange):not(.tyBtnOrange),\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivWrap .tyl-sub-btn.btn:not(.orange):not(.global-orange):not(.tyBtnOrange){\n' +
          '  background:rgba(21,29,32,0.75) !important;\n' +
          '  color:var(--slb-text) !important;\n' +
          '  border-color:rgba(239,94,20,0.28) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivWrap .tyl-toggle-btn.btn:not(.orange):not(.global-orange):not(.tyBtnOrange):hover,\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivWrap .tyl-sub-btn.btn:not(.orange):not(.global-orange):not(.tyBtnOrange):hover{\n' +
          '  background:rgba(27,37,41,0.88) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivWrap .slbOvAnnivCard,\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivWrap .slbOvAnnivItem{\n' +
          '  background:rgba(21,29,32,0.85) !important;\n' +
          '  border-color:rgba(255,255,255,0.10) !important;\n' +
          '}\n' +
          '\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivWrap .slbOvAnnivItem{\n' +
          '  color:var(--slb-text) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivWrap .slbOvAnnivLine1,\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivWrap .slbOvAnnivLine1 a{\n' +
          '  color:var(--slb-text) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivWrap .slbOvAnnivLine2{\n' +
          '  color:var(--slb-text-muted) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivWrap .slbOvAnnivLine2.passed{\n' +
          '  opacity:.82;\n' +
          '}\n' +
          '\n' +
          '/* Std Editor v1: protected light island (Phase 3) */\n' +
          ':root[data-slb-theme="dark"] :is(.slbStdEditor,[data-slbeditor="v1"]){\n' +
          '  background:#ffffff !important;\n  color-scheme:light !important;\n  filter:none !important;\n  /* lock editor back to LIGHT vars so toolbar/buttons/pickers stay normal */\n  --text:#111418 !important;\n  --muted:#6b7680 !important;\n  --card:#ffffff !important;\n  --soft:#f7f7f7 !important;\n  --border2:rgba(15,21,23,.14) !important;\n  --border:rgba(15,21,23,.14) !important;\n' +
          '  color:#111418 !important;\n' +
          '  border:1px solid #e2e6ea !important;\n' +
          '  box-shadow:0 10px 24px rgba(0,0,0,.28) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(.slbStdEditor,[data-slbeditor="v1"]) .slbWysToolbar{\n' +
          '  background:#f5f7f9 !important;\n' +
          '  color:#111418 !important;\n' +
          '  border-color:#e2e6ea !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(.slbStdEditor,[data-slbeditor="v1"]) .slbStdArea,\n' +
          ':root[data-slb-theme="dark"] :is(.slbStdEditor,[data-slbeditor="v1"]) [data-slbeditor-area]{\n' +
          '  background:#ffffff !important;\n' +
          '  color:#111418 !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(.slbStdEditor,[data-slbeditor="v1"]) .btn.soft,\n' +
          ':root[data-slb-theme="dark"] :is(.slbStdEditor,[data-slbeditor="v1"]) .btn.grey,\n' +
          ':root[data-slb-theme="dark"] :is(.slbStdEditor,[data-slbeditor="v1"]) .btn.gray,\n' +
          ':root[data-slb-theme="dark"] :is(.slbStdEditor,[data-slbeditor="v1"]) select,\n' +
          ':root[data-slb-theme="dark"] :is(.slbStdEditor,[data-slbeditor="v1"]) input.inp{\n' +
          '  background:#ffffff !important;\n' +
          '  color:#111418 !important;\n' +
          '  border-color:#e2e6ea !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(.slbStdEditor,[data-slbeditor="v1"]) input[type="color"]{\n' +
          '  background:transparent !important;\n' +
          '  border-color:#e2e6ea !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(.slbStdEditor,[data-slbeditor="v1"]) .slbEmojiPanel{\n' +
          '  background:#ffffff !important;\n' +
          '  color:#111418 !important;\n' +
          '  border-color:#e2e6ea !important;\n' +
          '  box-shadow:0 12px 24px rgba(0,0,0,.25) !important;\n' +
          '}\n' +          '/* ===== Phase 4: Module-specific fixes (SLB only) ===== */\n' +
          '/* Topbar: orange bar + remove button boxes */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .topbar{\n' +
          '  background:var(--slb-ty-orange) !important;\n' +
          '  border-color:rgba(0,0,0,0) !important;\n' +
          '  box-shadow:0 10px 24px rgba(0,0,0,.35) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .topbar .nowTabText{ color:#fff !important; }\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .topbar .iconBtn{ color:rgba(255,255,255,.92) !important; }\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .topbar .iconBtn:hover{ color:#fff !important; }\n' +
          '/* Theme toggle button (topbar) */\n' +
          ':is(#SaamLawBank,#tyWealthCourtyard) #slbThemeToggleBtn{\n' +
          '  width:30px; height:30px;\n' +
          '  border-radius:999px;\n' +
          '  border:none;\n' +
          '  background:transparent;\n' +
          '  display:inline-flex; align-items:center; justify-content:center;\n' +
          '}\n' +
          ':is(#SaamLawBank,#tyWealthCourtyard) #slbThemeToggleBtn:hover{ background:rgba(15,21,23,.06); }\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbThemeToggleBtn{\n' +
          '  border:none !important;\n' +
          '  background:transparent !important;\n' +
          '  color:#fff !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbThemeToggleBtn:hover{ background:rgba(255,255,255,.20) !important; }\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .topbar .btn{\n' +
          '  background:transparent !important;\n' +
          '  border-color:transparent !important;\n' +
          '  color:#fff !important;\n' +
          '  box-shadow:none !important;\n' +
          '}\n' +

          '\n' +
          '/* ---- Diary Write editor: keep original LIGHT toolbar + pickers (do NOT darken) ---- */\\n' +
          ':root[data-slb-theme="dark"] #slbDiaryWysToolbar{\\n' +
          '  /* lock local UI vars back to LIGHT so existing saamlawbank.css button styles stay normal */\\n' +
          '  --bg:#ffffff !important;\\n' +
          '  --card:#ffffff !important;\\n' +
          '  --soft:#f5f7f9 !important;\\n' +
          '  --text:#111418 !important;\\n' +
          '  --muted:#6b7680 !important;\\n' +
          '  --border:#e2e6ea !important;\\n' +
          '  --border2:rgba(15,21,23,.14) !important;\\n' +
          '  background:#f5f7f9 !important;\\n' +
          '  color:#111418 !important;\\n' +
          '  border:1px solid #e2e6ea !important;\\n' +
          '  border-radius:14px !important;\\n' +
          '  padding:8px !important;\\n' +
          '  color-scheme: light !important;\\n' +
          '}\\n' +
          ':root[data-slb-theme="dark"] #slbDiaryWysToolbar .btn{\\n' +
          '  background:var(--soft) !important;\\n' +
          '  color:var(--text) !important;\\n' +
          '  border-color:var(--border2) !important;\\n' +
          '  box-shadow:none !important;\\n' +
          '}\\n' +
          ':root[data-slb-theme="dark"] #slbDiaryWysToolbar .btn:hover{\\n' +
          '  background:#eef2f5 !important;\\n' +
          '  border-color:rgba(15,21,23,.18) !important;\\n' +
          '}\\n' +
          ':root[data-slb-theme="dark"] #slbDiaryWysToolbar .slbWysLabel{ color:var(--muted) !important; }\\n' +
          ':root[data-slb-theme="dark"] #slbDiaryWysToolbar select,\\n' +
          ':root[data-slb-theme="dark"] #slbDiaryWysToolbar input[type="color"],\\n' +
          ':root[data-slb-theme="dark"] #slbDiaryWysToolbar input.inp{\\n' +
          '  background:#ffffff !important;\\n' +
          '  color:#111418 !important;\\n' +
          '  border-color:#e2e6ea !important;\\n' +
          '}\\n' +
          ':root[data-slb-theme="dark"] #slbDiaryWysToolbar .slbEmojiPanel{\\n' +
          '  background:#ffffff !important;\\n' +
          '  color:#111418 !important;\\n' +
          '  border-color:#e2e6ea !important;\\n' +
          '  box-shadow:0 12px 24px rgba(0,0,0,.25) !important;\\n' +
          '}\\n' +
          ':root[data-slb-theme="dark"] #slbDiaryWysToolbar .slbEmojiItem{\\n' +
          '  background:#ffffff !important;\\n' +
          '  color:#111418 !important;\\n' +
          '  border:1px solid #e2e6ea !important;\\n' +
          '}\\n' +
          ':root[data-slb-theme="dark"] #slbDiaryWysToolbar .slbSwatch{\\n' +
          '  border:1px solid rgba(15,21,23,.14) !important;\\n' +
          '}\\n' +
          ':root[data-slb-theme="dark"] #slbDiaryBodyRich{\\n' +
          '  background:#ffffff !important;\\n' +
          '  color:#111418 !important;\\n' +
          '  border-color:#e2e6ea !important;\\n' +
          '  color-scheme: light !important;\\n' +
          '}\\n' +
          '' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .topbar .btn:hover{\n' +
          '  background:rgba(255,255,255,.14) !important;\n' +
          '  border-color:rgba(255,255,255,.18) !important;\n' +
          '}\n' +
          '\n' +
          '/* Overview: keep selected toggle orange */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbOvAnnivWrap .tyl-toggle-btn.btn.orange{\n' +
          '  background:var(--slb-ty-orange) !important;\n' +
          '  border-color:var(--slb-ty-orange) !important;\n' +
          '  color:#fff !important;\n' +
          '}\n' +
          '\n' +
          '/* Stickies: keep color swatches visible */\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbSwatch{ background:var(--c) !important; }\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbColorInput{ background:#fff !important; }\n' +
          '\n' +
          '/* Diary Read: remove white panels, use dark surfaces */\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbDiaryReadTitle{ color:var(--slb-text) !important; }\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbDiaryReadLeft{\n' +
          '  background:var(--card) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbDiaryReadRight{\n' +
          '  background:var(--soft) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbDiaryReadList .slbDiaryReadItem{ color:var(--slb-text) !important; }\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbDiaryReadBody{ color:var(--slb-text) !important; }\n' +
          '\n' +
          '/* ===== Phase 5: Regression sweep + shared component polish ===== */\n' +
          '/* Core borders used all over SLB */\n' +
          ':root[data-slb-theme="dark"]{ --ty-border:var(--slb-border) !important; --ty-border-2:rgba(255,255,255,.10); }\n' +
          '\n' +
          '/* Default SLB buttons in dark mode (avoid white boxes) */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .btn.soft:not(.slbWysToolbar .btn.soft):not(.slbStdEditor .btn.soft),\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .btn.grey:not(.slbWysToolbar .btn.grey):not(.slbStdEditor .btn.grey),\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .btn.gray:not(.slbWysToolbar .btn.gray):not(.slbStdEditor .btn.gray){\n' +
          '  background:var(--slb-control-bg,#223036) !important;\n' +
          '  border-color:var(--slb-control-border,#223036) !important;\n' +
          '  color:var(--slb-control-fg,#fff) !important;\n' +
          '  box-shadow:var(--slb-control-shadow,none) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .btn.primary{\n' +
          '  background:var(--slb-action-orange-bg,var(--ty-orange,#ef5e14)) !important;\n' +
          '  border-color:var(--slb-action-orange-border,var(--ty-orange,#ef5e14)) !important;\n' +
          '  color:#fff !important;\n' +
          '  box-shadow:var(--slb-action-orange-shadow,none) !important;\n' +
          '}\n' +
          '\n' +
          '/* Topbar: absolutely no pill/box even if other rules sneak in */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .topbar :is(a.btn,button.btn,.btn){\n' +
          '  background:transparent !important;\n' +
          '  border-color:transparent !important;\n' +
          '  box-shadow:none !important;\n' +
          '}\n' +
          '\n' +
          '/* Stickies / Board: remove hard-coded white blocks in dark mode */\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbBoardComposeBar{\n' +
          '  background:var(--card) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbBoardComposeBar:hover{ background:var(--ty-hover) !important; }\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbBoardPost{\n' +
          '  background:var(--soft) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbBoardMsg{\n' +
          '  background:var(--card) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '  color:var(--slb-text) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbSticky{\n' +
          '  background:var(--card) !important;\n' +
          '  border-color:var(--border2) !important;\n' +
          '  box-shadow:0 10px 22px rgba(0,0,0,.35) !important;\n' +
          '}\n' +
          '\n' +
          '/* Diary Read: borders + active item clarity */\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbDiaryReadLeft,\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbDiaryReadRight{ border-color:var(--border2) !important; }\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbDiaryReadList .slbDiaryReadItem{ color:var(--slb-text) !important; }\n' +
          ':root[data-slb-theme="dark"] #SaamLawBank .slbDiaryReadList .slbDiaryReadItem.active{\n' +
          '  outline:2px solid rgba(239,94,20,.45) !important;\n' +
          '  background:var(--ty-active) !important;\n' +
          '}\n' +
          '\n' +
          '/* QC overlay styles (only used when ?slbqc=1) */\n' +
          '#slbQcOverlay{ position:fixed; inset:0; z-index:999999; background:rgba(0,0,0,.55); display:none; }\n' +
          '#slbQcOverlay.on{ display:block; }\n' +
          '#slbQcOverlay .slbQcCard{ position:absolute; top:12px; right:12px; width:min(520px, calc(100vw - 24px)); max-height:calc(100vh - 24px); overflow:auto; border-radius:18px; border:1px solid rgba(255,255,255,.14); background:rgba(21,29,32,.92); color:#fff; box-shadow:0 18px 42px rgba(0,0,0,.55); padding:12px; }\n' +
          '#slbQcOverlay h3{ margin:2px 0 8px; font-size:14px; font-weight:950; letter-spacing:.2px; }\n' +
          '#slbQcOverlay .row{ display:flex; gap:8px; flex-wrap:wrap; margin:8px 0; }\n' +
          '#slbQcOverlay .mini{ font-size:12px; opacity:.9; }\n' +
          '#slbQcOverlay .tag{ font-size:12px; padding:2px 8px; border-radius:999px; border:1px solid rgba(255,255,255,.18); background:rgba(255,255,255,.08); }\n' +          '\n' +
          '/* ===== Std Editor v1: Dark mode editor styling (global) ===== */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(.slbStdEditor,[data-slbeditor="v1"]){\n' +
          '  background:var(--slb-panel) !important;\n' +
          '  color:var(--slb-text) !important;\n' +
          '  border-color:var(--slb-border) !important;\n' +
          '  color-scheme: dark;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(.slbStdEditor,[data-slbeditor="v1"]) .slbWysToolbar{\n' +
          '  background:var(--slb-panel-2) !important;\n' +
          '  border-color:var(--slb-border) !important;\n' +
          '  color:var(--slb-text) !important;\n' +
          '}\n' +
          '/* Toolbar buttons (exclude color pickers / swatches) */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(.slbWysToolbar,#slbDiaryWysToolbar) :is(button.btn.soft,.btn.soft):not(.slbWysColorBtn):not(.slbSwatch){\n' +
          '  background:var(--slb-btn-bg) !important;\n' +
          '  color:var(--slb-btn-text) !important;\n' +
          '  border-color:var(--slb-border) !important;\n' +
          '  box-shadow:none !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(.slbWysToolbar,#slbDiaryWysToolbar) :is(button.btn.soft,.btn.soft):not(.slbWysColorBtn):not(.slbSwatch):hover{\n' +
          '  filter:brightness(1.06);\n' +
          '}\n' +
          '/* Do NOT override color inputs and swatch buttons */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(.slbWysToolbar,#slbDiaryWysToolbar) :is(.slbSwatch,input.slbWysColorInput,input[type="color"],input.inp[data-wys-colorpicker],input.inp[data-wys-hlpicker]){\n' +
          '  color-scheme: light;\n' +
          '}\n' +
          '/* DCR panel editor: keep native color pickers visible */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbDcrWysToolbar input[type="color"]{\n' +
          '  background:#ffffff !important;\n' +
          '  border:1px solid rgba(0,0,0,.35) !important;\n' +
          '  box-shadow:none !important;\n' +
          '}\n' +
          '/* Library: action buttons + cancel/back should not be white-on-white */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbLibraryPanel :is(#slbLibCancelBtn,#slbLibBackBtn,#slbLibCopyLinkBtn,#slbLibEditBtn,#slbLibDeleteBtn,#slbLibUnpinBtn,#slbLibArchiveBtn){\n' +
          '  background:var(--slb-btn-bg) !important;\n' +
          '  color:var(--slb-btn-text) !important;\n' +
          '  border:1px solid var(--slb-border) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbLibraryPanel :is(#slbLibCancelBtn,#slbLibBackBtn,#slbLibCopyLinkBtn,#slbLibEditBtn,#slbLibDeleteBtn,#slbLibUnpinBtn,#slbLibArchiveBtn):hover{\n' +
          '  filter:brightness(1.08);\n' +
          '}\n' +
          '/* Library: post body area should be dark */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbLibraryPanel .slbRichPost{\n' +
          '  background:var(--slb-input-bg) !important;\n' +
          '  color:var(--slb-input-text) !important;\n' +
          '  border-color:var(--slb-border) !important;\n' +
          '}\n' +
          '/* Rich editor input area */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbRichWrap{\n' +
          '  background:var(--slb-panel) !important;\n' +
          '  border-color:var(--slb-border) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .richEditor{\n' +
          '  background:var(--slb-input-bg) !important;\n' +
          '  color:var(--slb-input-text) !important;\n' +
          '  border-color:var(--slb-border) !important;\n' +
          '  caret-color:var(--slb-input-text) !important;\n' +
          '}\n' +
          '/* Convert explicit black text to white in dark mode */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .richEditor [style*="color: rgb(0, 0, 0)"]{\n' +
          '  color:var(--slb-input-text) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .richEditor [style*="color:#000"],\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .richEditor [style*="color: #000"]{\n' +
          '  color:var(--slb-input-text) !important;\n' +
          '}\n' +
          '/* Word counter */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbWordCounter{\n' +
          '  background:var(--slb-panel-2) !important;\n' +
          '  color:var(--slb-text) !important;\n' +
          '  border:1px solid var(--slb-border) !important;\n' +
          '}\n' +
'/* Diary listing panels: ensure background is dark in dark mode (prevents light text on light panels) */\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbDiaryPanel.card{\n' +
          '  background:rgba(21,29,32,0.92) !important;\n' +
          '  border-color:rgba(255,255,255,0.10) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadLeft,\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadRight{\n' +
          '  background:rgba(21,29,32,0.85) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadList .slbDiaryReadItem{\n' +
          '  color:var(--slb-text) !important;\n' +
          '  border-color:rgba(255,255,255,0.08) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadList .slbDiaryReadItem:nth-child(odd){\n' +
          '  background:rgba(21,29,32,0.50) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadList .slbDiaryReadItem:nth-child(even){\n' +
          '  background:rgba(21,29,32,0.62) !important;\n' +
          '}\n' +
          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadList .slbDiaryReadItem:hover{\n' +
          '  background:rgba(27,37,41,0.66) !important;\n' +
          '}\n' +

          ':root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiaryReadList .slbDiaryReadItem.active{\n' +
          '  background:rgba(27,37,41,0.78) !important;\n' +
          '  border-color:rgba(239,94,20,0.35) !important;\n' +
          '}\n' +
'';
        var st = document.createElement('style');
        st.id = 'slbThemeComponents';
        st.type = 'text/css';
        st.appendChild(document.createTextNode(css));
        (document.head||document.documentElement).appendChild(st);
      }catch(_e){}
    }

    // Diary Write WYS toolbar: force original light toolbar look even in dark mode.
    function fixDiaryWysToolbar_(theme){
      try{
        // No JS forcing "light island" for the WYS toolbar in dark mode.
        // Styling is handled by CSS tokens + dark-mode component rules.
        var tb = document.getElementById('slbDiaryWysToolbar');
        if(!tb) return;
        tb.setAttribute('data-slb-wys-fix', (theme === 'dark') ? 'dark' : 'light');
      }catch(_e){}
    }

    function ensureDiaryWysObserver_(){
      try{
        if(window.__SLB_DIARY_WYS_OBS__) return;
        window.__SLB_DIARY_WYS_OBS__ = true;
        var mo = new MutationObserver(function(muts){
          try{
            for(var i=0;i<muts.length;i++){
              var a = muts[i].addedNodes;
              if(!a) continue;
              for(var j=0;j<a.length;j++){
                var n = a[j];
                if(!n || n.nodeType !== 1) continue;
                if(n.id === 'slbDiaryWysToolbar' || (n.querySelector && n.querySelector('#slbDiaryWysToolbar'))){
                  var cur = (window.SLBTheme && window.SLBTheme.get) ? window.SLBTheme.get() : (document.documentElement.getAttribute('data-slb-theme')||'light');
                  fixDiaryWysToolbar_(cur);
                  return;
                }
              }
            }
          }catch(_e){}
        });
        mo.observe(document.documentElement, { childList:true, subtree:true });
      }catch(_e){}
    }

    
    // Std Editor V1: keep color swatches (data-wcolor / data-wbg) using their original colors in dark mode.
    // Some dark-mode button rules use !important and can override inline styles; we re-assert with inline !important.
    function _parseInlineColor_(el){
      try{
        var s = _safeStr(el.getAttribute('style')||'');
        var m = s.match(/(?:^|;)\s*color\s*:\s*([^;]+)/i);
        return m ? _safeStr(m[1]).trim() : '';
      }catch(_e){ return ''; }
    }
    function _autoTextColorForBg_(hex){
      try{
        hex = _safeStr(hex||'').trim();
        if(!hex) return '';
        // support #rgb or #rrggbb
        var h = hex.replace('#','');
        if(h.length === 3){
          h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
        }
        if(h.length !== 6) return '';
        var r = parseInt(h.substr(0,2),16);
        var g = parseInt(h.substr(2,2),16);
        var b = parseInt(h.substr(4,2),16);
        // perceived luminance
        var yiq = ((r*299)+(g*587)+(b*114))/1000;
        return yiq >= 150 ? '#000' : '#fff';
      }catch(_e){ return ''; }
    }
    function fixStdEditorSwatches_(theme){
      try{
        if(theme !== 'dark') return;
        var tbs = document.querySelectorAll('.slbStdEditor[data-slbeditor="v1"] .slbWysToolbar');
        if(!tbs || !tbs.length) return;

        for(var i=0;i<tbs.length;i++){
          var tb = tbs[i];
          // Text color swatches
          var btns = tb.querySelectorAll('button.btn[data-wcolor]');
          for(var j=0;j<btns.length;j++){
            var b1 = btns[j];
            var bg1 = _safeStr(b1.getAttribute('data-wcolor')||'').trim();
            if(bg1) b1.style.setProperty('background', bg1, 'important');
            var tc1 = _parseInlineColor_(b1) || _autoTextColorForBg_(bg1);
            if(tc1) b1.style.setProperty('color', tc1, 'important');
          }
          // Highlight swatches
          var hls = tb.querySelectorAll('button.btn[data-wbg]');
          for(var k=0;k<hls.length;k++){
            var b2 = hls[k];
            var bg2 = _safeStr(b2.getAttribute('data-wbg')||'').trim();
            if(bg2) b2.style.setProperty('background', bg2, 'important');
            var tc2 = _parseInlineColor_(b2) || _autoTextColorForBg_(bg2);
            if(tc2) b2.style.setProperty('color', tc2, 'important');
          }
          // Color pickers should remain usable (avoid dark background overriding the native preview)
          var cps = tb.querySelectorAll('input[type=\"color\"]');
          for(var z=0;z<cps.length;z++){
            var inp = cps[z];
            inp.style.setProperty('background', '#ffffff', 'important');
            inp.style.setProperty('border-color', 'rgba(255,255,255,0.18)', 'important');
          }
        }
      }catch(_e){}
    }

    function ensureStdEditorSwatchObserver_(){
      try{
        if(window.__SLB_STD_WYS_SWATCH_OBS__) return;
        window.__SLB_STD_WYS_SWATCH_OBS__ = true;
        var mo = new MutationObserver(function(muts){
          try{
            var cur = (window.SLBTheme && window.SLBTheme.get) ? window.SLBTheme.get() : (document.documentElement.getAttribute('data-slb-theme')||'light');
            if(cur !== 'dark') return;
            for(var i=0;i<muts.length;i++){
              var a = muts[i].addedNodes;
              if(!a) continue;
              for(var j=0;j<a.length;j++){
                var n = a[j];
                if(!n || n.nodeType !== 1) continue;
                if((n.classList && n.classList.contains('slbStdEditor')) || (n.querySelector && n.querySelector('.slbStdEditor[data-slbeditor=\"v1\"]'))){
                  // Defer slightly to allow inner toolbar to render
                  setTimeout(function(){ try{ fixStdEditorSwatches_('dark'); }catch(_e2){} }, 0);
                  return;
                }
              }
            }
          }catch(_e){}
        });
        mo.observe(document.documentElement, { childList:true, subtree:true });
      }catch(_e){}
    }

function applyTheme_(t){
      try{
        ensureTokensStyle_();
        ensureComponentsStyle_();
        t = _normMaybe_(t) || 'light';
        document.documentElement.setAttribute('data-slb-theme', t);
        _save_(t);
        try{ ensureStdEditorSwatchObserver_(); }catch(_e3){}
        try{ setTimeout(function(){ fixStdEditorSwatches_(t); }, 0); }catch(_e4){}
        try{
          // Notify any UI (e.g. topbar toggle, QC overlay) that theme changed
          if(typeof CustomEvent === 'function'){
            window.dispatchEvent(new CustomEvent('slbthemechange', { detail:{ theme:t } }));
          }
        }catch(_e2){}
      }catch(_e){}
      return t;
    }

    // Decide initial theme
    var forcedRaw = _qs_('slbtheme');
    var forced = _normMaybe_(forcedRaw);
    var saved = _normMaybe_(_getSaved_());
    var initial = forced || saved || 'light';
    applyTheme_(initial);
    try{ ensureDiaryWysObserver_(); }catch(_e){}

    window.SLBTheme = window.SLBTheme || {};
    window.SLBTheme.get = function(){
      try{ return _normMaybe_(document.documentElement.getAttribute('data-slb-theme')||'') || 'light'; }catch(_e){ return 'light'; }
    };
    window.SLBTheme.set = function(t){ return applyTheme_(t); };
    window.SLBTheme.toggle = function(){
      var cur = window.SLBTheme.get();
      return applyTheme_(cur === 'dark' ? 'light' : 'dark');
    };

  // ============================================================
  // Phase 6: Real topbar toggle button (SLB-only)
  // - Button is rendered by saamlawbank-app.liquid: #slbThemeToggleBtn
  // - Wired here to window.SLBTheme.toggle(), persisted via applyTheme_()
  // ============================================================
  (function(){
    function onReady_(fn){
      if(document.readyState === 'complete' || document.readyState === 'interactive'){ setTimeout(fn, 0); return; }
      document.addEventListener('DOMContentLoaded', fn);
    }

    function _nextLabel_(cur){ return cur === 'dark' ? 'Light mode' : 'Dark mode'; }
    function _icon_(cur){ return cur === 'dark' ? '☀' : '☾'; }

    onReady_(function(){
      try{
        var btn = document.getElementById('slbThemeToggleBtn');
        if(!btn || btn.__slbThemeWired) return;
        btn.__slbThemeWired = true;

        function sync_(){
          try{
            var cur = (window.SLBTheme && window.SLBTheme.get) ? window.SLBTheme.get() : 'light';
            btn.textContent = _icon_(cur);
            var next = _nextLabel_(cur);
            btn.title = next;
            btn.setAttribute('aria-label', 'Toggle ' + next);
          }catch(_e){}
        }

        btn.addEventListener('click', function(e){
          try{ e.preventDefault(); e.stopPropagation(); }catch(_e){}
          try{ if(window.SLBTheme && window.SLBTheme.toggle){ window.SLBTheme.toggle(); } }catch(_e){}
          sync_();
        });

        // Update if theme changed elsewhere (QC overlay, URL, etc.)
        try{ window.addEventListener('slbthemechange', sync_); }catch(_e){}

        sync_();
      }catch(_e){}
    });
  })();

  // ============================================================

  // ============================================================
  // Phase 6b: Immersive (hero show/hide) button hardening
  // - Ensures the Immersive button beside Log out keeps working
  // - Raises status strip above sticky topbar to avoid overlap
  // ============================================================
  (function(){
    function onReady_(fn){
      if(document.readyState === 'complete' || document.readyState === 'interactive'){ setTimeout(fn, 0); return; }
      document.addEventListener('DOMContentLoaded', fn);
    }

    onReady_(function(){
      // CSS: keep status strip clickable even when topbar is sticky
      try{
        if(!document.getElementById('slbImmersivePatch')){
          var st = document.createElement('style');
          st.id = 'slbImmersivePatch';
          st.type = 'text/css';
          st.appendChild(document.createTextNode(
            ':is(#SaamLawBank,#tyWealthCourtyard) .statusStrip{position:relative;z-index:200;pointer-events:auto;}'+
            ':is(#SaamLawBank,#tyWealthCourtyard) .statusActions{position:relative;z-index:201;pointer-events:auto;}'+
            ':is(#SaamLawBank,#tyWealthCourtyard) #slbImmersiveIcon{position:relative;z-index:205;pointer-events:auto;}'+
            'html.slbImmersive .slbHeroRow, body.slbImmersive .slbHeroRow, #SaamLawBank.slbImmersive .slbHeroRow, #tyWealthCourtyard.slbImmersive .slbHeroRow{display:none !important;}html.slbFastBoot:not(.slbImmersive) #SaamLawBank .slbHeroRow{display:flex !important;}html.slbFastBoot:not(.slbImmersive) #tyWealthCourtyard .slbHeroRow{display:flex !important;}'
          ));
(document.head||document.documentElement).appendChild(st);
        }
      }catch(_e){}

      function applySaved_(){
        try{
          var want = false;
          try{ want = localStorage.getItem('slbImmersive') === '1'; }catch(_e){}
          var root = document.getElementById('SaamLawBank') || document.getElementById('tyWealthCourtyard');

          var app = document.getElementById('tywApp');
          function isLoggedIn_(){ return !!(app && !app.classList.contains('hidden')); }

          // Only hide hero when logged in (so boot/login UI isn't blank)
          var eff = !!(want && isLoggedIn_());

          try{ document.documentElement.classList.toggle('slbImmersive', eff); }catch(_e){}
          try{ if(document.body) document.body.classList.toggle('slbImmersive', eff); }catch(_e){}
          try{ if(root) root.classList.toggle('slbImmersive', eff); }catch(_e){}

          // Hard-override hero display so FastBoot's inline CSS can't permanently hide it
          var hero = null, foot = null;
          try{ hero = (root && root.querySelector) ? (root.querySelector('.slbHeroRow') || document.querySelector('.slbHeroRow')) : document.querySelector('.slbHeroRow'); }catch(_e){}
          try{ foot = (root && root.querySelector) ? (root.querySelector('.backendFoot') || document.querySelector('.backendFoot')) : document.querySelector('.backendFoot'); }catch(_e){}
          try{ if(hero) hero.style.setProperty('display', eff ? 'none' : 'flex', 'important'); }catch(_e){}
          try{ if(foot) foot.style.setProperty('display', eff ? 'none' : '', 'important'); }catch(_e){}

          var btn = document.getElementById('slbImmersiveIcon');
          if(btn){
            try{ btn.setAttribute('aria-pressed', want ? 'true' : 'false'); }catch(_e){}
            try{ btn.title = want ? 'Exit immersive mode' : 'Immersive mode'; }catch(_e){}
            try{ btn.textContent = want ? '🗗' : '⛶'; }catch(_e){}
          }
        }catch(_e){}
      }

      // Single source of truth: define toggleImmersive so other bundles won't double-bind.
      try{
        window.SLB = window.SLB || {};
        if(typeof window.SLB.toggleImmersive !== 'function'){
          window.SLB.toggleImmersive = function(force){
            var cur = false;
            try{ cur = localStorage.getItem('slbImmersive') === '1'; }catch(_e){}
            var want = (typeof force === 'boolean') ? force : !cur;
            try{ localStorage.setItem('slbImmersive', want ? '1' : '0'); }catch(_e){}
            try{ applySaved_(); }catch(_e){}
            return want;
          };
        }
      }catch(_e){}

      applySaved_();

      // JS: wire the Immersive button even if inline onclick is blocked
      try{
        var btn = document.getElementById('slbImmersiveIcon');
        if(!btn || btn.__slbImmersiveWired) return;
        btn.__slbImmersiveWired = true;

        btn.addEventListener('click', function(e){
          try{ e.preventDefault(); }catch(_e){}
          try{
            if(window.SLB && typeof window.SLB.toggleImmersive === "function"){
              window.SLB.toggleImmersive();
              return;
            }
          }catch(_e){}

          // Fallback (minimal)
          try{
            window.SLB = window.SLB || {};
            var cur = false;
            try{ cur = localStorage.getItem('slbImmersive') === '1'; }catch(_e2){}
            var on = !cur;
            try{ localStorage.setItem('slbImmersive', on ? '1' : '0'); }catch(_e2){}

            var r = document.getElementById('SaamLawBank') || document.getElementById('tyWealthCourtyard') || document.body;
            var hero = null, foot = null;
            try{ hero = (r && r.querySelector) ? (r.querySelector('.slbHeroRow') || document.querySelector('.slbHeroRow')) : document.querySelector('.slbHeroRow'); }catch(_e3){}
            try{ foot = (r && r.querySelector) ? (r.querySelector('.backendFoot') || document.querySelector('.backendFoot')) : document.querySelector('.backendFoot'); }catch(_e3){}

            try{ if(r && r.classList) r.classList.toggle('slbImmersive', on); }catch(_e3){}
            try{ document.documentElement.classList.toggle('slbImmersive', on); }catch(_e3){}
            try{ if(document.body) document.body.classList.toggle('slbImmersive', on); }catch(_e3){}
            try{ if(hero) hero.style.display = on ? 'none' : ''; }catch(_e3){}
            try{ if(foot) foot.style.display = on ? 'none' : ''; }catch(_e3){}
          }catch(_e){}
        });
      }catch(_e){}
    });
  })();

  // Phase 5: Dark Mode QC Overlay (SLB only)
  // - Enable via: ?slbqc=1
  // - Shows a small panel to toggle theme + confirm key tokens.
  // ============================================================
  (function(){
    function _qsHas_(k){
      try{
        var s = _safeStr(location.search||'');
        return s.indexOf(k+'=1') >= 0;
      }catch(_e){ return false; }
    }
    if(!_qsHas_('slbqc')) return;

    function onReady_(fn){
      if(document.readyState === 'complete' || document.readyState === 'interactive'){ setTimeout(fn, 0); return; }
      document.addEventListener('DOMContentLoaded', fn);
    }

    onReady_(function(){
      try{
        if(document.getElementById('slbQcOverlay')) return;

        var ov = document.createElement('div');
        ov.id = 'slbQcOverlay';
        ov.className = 'on';

        var card = document.createElement('div');
        card.className = 'slbQcCard';

        function mkBtn_(label, onClick, cls){
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'btn ' + (cls||'');
          b.textContent = label;
          b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); try{ onClick(); }catch(_e){} });
          return b;
        }

        var h = document.createElement('h3');
        h.textContent = 'SLB Dark Mode QC';
        card.appendChild(h);

        var meta = document.createElement('div');
        meta.className = 'row mini';
        var t1 = document.createElement('span'); t1.className = 'tag'; t1.textContent = 'theme: ' + (window.SLBTheme ? window.SLBTheme.get() : 'n/a');
        var t2 = document.createElement('span'); t2.className = 'tag'; t2.textContent = 'path: ' + _safeStr(location.pathname||'');
        meta.appendChild(t1); meta.appendChild(t2);
        card.appendChild(meta);

        var row1 = document.createElement('div');
        row1.className = 'row';
        row1.appendChild(mkBtn_('Toggle theme', function(){
          if(window.SLBTheme){ window.SLBTheme.toggle(); }
          t1.textContent = 'theme: ' + (window.SLBTheme ? window.SLBTheme.get() : 'n/a');
        }, 'orange'));
        row1.appendChild(mkBtn_('Force dark', function(){ if(window.SLBTheme){ window.SLBTheme.set('dark'); } t1.textContent = 'theme: dark'; }, 'black'));
        row1.appendChild(mkBtn_('Force light', function(){ if(window.SLBTheme){ window.SLBTheme.set('light'); } t1.textContent = 'theme: light'; }, 'grey'));
        row1.appendChild(mkBtn_('Close', function(){ ov.className=''; ov.parentNode && ov.parentNode.removeChild(ov); }, 'danger'));
        card.appendChild(row1);

        var tokens = document.createElement('div');
        tokens.className = 'mini';
        function val_(k){
          try{ return getComputedStyle(document.documentElement).getPropertyValue(k).trim(); }catch(_e){ return ''; }
        }
        tokens.innerHTML =
          '<div class="row">' +
          '<span class="tag">--slb-bg: '+ val_('--slb-bg') +'</span>' +
          '<span class="tag">--slb-panel: '+ val_('--slb-panel') +'</span>' +
          '<span class="tag">--slb-text: '+ val_('--slb-text') +'</span>' +
          '<span class="tag">--slb-ty-orange: '+ val_('--slb-ty-orange') +'</span>' +
          '</div>';
        card.appendChild(tokens);

        ov.appendChild(card);
        ov.addEventListener('click', function(){ ov.className=''; ov.parentNode && ov.parentNode.removeChild(ov); });

        document.body.appendChild(ov);
      }catch(_e){}
    });
  })();

  })();

  function dbgOn_(){
    try{
      var s = _safeStr(location.search||'');
      var s0 = _safeStr(window.__TY_NAV_SEARCH0||'');
      if(s0 && s.indexOf(s0) < 0) s += '&' + s0;
      if(s.indexOf('slbdebug=1') >= 0) return true;
    }catch(_e){}
    try{
      return (_safeStr(localStorage.getItem('SLB_DEBUG')||'') === '1');
    }catch(_e2){}
    return false;
  }

  function dlog_(){
    if(!dbgOn_()) return;
    try{ console.info.apply(console, arguments); }catch(_e){}
  }

  // ---------- Report bundle (Phase 4) ----------
  function getBuildTag_(){
    try{ return _safeStr(window.__SLB_BUILD_TAG__ || window.__SLB_BUILD_TAG || window.__SLB_BUILD_TAG__ || ''); }catch(_e){}
    return '';
  }
  function toErrObj_(err){
    try{
      if(!err) return null;
      var o = {};
      try{ o.name = _safeStr(err.name || ''); }catch(_e){}
      try{ o.message = _safeStr(err.message || err); }catch(_e2){ o.message = _safeStr(err); }
      try{ o.stack = _safeStr(err.stack || ''); }catch(_e3){}
      return o;
    }catch(_e4){ return null; }
  }
  function takeLogs_(n){
    try{
      n = n || 50;
      if(window.SLB && SLB.log && typeof SLB.log.dump === 'function'){
        var arr = SLB.log.dump() || [];
        if(arr && arr.length > n) arr = arr.slice(arr.length - n);
        return arr || [];
      }
    }catch(_e){}
    return [];
  }
  function buildReportBundle_(extra){
    var out = {};
    try{
      out.v = 1;
      out.ts = (new Date()).toISOString();
      out.build = getBuildTag_();
      out.page = _safeStr(location.href || '');
      out.ua = _safeStr(navigator.userAgent || '');
      out.online = (navigator.onLine !== false);
      out.lastError = _safeStr(window.__slbLastErrorText || '');
      out.lastErrorObj = window.__slbLastErrorObj || null;
      out.extra = extra || null;
      out.logs = takeLogs_(50);
    }catch(_e){}
    return out;
  }
  function copyText_(txt){
    try{
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(txt);
        return true;
      }
    }catch(_e){}
    try{
      var ta = document.createElement('textarea');
      ta.value = txt;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      ta.style.top = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      return true;
    }catch(_e2){}
    return false;
  }
  function copyReportBundle_(extra){
    try{
      var bundle = buildReportBundle_(extra);
      var txt = "SLB_REPORT_BUNDLE v1\n" + JSON.stringify(bundle, null, 2);
      return copyText_(txt);
    }catch(_e){ return false; }
  }
  window.SLB_REPORT = window.SLB_REPORT || {};
  window.SLB_REPORT.bundle = buildReportBundle_;
  window.SLB_REPORT.copy = copyReportBundle_;

  // ---------- UI helpers ----------
  function el_(tag, cls, text){
    var e = document.createElement(tag);
    if(cls) e.className = cls;
    if(text != null) e.textContent = text;
    return e;
  }

  function onceReady_(fn){
    if(document.readyState === 'complete' || document.readyState === 'interactive'){
      try{ fn(); }catch(_e){}
      return;
    }
    document.addEventListener('DOMContentLoaded', function(){ try{ fn(); }catch(_e){} }, {once:true});
  }

  // ---------- Offline banner ----------
  var banner;
  function ensureBanner_(){
    if(banner) return banner;
    banner = el_('div', 'slbNetBanner');
    banner.id = 'slbNetBanner';
    var dot = el_('div', 'dot');
    var wrap = el_('div', 'wrap');
    var msg = el_('div', 'msg', 'Network issue');
    var sub = el_('div', 'sub', 'You are offline. Some features may fail.');
    wrap.appendChild(msg);
    wrap.appendChild(sub);

    var btnRetry = el_('button', 'btn primary', 'Retry');
    btnRetry.type = 'button';
    btnRetry.addEventListener('click', function(){
      try{ flushRetryQueue_(); }catch(_e){}
    });

    // Lightweight banner should not push users to reload during background sync.
    // Full reload stays available in the blocking retry modal/debug tools only.
    var btnReload = el_('button', 'btn', 'Hide');
    btnReload.type = 'button';
    btnReload.title = 'Hide this background-sync message';
    btnReload.addEventListener('click', function(){ try{ setBanner_(false); }catch(_e){} });

    banner.appendChild(dot);
    banner.appendChild(wrap);
    banner.appendChild(btnRetry);
    banner.appendChild(btnReload);

    (document.body || document.documentElement).appendChild(banner);
    return banner;
  }

  function setBanner_(show, subtitle){
    try{
      var b = ensureBanner_();
      if(show){
        var sub = b.querySelector('.sub');
        if(sub && subtitle) sub.textContent = subtitle;
        var msg = b.querySelector('.msg');
        if(msg) msg.textContent = (navigator.onLine === false) ? 'Network issue' : 'Background sync';
        b.style.display = 'flex';
      }else{
        b.style.display = 'none';
      }
    }catch(_e){}
  }

  function updateOnlineBanner_(){
    try{
      if(navigator.onLine === false){
        setBanner_(true, 'You are offline. Some features may fail.');
      }else{
        setBanner_(false);
      }
    }catch(_e){}
  }

  // ---------- Retry modal (queue-based) ----------
  var retryOverlay, retryCard, retryMsg, retryDetails, retryBtn, cancelBtn, reloadBtn, reportBtn;
  var retryQueue = [];
  var retryActive = false;
  var lastNetErrAt = 0;
  var autoRetryTimer = null;
  var autoRetryMs = 800;
  var netBannerSeq = 0; // prevents stale delayed banner from reappearing after recovery

  function ensureRetryModal_(){
    if(retryOverlay) return;
    retryOverlay = el_('div', 'slbNetRetryOverlay');
    retryOverlay.id = 'slbNetRetryOverlay';

    retryCard = el_('div', 'card');
    var title = el_('div', 'title', 'Network error');
    retryMsg = el_('div', 'msg', 'Request failed. Try again?');
    retryDetails = el_('div', 'details');
    retryDetails.style.display = 'none';

    var row = el_('div', 'btnRow');
    retryBtn = el_('button', 'btn primary', 'Retry');
    retryBtn.type = 'button';
    cancelBtn = el_('button', 'btn', 'Cancel');
    cancelBtn.type = 'button';
    reloadBtn = el_('button', 'btn', 'Reload');
    reloadBtn.type = 'button';
    reportBtn = el_('button', 'btn', 'Report');
    reportBtn.type = 'button';

    retryBtn.addEventListener('click', function(){ flushRetryQueue_(); });
    cancelBtn.addEventListener('click', function(){ cancelRetryQueue_(); });
    reloadBtn.addEventListener('click', function(){ try{ location.reload(); }catch(_e){} });
    reportBtn.addEventListener('click', function(){ try{ copyReportBundle_({source:'net-retry'}); }catch(_e){} });

    row.appendChild(retryBtn);
    row.appendChild(cancelBtn);
    row.appendChild(reloadBtn);
    row.appendChild(reportBtn);

    retryCard.appendChild(title);
    retryCard.appendChild(retryMsg);
    retryCard.appendChild(retryDetails);
    retryCard.appendChild(row);

    retryOverlay.appendChild(retryCard);
    (document.body || document.documentElement).appendChild(retryOverlay);
  }

  function openRetryModal_(err){
    ensureRetryModal_();
    try{
      var now = Date.now();
      lastNetErrAt = now;
      try{ window.__slbLastNetErrorObj = toErrObj_(err); }catch(_e){}

      var txt = 'Request failed. Try again?';
      if(navigator.onLine === false) txt = 'You are offline. Try again when the network is back.';
      if(retryMsg) retryMsg.textContent = txt;

      if(retryDetails){
        if(dbgOn_()){
          retryDetails.style.display = 'block';
          retryDetails.textContent = formatErr_(err);
        }else{
          retryDetails.style.display = 'none';
          retryDetails.textContent = '';
        }
      }
      retryOverlay.style.display = 'flex';
      retryActive = true;
    }catch(_e){}
  }

  function closeRetryModal_(){
    try{
      if(retryOverlay) retryOverlay.style.display = 'none';
    }catch(_e){}
    retryActive = false;
  }

  function markNetHealthy_(meta){
    try{ netBannerSeq++; }catch(_eSeq){}
    try{
      if(autoRetryTimer){
        clearTimeout(autoRetryTimer);
        autoRetryTimer = null;
      }
    }catch(_e){}
    try{ autoRetryMs = 800; }catch(_e){}
    try{
      if(window.__slbNetRetryState){
        window.__slbNetRetryState.firstAt = 0;
        window.__slbNetRetryState.count = 0;
      }
    }catch(_e){}
    try{ window.__SLB_GUARD_BANNER_FIRST_MS = 0; }catch(_e){}
    try{ closeRetryModal_(); }catch(_e){}
    try{ retryQueue.length = 0; }catch(_e){}
    try{
      if(navigator.onLine === false){
        setBanner_(true, 'You are offline. Some features may fail.');
      }else{
        setBanner_(false);
      }
    }catch(_e){}
    try{
      window.__SLB_NET_LAST_OK__ = {
        at: Date.now(),
        meta: meta || null
      };
    }catch(_e){}
  }

  try{
    window.__SLB_NET_MARK_HEALTHY__ = markNetHealthy_;
  }catch(_e){}

  function enqueueRetry_(attemptFn, resolve, reject, err){
    retryQueue.push({ attempt: attemptFn, resolve: resolve, reject: reject, err: err });

    var p = _safeStr(location.pathname||'').toLowerCase();
    var isChat = (p === '/pages/chat' || p.indexOf('/pages/chat') === 0) || (p.indexOf('/pages/saam-law-bank') === 0 && (String(location.hash||'').toLowerCase().indexOf('tab=chat')>=0 || String(location.hash||'').toLowerCase().indexOf('#chat')>=0 || (String(location.hash||'').toLowerCase().indexOf('tab=mycabin')>=0 && String(location.hash||'').toLowerCase().indexOf('cabin=chat')>=0) || !!window.__SLB_CHAT_BUILD_TAG__ || !!window.__SLB_CHAT_BOOTED__));

    // Lightweight banner: only show if the retry queue is still failing after a few seconds.
    // This stops background Apps Script hiccups from flashing a Reload/Retry bar while the page is usable.
    var _msg0 = (navigator.onLine === false ? 'You are offline. Some features may fail.' : 'Background sync is reconnecting…');
    try{
      var bannerSeq = ++netBannerSeq;
      var now = Date.now();
      if(!window.__SLB_GUARD_BANNER_FIRST_MS) window.__SLB_GUARD_BANNER_FIRST_MS = now;
      setTimeout(function(){
        try{
          if(bannerSeq !== netBannerSeq) return;
          if(!retryQueue || retryQueue.length === 0) return;
          if(navigator.onLine !== false){
            var lastOk = (window.__SLB_NET_LAST_OK__ && Number(window.__SLB_NET_LAST_OK__.at || 0)) || 0;
            if(lastOk && lastOk >= now) return;
          }
          setBanner_(true, _msg0);
        }catch(_eLater){}
      }, (navigator.onLine === false ? 1200 : 5000));
    }catch(_e){
      try{ if(navigator.onLine === false) setBanner_(true, _msg0); }catch(_e2){}
    }

    // Auto-retry (silent). Modal only if offline or repeated failures for a while.
    try{
      if(autoRetryTimer) clearTimeout(autoRetryTimer);

      // Global retry state (shared across pages)
      if(!window.__slbNetRetryState) window.__slbNetRetryState = { firstAt: 0, count: 0 };
      var st = window.__slbNetRetryState;
      var now = Date.now();
      if(!st.firstAt) st.firstAt = now;
      st.count = (st.count||0) + 1;

      // Always schedule a background flush
      autoRetryTimer = setTimeout(function(){
        try{ flushRetryQueue_(); }catch(_e){}
      }, autoRetryMs);

      // gentle backoff (cap)
      autoRetryMs = Math.min(8000, Math.floor(autoRetryMs * 1.6));

      // Decide whether to show the blocking modal
      // - Chat: almost never show (unless truly offline for a bit)
      // - Other pages: show only after prolonged failures
      var age = now - (st.firstAt||now);
      var shouldModal = false;

      if(navigator.onLine === false){
        // offline: allow modal after a brief moment
        shouldModal = (age > 3000 && st.count >= 2);
      }else{
        // online but failing: keep it non-blocking much longer; Apps Script often recovers by itself.
        shouldModal = (age > 30000 || st.count >= 8);
      }

      if(isChat){
        // Keep chat UX non-blocking
        if(navigator.onLine === false && shouldModal){
          if(!retryActive) openRetryModal_(err);
        }
      }else{
        if(shouldModal){
          if(!retryActive) openRetryModal_(err);
        }
      }
      return;
    }catch(_e){}
  }


  function flushRetryQueue_(){
    ensureRetryModal_();
    if(retryQueue.length === 0){
      closeRetryModal_();
      updateOnlineBanner_();
      try{ autoRetryMs = 800; }catch(_e){}
      try{
        if(window.__slbNetRetryState){
          window.__slbNetRetryState.firstAt = 0;
          window.__slbNetRetryState.count = 0;
        }
      }catch(_e2){}
      return;
    }
    if(navigator.onLine === false){
      openRetryModal_(retryQueue[0].err);
      return;
    }

    var batch = retryQueue.slice(0);
    retryQueue.length = 0;

    // Execute all attempts in parallel (but each is its own promise)
    closeRetryModal_();

    Promise.resolve().then(function(){
      return Promise.all(batch.map(function(item){
        return Promise.resolve().then(item.attempt).then(function(res){
          try{ item.resolve(res); }catch(_e){}
          return true;
        }).catch(function(e){
          if(isNetworkError_(e)){
            // re-queue
            enqueueRetry_(item.attempt, item.resolve, item.reject, e);
          }else{
            try{ item.reject(e); }catch(_e2){}
          }
          return false;
        });
      }));
    }).then(function(){
      // hide banner if queue empty
      if(retryQueue.length === 0){ updateOnlineBanner_(); try{ autoRetryMs = 800; }catch(_e){} }
    });
  }

  function cancelRetryQueue_(){
    var batch = retryQueue.slice(0);
    retryQueue.length = 0;
    closeRetryModal_();
    updateOnlineBanner_();
    batch.forEach(function(item){
      try{ item.reject(item.err || new Error('Cancelled')); }catch(_e){}
    });
  }

  // ---------- Error formatting / detection ----------
  function formatErr_(err){
    try{
      if(!err) return 'Unknown error';
      var msg = err && err.message ? _safeStr(err.message) : _safeStr(err);
      var st = '';
      if(err && err.stack) st = _safeStr(err.stack);
      if(st && st.indexOf(msg) < 0) return msg + '\n' + st;
      return st || msg;
    }catch(_e){ return 'Error'; }
  }

  function isNetworkError_(err){
    try{
      if(!err) return false;
      // Our JSONP wrapper uses "Network error." string
      var m = _safeStr(err.message || err);
      m = m.toLowerCase();
      if(m.indexOf('network error') >= 0) return true;
      if(m.indexOf('failed to fetch') >= 0) return true;
      if(m.indexOf('load failed') >= 0) return true;
      if(m.indexOf('fetch') >= 0 && m.indexOf('typeerror') >= 0) return true;
      if(m.indexOf('timeout') >= 0) return true;
      return false;
    }catch(_e){ return false; }
  }

  // Diary Inbox callsign opening intentionally starts several cache/UI/backend
  // operations together. A contained rejection during that short transaction must
  // not be presented as a whole-page failure when the diary list is still usable.
  function isHandledDiaryInboxError_(kind, err, extra){
    try{
      if(err && err.__slbDiaryInboxHandled) return true;
      var st = window.__slbDiaryInboxTransientOpen;
      if(!st || !st.until || Date.now() > Number(st.until)) return false;

      var root = document.getElementById('slbDiaryInbox');
      if(!root) return false;
      var panel = document.getElementById('slbDiaryInboxPanel');
      if(panel && panel.classList && panel.classList.contains('hidden')) return false;

      var item = {
        at: new Date().toISOString(),
        kind: String(kind||'error'),
        callsign: String(st.callsign||''),
        phase: String(st.phase||''),
        message: formatErr_(err),
        extra: extra ? _safeStr(extra) : ''
      };
      if(!window.__slbDiaryInboxSuppressedErrors) window.__slbDiaryInboxSuppressedErrors = [];
      window.__slbDiaryInboxSuppressedErrors.push(item);
      if(window.__slbDiaryInboxSuppressedErrors.length > 20){
        window.__slbDiaryInboxSuppressedErrors.splice(0, window.__slbDiaryInboxSuppressedErrors.length - 20);
      }
      if(dbgOn_()) dlog_('Diary Inbox contained error:', item);
      return true;
    }catch(_e){ return false; }
  }

  // ---------- Global error guard ----------
  var lastToastAt = 0;
  var toastEl;

  function ensureToast_(){
    if(toastEl) return toastEl;
    toastEl = el_('div', 'slbErrToast');
    toastEl.id = 'slbErrToast';

    var t = el_('div', 't', 'Something went wrong');
    var actions = el_('div', 'actions');
    var btnReport = el_('button', 'btn', 'Report');
    btnReport.type = 'button';
    btnReport.addEventListener('click', function(){ try{ copyReportBundle_({source:'toast'}); }catch(_e){} });
    var btnReload = el_('button', 'btn primary', 'Reload');
    btnReload.type = 'button';
    btnReload.addEventListener('click', function(){ try{ location.reload(); }catch(_e){} });

    var btnCopy = el_('button', 'btn', 'Copy');
    btnCopy.type = 'button';
    btnCopy.style.display = 'none';

    btnCopy.addEventListener('click', function(){
      try{
        var txt = _safeStr(window.__slbLastErrorText || '');
        if(!txt) return;
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(txt);
        }else{
          var ta = el_('textarea');
          ta.value = txt;
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
      }catch(_e){}
    });

    actions.appendChild(btnReport);
    actions.appendChild(btnReload);
    actions.appendChild(btnCopy);

    toastEl.appendChild(t);
    toastEl.appendChild(actions);

    (document.body || document.documentElement).appendChild(toastEl);
    return toastEl;
  }

  function showErrorToast_(errText, errObj){
    try{
      var now = Date.now();
      if(now - lastToastAt < 1500) return;
      lastToastAt = now;
      window.__slbLastErrorText = errText;
      try{ window.__slbLastErrorObj = toErrObj_(errObj); }catch(_e){}

      var e = ensureToast_();
      var copyBtn = e.querySelector('.actions .btn:not(.primary)');
      if(copyBtn){
        copyBtn.style.display = dbgOn_() ? 'inline-flex' : 'none';
      }
      e.style.display = 'flex';
      setTimeout(function(){ try{ e.style.display = 'none'; }catch(_e){} }, 7000);
    }catch(_e){}
  }

  function rememberSuppressedGlobalErr_(kind, err, extra, reason){
    try{
      var item = {
        at: new Date().toISOString(),
        kind: String(kind||'error'),
        reason: String(reason||'background/non-critical'),
        message: formatErr_(err),
        extra: extra ? _safeStr(extra) : ''
      };
      if(!window.__slbSuppressedGlobalErrors) window.__slbSuppressedGlobalErrors = [];
      window.__slbSuppressedGlobalErrors.push(item);
      if(window.__slbSuppressedGlobalErrors.length > 30){
        window.__slbSuppressedGlobalErrors.splice(0, window.__slbSuppressedGlobalErrors.length - 30);
      }
      if(dbgOn_()) dlog_('SLB suppressed non-fatal error:', item);
      try{ rememberGlobalGuardEvent_('suppressed', kind, err, extra, reason); }catch(_eDiag){}
    }catch(_e){}
  }


  // Keep a tiny session diagnostic ring so a future one-off false bar can be
  // identified without changing production UI or requiring persistent logging.
  function rememberGlobalGuardEvent_(status, kind, err, extra, reason){
    try{
      var item = {
        at: new Date().toISOString(),
        status: String(status||'seen'),
        kind: String(kind||'error'),
        reason: String(reason||''),
        message: formatErr_(err),
        extra: extra ? _safeStr(extra) : ''
      };
      if(!window.__slbGlobalGuardEvents) window.__slbGlobalGuardEvents = [];
      window.__slbGlobalGuardEvents.push(item);
      if(window.__slbGlobalGuardEvents.length > 25){
        window.__slbGlobalGuardEvents.splice(0, window.__slbGlobalGuardEvents.length - 25);
      }
      try{ sessionStorage.setItem('slb_global_guard_events_v32318', JSON.stringify(window.__slbGlobalGuardEvents)); }catch(_eStore){}
    }catch(_e){}
  }

  try{
    if(!window.__slbGlobalGuardEvents){
      var _oldGuardEvents = null;
      try{ _oldGuardEvents = JSON.parse(sessionStorage.getItem('slb_global_guard_events_v32318')||'null'); }catch(_eOld){}
      window.__slbGlobalGuardEvents = Array.isArray(_oldGuardEvents) ? _oldGuardEvents.slice(-25) : [];
    }
    window.SLB_ERROR_GUARD_DIAG = function(){ return (window.__slbGlobalGuardEvents||[]).slice(); };
  }catch(_eDiag){}

  // Browsers can report ResizeObserver delivery-limit notices as window errors even
  // though the page remains healthy. They are scheduling diagnostics, not a reason
  // to tell a disciple to reload SLB. Keep them in the debug ring instead.
  function isBenignBrowserRuntimeError_(err){
    try{
      var m = _safeStr((err && err.message) ? err.message : err).toLowerCase();
      return (
        m.indexOf('resizeobserver loop limit exceeded') >= 0 ||
        m.indexOf('resizeobserver loop completed with undelivered notifications') >= 0
      );
    }catch(_e){ return false; }
  }

  function handleGlobalErr_(kind, err, extra){
    try{
      if(isHandledDiaryInboxError_(kind, err, extra)) return;
      if(isBenignBrowserRuntimeError_(err)){
        rememberSuppressedGlobalErr_(kind, err, extra, 'resize-observer-delivery');
        return;
      }
      var txt = '[' + kind + '] ' + formatErr_(err);
      if(extra) txt += '\n' + _safeStr(extra);

      // Minimal user message; detailed only in debug
      rememberGlobalGuardEvent_('shown', kind, err, extra, 'global-toast');
      showErrorToast_(txt, err);
      if(dbgOn_()) dlog_('SLB Global Error:', txt);
    }catch(_e){}
  }

  function isRpcResourceError_(target){
    try{
      if(!target || target === window) return false;
      if(target.getAttribute && target.getAttribute('data-slb-rpc-script') === '1') return true;
      var src = String((target && (target.src || target.href)) || '');
      if(src && src.indexOf('script.google.com') >= 0 && src.indexOf('payload=') >= 0) return true;
      return false;
    }catch(_e){ return false; }
  }

  // Explicitly-marked resource loaders own their own failure/fallback state.
  // Examples include the Overview lunar-calendar CDN fallback. A failed first
  // CDN attempt can happen while My Altar is quietly syncing, but it is not an
  // altar or whole-SLB failure and the loader immediately tries its fallback.
  function isExplicitlyManagedResourceError_(target){
    try{
      if(!target || target === window || !target.getAttribute) return false;
      return !!target.getAttribute('data-slb-managed-resource');
    }catch(_e){ return false; }
  }

  // SLB's lazy loader owns its speculative prefetches and its dynamically inserted
  // script/style tags. Browser resource-error events fire in the capture phase before
  // the lazy loader's own onerror handler can remove/retry the element. Treating those
  // events as whole-app failures produces a brief global "Something went wrong" bar
  // even when the actual click immediately loads the module successfully. Keep the
  // failure in diagnostics and let the lazy loader's dedicated retry/inline UI own it.
  function isManagedLazyResourceError_(target){
    try{
      if(!target || target === window || !target.getAttribute) return false;
      if(target.getAttribute('data-slb-lazy-prefetch') === '1') return true;
      if(target.getAttribute('data-slb-lazy-url')) return true;
      var tag = String(target.tagName || '').toLowerCase();
      if(tag === 'link'){
        var rel = String(target.getAttribute('rel') || '').toLowerCase();
        if((rel === 'prefetch' || rel === 'preload' || rel === 'modulepreload') && target.getAttribute('data-slb-lazy-prefetch')) return true;
      }
      return false;
    }catch(_e){ return false; }
  }

  // Secure POST/read transport owns its hidden iframe failures. A browser or
  // privacy tool can fire an iframe resource-error event in capture phase before
  // the transport's own onerror Promise handler retries or reports the operation.
  // That is not a whole-SLB crash. Suppress only frames explicitly marked by the
  // secure transport layer; unrelated iframe failures remain globally guarded.
  function isManagedSecureTransportResourceError_(target){
    try{
      if(!target || target === window || !target.getAttribute) return false;
      if(String(target.tagName || '').toLowerCase() !== 'iframe') return false;
      return !!target.getAttribute('data-slb-secure-transport-frame');
    }catch(_e){ return false; }
  }

  // Diary entries can contain old or temporary image links. A missing image is not a
  // page failure and must never tell the user to reload or retry the whole SLB page.
  // Keep real JavaScript, stylesheet and RPC failures visible; silence only non-critical
  // media resources rendered inside the Diary Inbox.
  function isGameMediaResourceError_(target){
    try{
      if(!target || target === window) return false;
      var tag=String(target.tagName||'').toLowerCase();
      if(['img','audio','video','source','track'].indexOf(tag)<0)return false;
      if(!target.closest)return false;
      return !!target.closest('#slbMyAltar,#slbCelestialKitchen,#slbCelestialKitchenReceive,#slbAltarFaith,#slbThunderCourt');
    }catch(_e){return false;}
  }

  // Missing images/audio/video are local content failures, not whole-app failures.
  // A background/parked Cabin panel can hydrate one of these resources while the
  // disciple is simply sitting on My Cabin; showing the global Reload bar for that
  // is both noisy and misleading. Scripts/styles/RPC resources remain guarded.
  function isNonCriticalMediaResourceError_(target){
    try{
      if(!target || target === window) return false;
      var tag = String(target.tagName || '').toLowerCase();
      if(['img','audio','video','source','track'].indexOf(tag) < 0) return false;
      try{ target.setAttribute('data-slb-media-failed', '1'); }catch(_eMark){}
      return true;
    }catch(_e){ return false; }
  }

  // My Altar deliberately exposes a usable cached/local altar before its background
  // published-profile refresh finishes. During that exact "Syncing quietly…" window,
  // other Cabin modules can also finish optional/background work. Resource errors and
  // Promise rejections from those async background jobs are owned by their local loaders
  // and must not be promoted into the whole-SLB "Something went wrong" bar. Keep real
  // synchronous JavaScript errors globally guarded so an actual crash is still visible.
  function isMyAltarQuietSyncActive_(){
    try{
      var hosts=document.querySelectorAll('slb-my-altar-live-v2');
      for(var i=0;i<hosts.length;i++){
        var h=hosts[i];
        if(!h || h.isConnected===false) continue;
        try{
          if(Number(h.__slbQuietSyncUntil||0)>Date.now()) return true;
          if(h.getAttribute && h.getAttribute('data-slb-quiet-sync')==='1') return true;
        }catch(_eAttr){}
        var sh=h.shadowRoot||h.shadow;
        if(!sh || !sh.querySelector) continue;
        var st=sh.querySelector('[data-status],.matStatus');
        var txt=String(st&&st.textContent||'').toLowerCase();
        if(txt.indexOf('syncing quietly')>=0 || (txt.indexOf('syncing')>=0 && txt.indexOf('quietly')>=0)) return true;
      }
      return false;
    }catch(_e){ return false; }
  }

  function isCabinMyAltarHealthy_(){
    try{
      var cabin=document.getElementById('slbCabinPanel');
      if(!cabin || cabin.classList.contains('hidden')) return false;
      var active=document.querySelector('#slbCabinPanel [data-cabin-tao="cult"].active, #slbCabinPanel [data-cabin-tao="cult"][aria-pressed="true"]');
      if(!active) return false;
      var host=document.querySelector('#slbCabinPanel slb-my-altar-live-v2') || document.querySelector('slb-my-altar-live-v2');
      if(!host || host.isConnected===false || !host.rby || !host.rby.engine) return false;
      var sh=host.shadowRoot||host.shadow;
      var m=sh&&sh.querySelector&&sh.querySelector('[data-mount]');
      return !!(m&&m.classList&&m.classList.contains('is-ready'));
    }catch(_e){ return false; }
  }

  var cabinQuietDeferredErrors_=[];
  function deferCabinQuietError_(kind,err,extra){
    try{
      if(!isMyAltarQuietSyncActive_()) return false;
      var item={kind:String(kind||'error'),err:err,extra:extra||'',at:Date.now()};
      cabinQuietDeferredErrors_.push(item);
      if(cabinQuietDeferredErrors_.length>8)cabinQuietDeferredErrors_.splice(0,cabinQuietDeferredErrors_.length-8);
      rememberGlobalGuardEvent_('deferred',kind,err,extra,'my-altar-quiet-sync-healthcheck');
      setTimeout(function(){
        try{
          var idx=cabinQuietDeferredErrors_.indexOf(item);if(idx>=0)cabinQuietDeferredErrors_.splice(idx,1);
          if(isCabinMyAltarHealthy_()){
            rememberSuppressedGlobalErr_(kind,err,extra,'my-altar-quiet-sync-recovered');
            return;
          }
          handleGlobalErr_(kind,err,extra);
        }catch(_e){}
      },2600);
      return true;
    }catch(_e){ return false; }
  }

  // Thunder Court's live host is upgraded even while its panel can still be hidden.
  // During that short Rby/custom-element startup, a transient Promise or resource event
  // may surface before the altar has finished becoming healthy. The Thunder component
  // owns its own inline loading/retry UI, so hold the whole-site error bar until that
  // bounded startup finishes. If Thunder becomes ready, keep the transient only in the
  // diagnostic ring; if it stays broken, the original error still reaches the global bar.
  function thunderStartupHost_(){
    try{
      var hosts=document.querySelectorAll('slb-thunder-court-live-v2[data-slb-thunder-starting="1"]');
      for(var i=0;i<hosts.length;i++){
        var h=hosts[i];
        if(!h || h.isConnected===false) continue;
        var until=Number(h.__slbThunderStartupUntil||0);
        if(until>Date.now()) return h;
      }
      return null;
    }catch(_e){ return null; }
  }

  function isThunderStartupHealthy_(host){
    try{
      if(!host || host.isConnected===false) return false;
      if(host.getAttribute && host.getAttribute('data-live-ready')==='1') return true;
      var sh=host.shadowRoot||host.shadow;
      var mount=sh&&sh.querySelector&&sh.querySelector('[data-mount]');
      return !!(mount&&mount.classList&&mount.classList.contains('is-ready')&&host.engine);
    }catch(_e){ return false; }
  }

  // Thunder can already be healthy while it quietly refreshes its saved profile.
  // A transport/lazy Promise may be reported as temporarily unhandled and receive its
  // catch a few seconds later. Because the local altar is already usable, this refresh
  // owns those async errors and the whole-site error bar must stay quiet.
  function thunderQuietSyncHost_(){
    try{
      var hosts=document.querySelectorAll('slb-thunder-court-live-v2[data-slb-thunder-quiet-sync="1"]');
      for(var i=0;i<hosts.length;i++){
        var h=hosts[i];
        if(!h || h.isConnected===false) continue;
        if(!h.getAttribute || h.getAttribute('data-live-ready')!=='1') continue;
        if(Number(h.__slbThunderQuietSyncUntil||0)>Date.now()) return h;
      }
      return null;
    }catch(_e){ return null; }
  }
  function isThunderQuietSyncActive_(){return !!thunderQuietSyncHost_();}

  // The Thunder launcher wall can already be visible and healthy after startup has
  // finished but before/after the narrower startup and quiet-sync ownership markers.
  // A Promise that receives its catch handler a few seconds later can therefore fall
  // into the generic 2.5 s global-rejection grace and flash the whole-SLB error bar,
  // even though Thunder never stopped working. Detect the actual visible launcher wall
  // and give only Promise rejections a longer handled-rejection grace. Persistent
  // rejections still surface after that grace; synchronous JS errors are unchanged.
  function thunderVisibleWallHost_(){
    try{
      var panel=document.getElementById('slbThunderCourtPanel') || document.querySelector('[data-panel="thunderCourt"]');
      if(!panel || panel.hidden || (panel.classList&&panel.classList.contains('hidden'))) return null;
      var host=panel.querySelector&&panel.querySelector('slb-thunder-court-live-v2');
      if(!host || host.isConnected===false) return null;
      var sh=host.shadowRoot||host.shadow;
      if(!sh || !sh.querySelector) return null;
      var shell=sh.querySelector('[data-launcher-view]');
      var wall=sh.querySelector('[data-launcher-wall]');
      if(!wall || (shell&&String(shell.getAttribute('data-launcher-view')||'')!=='wall')) return null;
      return host;
    }catch(_e){ return null; }
  }

  function thunderWallRejectionGraceMs_(){
    return thunderVisibleWallHost_() ? 8000 : 2500;
  }

  // R22: mirror the My Altar R10 health-check pattern for the entire Thunder
  // launcher-wall loading phase, not only Promise rejections. The wall is a local
  // recovery boundary with its own status/retry UI. A short synchronous/runtime or
  // resource error may occur while background profile/engine work is settling after
  // the wall is already visible. Hold that event briefly; if Thunder remains healthy
  // or is still locally starting, keep it diagnostic-only. If Thunder has actually
  // entered its failed state, surface the original global error.
  function thunderWallLocallyOwnsErrors_(host){
    try{
      host=host||thunderVisibleWallHost_();
      if(!host || host.isConnected===false) return false;
      if(host.getAttribute && host.getAttribute('data-slb-thunder-startup-state')==='failed') return false;
      var sh=host.shadowRoot||host.shadow, status=sh&&sh.querySelector&&sh.querySelector('[data-launcher-status]');
      var tone=String(status&&status.getAttribute&&status.getAttribute('data-tone')||'').toLowerCase();
      var text=String(status&&status.textContent||'').toLowerCase();
      if(tone==='error' && (text.indexOf('retry')>=0 || text.indexOf('did not')>=0 || text.indexOf('failed')>=0 || text.indexOf('could not')>=0)) return false;
      return true;
    }catch(_e){ return false; }
  }

  var thunderWallDeferredErrors_=[];
  function deferThunderWallError_(kind,err,extra){
    try{
      var host=thunderVisibleWallHost_();
      if(!host || !thunderWallLocallyOwnsErrors_(host)) return false;
      var item={kind:String(kind||'error'),err:err,extra:extra||'',host:host,at:Date.now()};
      thunderWallDeferredErrors_.push(item);
      if(thunderWallDeferredErrors_.length>12)thunderWallDeferredErrors_.splice(0,thunderWallDeferredErrors_.length-12);
      rememberGlobalGuardEvent_('deferred',kind,err,extra,'thunder-wall-healthcheck');
      setTimeout(function(){
        try{
          var idx=thunderWallDeferredErrors_.indexOf(item);if(idx>=0)thunderWallDeferredErrors_.splice(idx,1);
          var current=thunderVisibleWallHost_();
          if(current===item.host && thunderWallLocallyOwnsErrors_(item.host)){
            rememberSuppressedGlobalErr_(kind,err,extra,'thunder-wall-recovered-or-locally-owned');
            return;
          }
          if(item.host && item.host.isConnected!==false && isThunderStartupHealthy_(item.host)){
            rememberSuppressedGlobalErr_(kind,err,extra,'thunder-wall-remained-healthy');
            return;
          }
          handleGlobalErr_(kind,err,extra);
        }catch(_e){}
      },2800);
      return true;
    }catch(_e){ return false; }
  }


  // R28: Celestial Altar disciple page uses the same local-first owned-startup model.
  // Its frozen-player shell is already the user's visible recovery surface while the nested
  // runtime, Frozen Live profile and public Celestial layer settle. Do not flash the whole-SLB
  // error bar for a transient event that the visible Celestial page is already handling.
  function celestialDiscipleIntentActive_(){
    try{
      if(Number(window.__slbCelestialDiscipleIntentUntil||0)>Date.now()) return true;
      var panel=document.getElementById('slbCelestialAltarPanel');
      if(!panel)return false;
      if(panel.hidden===true)return false;
      if(panel.classList&&panel.classList.contains('hidden'))return false;
      var st=panel.style;if(st&&(st.display==='none'||st.visibility==='hidden'))return false;
      return !!panel.querySelector('slb-celestial-altar-test-v2[data-disciple-live]');
    }catch(_e){return false;}
  }
  function celestialDiscipleVisibleHost_(){
    try{
      var hosts=document.querySelectorAll('slb-celestial-altar-test-v2[data-disciple-live]');
      for(var i=0;i<hosts.length;i++){
        var host=hosts[i];if(!host||host.isConnected===false)continue;
        var panel=host.closest&&host.closest('[data-panel],.slbPanel,.panel');
        if(panel){
          if(panel.hidden===true)continue;
          if(panel.classList&&panel.classList.contains('hidden'))continue;
          var pst=panel.style;if(pst&&(pst.display==='none'||pst.visibility==='hidden'))continue;
        }
        // IMPORTANT: return the visible disciple host even before its custom-element
        // shadow root exists. That pre-mount interval is exactly where V4.103 could
        // leak a transient startup event into the global error toast.
        return host;
      }
      return null;
    }catch(_e){return null;}
  }
  function isCelestialDiscipleHealthy_(host){
    try{
      if(!host||host.isConnected===false)return false;
      if(host.getAttribute&&host.getAttribute('data-slb-celestial-startup-failed')==='1')return false;
      if(host._activated===true)return true;
      if(host._runtimeReady===true&&host._runtimeEl&&host._runtimeEl.engine)return true;
      var state=String(host.getAttribute&&host.getAttribute('data-slb-celestial-startup-state')||'').toLowerCase();
      return state==='ready'||state==='runtime-ready';
    }catch(_e){return false;}
  }
  function celestialDiscipleLocallyOwnsErrors_(host){
    try{
      host=host||celestialDiscipleVisibleHost_();
      if(!host||host.isConnected===false){
        // On the actual menu click the lazy loader may fail/settle before the custom
        // element has upgraded. Keep that very short, explicit intent window local.
        return celestialDiscipleIntentActive_();
      }
      if(host.getAttribute&&host.getAttribute('data-slb-celestial-startup-failed')==='1')return false;
      var state=String(host.getAttribute&&host.getAttribute('data-slb-celestial-startup-state')||'').toLowerCase();
      if(state==='failed')return false;
      var sh=host.shadowRoot||host.shadow;
      if(!sh||!sh.querySelector){
        // Pre-upgrade/pre-shadow shell: the visible Celestial page itself is already
        // the owner. Do not flash the whole-app Reload toast while the component mounts.
        return celestialDiscipleIntentActive_();
      }
      var note=String(sh.querySelector('[data-note]')&&sh.querySelector('[data-note]').textContent||'').toLowerCase();
      var begin=String(sh.querySelector('[data-begin]')&&sh.querySelector('[data-begin]').textContent||'').toLowerCase();
      if((/could not|failed|cannot start|unavailable/.test(note))&&/retry/.test(begin))return false;
      return true;
    }catch(_e){return false;}
  }
  var celestialDiscipleDeferredErrors_=[];
  function deferCelestialDiscipleError_(kind,err,extra){
    try{
      var host=celestialDiscipleVisibleHost_();if(!host||!celestialDiscipleLocallyOwnsErrors_(host))return false;
      var item={kind:String(kind||'error'),err:err,extra:extra||'',host:host,at:Date.now()};
      celestialDiscipleDeferredErrors_.push(item);if(celestialDiscipleDeferredErrors_.length>12)celestialDiscipleDeferredErrors_.splice(0,celestialDiscipleDeferredErrors_.length-12);
      rememberGlobalGuardEvent_('deferred',kind,err,extra,'celestial-disciple-startup-healthcheck');
      setTimeout(function(){
        try{
          var idx=celestialDiscipleDeferredErrors_.indexOf(item);if(idx>=0)celestialDiscipleDeferredErrors_.splice(idx,1);
          var current=celestialDiscipleVisibleHost_();
          if(current===item.host&&celestialDiscipleLocallyOwnsErrors_(item.host)){
            rememberSuppressedGlobalErr_(kind,err,extra,'celestial-disciple-recovered-or-locally-owned');return;
          }
          if(item.host&&item.host.isConnected!==false&&isCelestialDiscipleHealthy_(item.host)){
            rememberSuppressedGlobalErr_(kind,err,extra,'celestial-disciple-remained-healthy');return;
          }
          handleGlobalErr_(kind,err,extra);
        }catch(_e){}
      },3200);
      return true;
    }catch(_e){return false;}
  }

  // R23: AOF and Offering Hall use the same local-first launcher-wall model as
  // Thunder Court. Their wall is visible before the altar/profile/account refresh
  // finishes, and each page already has its own busy/error/retry UI. Do not promote
  // a transient locally-owned settling event into the whole-SLB error bar. Hold it
  // briefly, then keep it diagnostic-only if the page remains healthy/local; surface
  // it only if that page has actually entered its own failed state.
  function aofVisibleWallHost_(){
    try{
      var hosts=document.querySelectorAll('slb-aof-test-v2[data-aof-live="1"],slb-aof-test-v2[data-aof-live]');
      for(var i=0;i<hosts.length;i++){
        var host=hosts[i];if(!host||host.isConnected===false)continue;
        var sh=host.shadowRoot||host.shadow;if(!sh||!sh.querySelector)continue;
        var shell=sh.querySelector('.aofShell'),wall=sh.querySelector('[data-aof-launcher-wall]');
        if(!shell||!wall||String(shell.getAttribute('data-aof-launcher-view')||'')!=='wall')continue;
        return host;
      }
      return null;
    }catch(_e){return null;}
  }
  function isAofWallHealthy_(host){
    try{
      if(!host||host.isConnected===false)return false;
      var sh=host.shadowRoot||host.shadow,mount=sh&&sh.querySelector&&sh.querySelector('[data-mount]');
      return !!(host.rby&&host.rby.engine&&mount&&mount.classList&&mount.classList.contains('is-ready'));
    }catch(_e){return false;}
  }
  function aofWallLocallyOwnsErrors_(host){
    try{
      host=host||aofVisibleWallHost_();if(!host||host.isConnected===false)return false;
      var sh=host.shadowRoot||host.shadow;if(!sh||!sh.querySelector)return false;
      var status=sh.querySelector('[data-aof-launcher-status]'),tone=String(status&&status.getAttribute&&status.getAttribute('data-tone')||'').toLowerCase(),text=String(status&&status.textContent||'').toLowerCase();
      var loading=sh.querySelector('[data-loading]'),loadText=String(loading&&loading.textContent||'').toLowerCase(),loadFailed=!!(loading&&!loading.hidden&&/(could not load|failed|reload this page|unavailable)/.test(loadText));
      var base=sh.querySelector('[data-status]'),baseText=String(base&&base.textContent||'').toLowerCase();
      if(loadFailed)return false;
      if(/(unavailable|runtime did not start|could not load|failed to load)/.test(baseText))return false;
      if(tone==='error'&&/(could not|failed|unavailable|runtime|retry sync|not ready)/.test(text))return false;
      return true;
    }catch(_e){return false;}
  }
  var aofWallDeferredErrors_=[];
  function deferAofWallError_(kind,err,extra){
    try{
      var host=aofVisibleWallHost_();if(!host||!aofWallLocallyOwnsErrors_(host))return false;
      var item={kind:String(kind||'error'),err:err,extra:extra||'',host:host,at:Date.now()};
      aofWallDeferredErrors_.push(item);if(aofWallDeferredErrors_.length>12)aofWallDeferredErrors_.splice(0,aofWallDeferredErrors_.length-12);
      rememberGlobalGuardEvent_('deferred',kind,err,extra,'aof-wall-healthcheck');
      setTimeout(function(){
        try{
          var idx=aofWallDeferredErrors_.indexOf(item);if(idx>=0)aofWallDeferredErrors_.splice(idx,1);
          var current=aofVisibleWallHost_();
          if(current===item.host&&aofWallLocallyOwnsErrors_(item.host)){
            rememberSuppressedGlobalErr_(kind,err,extra,'aof-wall-recovered-or-locally-owned');return;
          }
          if(item.host&&item.host.isConnected!==false&&isAofWallHealthy_(item.host)){
            rememberSuppressedGlobalErr_(kind,err,extra,'aof-wall-remained-healthy');return;
          }
          handleGlobalErr_(kind,err,extra);
        }catch(_e){}
      },2800);
      return true;
    }catch(_e){return false;}
  }

  function offeringVisibleWallHost_(){
    try{
      var hosts=document.querySelectorAll('slb-offering-hall-v2-test[data-public-mode],slb-offering-hall-v2-test[mode="public"]');
      for(var i=0;i<hosts.length;i++){
        var host=hosts[i];if(!host||host.isConnected===false)continue;
        var sh=host.shadowRoot||host.shadow;if(!sh||!sh.querySelector)continue;
        var shell=sh.querySelector('.ohfs'),wall=sh.querySelector('[data-oh-launcher-wall]');
        if(!shell||!wall||String(shell.getAttribute('data-oh-launcher-view')||'')!=='wall')continue;
        return host;
      }
      return null;
    }catch(_e){return null;}
  }
  function isOfferingWallHealthy_(host){
    try{return !!(host&&host.isConnected!==false&&host._sceneLoaded&&host.rby&&host.rby.engine);}catch(_e){return false;}
  }
  function offeringWallLocallyOwnsErrors_(host){
    try{
      host=host||offeringVisibleWallHost_();if(!host||host.isConnected===false)return false;
      var sh=host.shadowRoot||host.shadow;if(!sh||!sh.querySelector)return false;
      var status=sh.querySelector('[data-oh-launcher-status]'),tone=String(status&&status.getAttribute&&status.getAttribute('data-tone')||'').toLowerCase(),text=String(status&&status.textContent||'').toLowerCase();
      var loading=sh.querySelector('[data-loading]'),loadText=String(loading&&loading.textContent||'').toLowerCase(),loadFailed=!!(loading&&!loading.hidden&&/(could not load|failed|reload this page|unavailable)/.test(loadText));
      var base=sh.querySelector('[data-status]'),baseText=String(base&&base.textContent||'').toLowerCase();
      if(loadFailed)return false;
      if(!host._sceneLoaded&&/(unavailable|runtime did not start|could not load|failed to load)/.test(baseText))return false;
      if(tone==='error'&&/(could not load|failed|unavailable|still loading\. try again|runtime)/.test(text))return false;
      return true;
    }catch(_e){return false;}
  }
  var offeringWallDeferredErrors_=[];
  function deferOfferingWallError_(kind,err,extra){
    try{
      var host=offeringVisibleWallHost_();if(!host||!offeringWallLocallyOwnsErrors_(host))return false;
      var item={kind:String(kind||'error'),err:err,extra:extra||'',host:host,at:Date.now()};
      offeringWallDeferredErrors_.push(item);if(offeringWallDeferredErrors_.length>12)offeringWallDeferredErrors_.splice(0,offeringWallDeferredErrors_.length-12);
      rememberGlobalGuardEvent_('deferred',kind,err,extra,'offering-wall-healthcheck');
      setTimeout(function(){
        try{
          var idx=offeringWallDeferredErrors_.indexOf(item);if(idx>=0)offeringWallDeferredErrors_.splice(idx,1);
          var current=offeringVisibleWallHost_();
          if(current===item.host&&offeringWallLocallyOwnsErrors_(item.host)){
            rememberSuppressedGlobalErr_(kind,err,extra,'offering-wall-recovered-or-locally-owned');return;
          }
          if(item.host&&item.host.isConnected!==false&&isOfferingWallHealthy_(item.host)){
            rememberSuppressedGlobalErr_(kind,err,extra,'offering-wall-remained-healthy');return;
          }
          handleGlobalErr_(kind,err,extra);
        }catch(_e){}
      },2800);
      return true;
    }catch(_e){return false;}
  }


  // R27: Disciple Diary uses the same local-first My Cabin mounting model as the
  // altar walls. The editor/history can already be usable while its current-entry,
  // reply, lazy module, or history work is still settling. Those operations already
  // have Diary/Cabin inline status and retry UI; a short settling error must not be
  // promoted into the whole-SLB "Something went wrong" bar.
  function slbDiaryNodeVisible_(node){
    try{
      if(!node || node.isConnected===false) return false;
      var n=node, depth=0;
      while(n && n!==document.documentElement && depth++<18){
        if(n.hidden===true) return false;
        if(n.classList && n.classList.contains('hidden')) return false;
        if(n.getAttribute && String(n.getAttribute('aria-hidden')||'').toLowerCase()==='true') return false;
        var st=n.style;
        if(st && (st.display==='none' || st.visibility==='hidden')) return false;
        n=n.parentElement;
      }
      return true;
    }catch(_e){ return false; }
  }

  function discipleDiarySurface_(){
    try{
      var write=document.getElementById('slbDiaryWriteBody');
      var read=document.getElementById('slbDiaryReadBoxBody');
      var panel=document.getElementById('slbDiaryPanel');
      var readPanel=document.querySelector('.slbCabinDiaryReadPanel');
      if(write && slbDiaryNodeVisible_(write)) return { root:(panel||write), mode:'write' };
      if(read && slbDiaryNodeVisible_(read)) return { root:(readPanel||panel||read), mode:'read' };
      if(readPanel && slbDiaryNodeVisible_(readPanel)) return { root:readPanel, mode:'read-loading' };
      if(panel && slbDiaryNodeVisible_(panel)){
        var hosted=panel.getAttribute && panel.getAttribute('data-cabin-hosted');
        if(panel.__slbDiaryMounted || hosted) return { root:panel, mode:'mounting' };
      }
      return null;
    }catch(_e){ return null; }
  }

  function discipleDiaryFatalVisible_(){
    try{
      var sels=[
        '#slbCabinPortalHost > .slbCabinLoading.error',
        '#slbCabinTaoHost > .slbCabinLoading.error',
        '.slbCabinDiaryReadHost > .slbCabinLoading.error'
      ];
      for(var i=0;i<sels.length;i++){
        var el=document.querySelector(sels[i]);
        if(el && slbDiaryNodeVisible_(el)) return true;
      }
      return false;
    }catch(_e){ return false; }
  }

  function discipleDiaryHealthy_(){
    try{
      if(discipleDiaryFatalVisible_()) return false;
      var s=discipleDiarySurface_();
      if(!s) return false;
      if(s.mode==='write' || s.mode==='mounting'){
        var panel=document.getElementById('slbDiaryPanel');
        var date=document.getElementById('slbDiaryDate');
        var body=document.getElementById('slbDiaryBodyRich');
        if(panel && (panel.__slbDiaryMounted || (date && body))) return true;
      }
      if(s.mode==='read' || s.mode==='read-loading'){
        var list=document.getElementById('slbDiaryReadList') || (s.root.querySelector && s.root.querySelector('#slbDiaryReadList'));
        if(list) return true;
        var loading=s.root.querySelector && s.root.querySelector('.slbCabinLoading:not(.error)');
        if(loading) return true;
      }
      return false;
    }catch(_e){ return false; }
  }

  function discipleDiaryLocallyOwnsErrors_(){
    try{
      var s=discipleDiarySurface_();
      if(!s || discipleDiaryFatalVisible_()) return false;
      // A visible, mounted Diary surface owns current-entry/history/reply failures
      // through its own inline status. During the short mounting placeholder, the
      // Cabin loader owns the operation until it either hydrates or shows .error.
      return true;
    }catch(_e){ return false; }
  }

  var discipleDiaryDeferredErrors_=[];
  function deferDiscipleDiaryError_(kind,err,extra){
    try{
      var surface=discipleDiarySurface_();
      if(!surface || !discipleDiaryLocallyOwnsErrors_()) return false;
      var item={kind:String(kind||'error'),err:err,extra:extra||'',root:surface.root,mode:surface.mode,at:Date.now()};
      discipleDiaryDeferredErrors_.push(item);
      if(discipleDiaryDeferredErrors_.length>12) discipleDiaryDeferredErrors_.splice(0,discipleDiaryDeferredErrors_.length-12);
      rememberGlobalGuardEvent_('deferred',kind,err,extra,'disciple-diary-healthcheck');
      setTimeout(function(){
        try{
          var idx=discipleDiaryDeferredErrors_.indexOf(item);if(idx>=0)discipleDiaryDeferredErrors_.splice(idx,1);
          if(discipleDiaryFatalVisible_()){
            handleGlobalErr_(kind,err,extra);
            return;
          }
          var current=discipleDiarySurface_();
          if(current && discipleDiaryLocallyOwnsErrors_()){
            rememberSuppressedGlobalErr_(kind,err,extra,'disciple-diary-recovered-or-locally-owned');
            return;
          }
          // If the user left Diary while the deferred event was settling, never
          // show a stale global bar on the next Cabin page.
          if(!item.root || item.root.isConnected===false || !slbDiaryNodeVisible_(item.root)){
            rememberSuppressedGlobalErr_(kind,err,extra,'disciple-diary-surface-left');
            return;
          }
          if(discipleDiaryHealthy_()){
            rememberSuppressedGlobalErr_(kind,err,extra,'disciple-diary-remained-healthy');
            return;
          }
          handleGlobalErr_(kind,err,extra);
        }catch(_e){}
      },2800);
      return true;
    }catch(_e){ return false; }
  }

  var thunderStartupDeferredErrors_=[];
  function deferThunderStartupError_(kind,err,extra){
    try{
      var host=thunderStartupHost_();
      if(!host) return false;
      var until=Number(host.__slbThunderStartupUntil||0);
      if(!until || until<=Date.now()) return false;
      var item={kind:String(kind||'error'),err:err,extra:extra||'',host:host,until:until,at:Date.now()};
      thunderStartupDeferredErrors_.push(item);
      if(thunderStartupDeferredErrors_.length>10)thunderStartupDeferredErrors_.splice(0,thunderStartupDeferredErrors_.length-10);
      rememberGlobalGuardEvent_('deferred',kind,err,extra,'thunder-startup-healthcheck');
      var delay=Math.max(250,Math.min(9000,until-Date.now()+80));
      setTimeout(function(){
        try{
          var idx=thunderStartupDeferredErrors_.indexOf(item);if(idx>=0)thunderStartupDeferredErrors_.splice(idx,1);
          if(!item.host || item.host.isConnected===false){
            rememberSuppressedGlobalErr_(kind,err,extra,'thunder-startup-host-gone');
            return;
          }
          if(isThunderStartupHealthy_(item.host)){
            rememberSuppressedGlobalErr_(kind,err,extra,'thunder-startup-recovered');
            return;
          }
          handleGlobalErr_(kind,err,extra);
        }catch(_e){}
      },delay);
      return true;
    }catch(_e){ return false; }
  }

  function isDiaryMediaResourceError_(target){
    try{
      if(!target || target === window) return false;
      var tag = String(target.tagName || '').toLowerCase();
      if(tag !== 'img' && tag !== 'audio' && tag !== 'video' && tag !== 'source' && tag !== 'track') return false;

      var insideDiary = false;
      try{
        if(target.closest) insideDiary = !!target.closest('#slbDiaryInbox, #slbDiaryInboxPanel');
      }catch(_eClosest){}
      if(!insideDiary){
        try{
          var root = document.getElementById('slbDiaryInbox');
          insideDiary = !!(root && root.contains && root.contains(target));
        }catch(_eContains){}
      }
      if(!insideDiary) return false;

      // Mark it for optional inline styling/debugging without creating another error.
      try{ target.setAttribute('data-slb-diary-media-failed', '1'); }catch(_eMark){}
      try{
        if(tag === 'img' && !String(target.getAttribute('alt') || '').trim()){
          target.setAttribute('alt', 'Diary image unavailable');
        }
      }catch(_eAlt){}
      return true;
    }catch(_e){ return false; }
  }

  function bindGlobalHandlers_(){
    try{
      window.addEventListener('error', function(ev){
        try{
          // Resource errors: ev.target/src. Ignore SLB JSONP RPC scripts because the RPC
          // promise already handles them; otherwise background reads show a scary Reload toast.
          if(ev && ev.target && ev.target !== window && !ev.error){
            if(isMyAltarQuietSyncActive_()){
              var quietSrc=ev.target && (ev.target.src || ev.target.href) ? (ev.target.src || ev.target.href) : '';
              rememberSuppressedGlobalErr_('resource', new Error('Background resource event during My Altar quiet sync'), quietSrc, 'my-altar-quiet-sync-resource');
              return;
            }
            if(isRpcResourceError_(ev.target)) return;
            if(isExplicitlyManagedResourceError_(ev.target)){
              var managedSrc = ev.target && (ev.target.src || ev.target.href) ? (ev.target.src || ev.target.href) : '';
              var managedOwner = '';
              try{ managedOwner = String(ev.target.getAttribute('data-slb-managed-resource') || 'managed-resource'); }catch(_eManagedOwner){}
              rememberSuppressedGlobalErr_('resource', new Error('SLB managed resource load event'), managedSrc, managedOwner || 'managed-resource');
              return;
            }
            if(isManagedLazyResourceError_(ev.target)){
              var lazySrc = ev.target && (ev.target.src || ev.target.href) ? (ev.target.src || ev.target.href) : '';
              var lazyKind = '';
              try{ lazyKind = ev.target.getAttribute('data-slb-lazy-prefetch') === '1' ? 'lazy-prefetch' : 'lazy-managed-resource'; }catch(_eLazyKind){}
              rememberSuppressedGlobalErr_('resource', new Error('SLB lazy resource load event'), lazySrc, lazyKind || 'lazy-managed-resource');
              return;
            }
            if(isManagedSecureTransportResourceError_(ev.target)){
              var transportSrc = ev.target && (ev.target.src || ev.target.href) ? (ev.target.src || ev.target.href) : '';
              var transportKind = '';
              try{ transportKind = String(ev.target.getAttribute('data-slb-secure-transport-frame') || 'managed'); }catch(_eTransportKind){}
              rememberSuppressedGlobalErr_('resource', new Error('SLB secure transport iframe load event'), transportSrc, 'secure-transport-'+transportKind);
              return;
            }
            if(isDiaryMediaResourceError_(ev.target)) return;
            if(isGameMediaResourceError_(ev.target)) return;
            if(isNonCriticalMediaResourceError_(ev.target)){
              var mediaSrc = ev.target && (ev.target.src || ev.target.href) ? (ev.target.src || ev.target.href) : '';
              rememberSuppressedGlobalErr_('resource', new Error('Non-critical media failed to load'), mediaSrc, 'non-critical-media');
              return;
            }
            var src = ev.target && (ev.target.src || ev.target.href) ? (ev.target.src || ev.target.href) : '';
            var resourceErr=new Error('Resource failed to load');
            if(isThunderQuietSyncActive_()){
              rememberSuppressedGlobalErr_('resource',resourceErr,src,'thunder-quiet-sync-resource');
              return;
            }
            if(deferCelestialDiscipleError_('resource',resourceErr,src)) return;
            if(deferThunderStartupError_('resource',resourceErr,src)) return;
            if(deferThunderWallError_('resource',resourceErr,src)) return;
            if(deferAofWallError_('resource',resourceErr,src)) return;
            if(deferOfferingWallError_('resource',resourceErr,src)) return;
            if(deferDiscipleDiaryError_('resource',resourceErr,src)) return;
            handleGlobalErr_('resource', resourceErr, src);
            return;
          }
          var syncErr=ev && ev.error ? ev.error : new Error(ev && ev.message ? ev.message : 'Error');
          var syncExtra='';
          try{ syncExtra=[String(ev&&ev.filename||''),String(ev&&ev.lineno||''),String(ev&&ev.colno||'')].filter(Boolean).join(':'); }catch(_eSyncExtra){}
          if(deferCelestialDiscipleError_('error',syncErr,syncExtra)) return;
          if(deferThunderStartupError_('error',syncErr,syncExtra)) return;
          if(deferThunderWallError_('error',syncErr,syncExtra)) return;
          if(deferAofWallError_('error',syncErr,syncExtra)) return;
          if(deferOfferingWallError_('error',syncErr,syncExtra)) return;
          if(deferDiscipleDiaryError_('error',syncErr,syncExtra)) return;
          if(deferCabinQuietError_('error',syncErr,syncExtra)) return;
          handleGlobalErr_('error',syncErr,syncExtra);
        }catch(_e){}
      }, true);

      // A Promise can briefly be reported as "unhandled" and then receive its
      // catch handler on the next async turn. Lazy Cabin/My Altar startup does this
      // in a few compatibility paths while modules/custom elements are attaching.
      // Showing the global Reload bar immediately creates a false one-second flash
      // even though the promise is subsequently handled and the destination opens.
      // Give rejections a short grace period and cancel the toast if the browser
      // later emits rejectionhandled for the same Promise. Truly unhandled
      // rejections still reach the normal global guard after the grace period.
      var pendingUnhandled_ = (typeof WeakMap === 'function') ? new WeakMap() : null;
      window.addEventListener('unhandledrejection', function(ev){
        try{
          var r = ev && ev.reason ? ev.reason : new Error('Unhandled rejection');
          if(isThunderQuietSyncActive_()){
            rememberSuppressedGlobalErr_('rejection',r,'','thunder-quiet-sync-rejection');
            return;
          }
          if(deferCelestialDiscipleError_('rejection',r,'')) return;
          if(deferThunderStartupError_('rejection',r,'')) return;
          if(deferAofWallError_('rejection',r,'')) return;
          if(deferOfferingWallError_('rejection',r,'')) return;
          if(deferDiscipleDiaryError_('rejection',r,'')) return;
          // My Altar is already usable while this status is visible. Any asynchronous
          // background rejection during the quiet refresh belongs to the component that
          // launched it and is retained in diagnostics rather than alarming the whole page.
          if(isMyAltarQuietSyncActive_()){
            rememberSuppressedGlobalErr_('rejection', r, '', 'my-altar-quiet-sync-rejection');
            return;
          }
          // Diary Inbox RPC errors are already handled by its own inline status and cache UI.
          if(r && r.__slbDiaryInboxHandled) return;
          var promise = ev && ev.promise;
          var wallHost=thunderVisibleWallHost_();
          var rejectionGrace=wallHost?8000:2500;
          var state = { cancelled:false, reason:r, at:Date.now(), timer:0, thunderWallHost:wallHost||null, graceMs:rejectionGrace };
          if(wallHost) rememberGlobalGuardEvent_('deferred','rejection',r,'','thunder-visible-wall-late-handler-grace');
          state.timer = setTimeout(function(){
            if(state.cancelled) return;
            if(state.thunderWallHost){
              var visibleHost=thunderVisibleWallHost_();
              if(visibleHost===state.thunderWallHost && isThunderStartupHealthy_(state.thunderWallHost)){
                rememberSuppressedGlobalErr_('rejection',r,'','thunder-visible-wall-still-healthy');
                return;
              }
            }
            state.shown = true;
            state.toastText = '[rejection] ' + formatErr_(r);
            handleGlobalErr_('rejection', r);
          }, rejectionGrace);
          try{ if(pendingUnhandled_ && promise) pendingUnhandled_.set(promise, state); }catch(_eSet){}
        }catch(_e){}
      }, true);

      window.addEventListener('rejectionhandled', function(ev){
        try{
          var promise = ev && ev.promise;
          if(!pendingUnhandled_ || !promise) return;
          var state = pendingUnhandled_.get(promise);
          if(!state) return;
          state.cancelled = true;
          try{ clearTimeout(state.timer); }catch(_eTimer){}
          try{ pendingUnhandled_.delete(promise); }catch(_eDel){}
          // If this rejection was handled only after its grace window and it was
          // the exact error currently shown, retract the false toast immediately.
          try{
            if(state.shown && toastEl && String(window.__slbLastErrorText||'')===String(state.toastText||'')){
              toastEl.style.display='none';
            }
          }catch(_eHide){}
          rememberSuppressedGlobalErr_('rejection', state.reason, '', 'late-handled-rejection');
        }catch(_e){}
      }, true);
    }catch(_e){}
  }

  // ---------- Wrap RPC for consistent retry ----------
  function wrapRpc_(obj, key){
    try{
      if(!obj) return false;
      var fn = obj[key];
      if(typeof fn !== 'function') return false;
      if(fn.__slbRetryWrapped) return true;

      var wrapped = function(){
        var self = this;
        var args = arguments;
        var noGlobalRetry = false;
        try{
          var payload = args && args.length > 1 ? args[1] : null;
          var opts = args && args.length > 2 ? args[2] : null;
          noGlobalRetry = !!(
            (opts && (opts.noGlobalRetry || opts.__slbNoGlobalRetry)) ||
            (payload && (payload.__slbNoGlobalRetry || payload.noGlobalRetry))
          );
        }catch(_eNoRetry){}
        var attempt = function(){
          return Promise.resolve().then(function(){ return fn.apply(self, args); });
        };

        return attempt().catch(function(e){
          if(isNetworkError_(e) && !noGlobalRetry){
            return new Promise(function(resolve, reject){
              enqueueRetry_(attempt, resolve, reject, e);
            });
          }
          throw e;
        });
      };
      wrapped.__slbRetryWrapped = true;
      obj[key] = wrapped;
      return true;
    }catch(_e){ return false; }
  }

  function tryWrapRpcs_(){
    var found = false;
    try{ if(window.TYW && window.TYW.rpc){ wrapRpc_(window.TYW, 'rpc'); found = true; } }catch(_e){}
    try{ if(window.SLB_APP && window.SLB_APP.rpc){ wrapRpc_(window.SLB_APP, 'rpc'); found = true; } }catch(_e2){}
    return found;
  }

  function startWrapWatch_(){
    var delays = [0,60,180,450,1000,2200,4500,9000,16000,24000];
    for(var i=0;i<delays.length;i++){
      setTimeout(tryWrapRpcs_, delays[i]);
    }
    try{ window.addEventListener('slb:auth-ready', tryWrapRpcs_); }catch(_e){}
    try{ window.addEventListener('slb:rpc-ready', tryWrapRpcs_); }catch(_e2){}
    try{ window.addEventListener('slb:core-ready', tryWrapRpcs_); }catch(_e3){}
  }

  onceReady_(function(){
    bindGlobalHandlers_();
    ensureBanner_();
    updateOnlineBanner_();
    window.addEventListener('online', updateOnlineBanner_);
    window.addEventListener('offline', updateOnlineBanner_);
    startWrapWatch_();
  });

  // ===========================
  // Warm Up / Pre-Cache (Phase W1)
  // ===========================
  function warmGetToken_(){
    try{ return String(sessionStorage.getItem('tyw_token') || '') || null; }catch(_e){ return null; }
  }

  function warmGetCallsign_(){
    try{
      var cs = String(sessionStorage.getItem('tyw_callsign') || '').trim();
      if(cs) return cs;
    }catch(_e){}
    try{
      var raw = localStorage.getItem('ty_auth_v1') || '';
      var o = raw ? JSON.parse(raw) : null;
      return (o && (o.callsign||o.cs)) ? String(o.callsign||o.cs) : null;
    }catch(_e2){ return null; }
  }

  function warmIsAdmin_(){
    try{ if(sessionStorage.getItem('tyw_isAdmin') === '1') return true; }catch(_e0){}
    try{
      var raw = localStorage.getItem('ty_auth_v1') || '';
      if(raw){
        var a = JSON.parse(raw);
        if(a && (a.isAdmin === true || a.isAdmin === '1' || String(a.role||'').toLowerCase() === 'admin')) return true;
        if(a && a.profile && (a.profile.isAdmin === true || String(a.profile.role||'').toLowerCase() === 'admin')) return true;
      }
    }catch(_e1){}
    try{
      var root = document.getElementById('SaamLawBank') || document.getElementById('tyWealthCourtyard');
      if(root && root.classList && root.classList.contains('tyRoleAdmin')) return true;
    }catch(_e2){}
    return false;
  }

  function warmAdminCacheSteps_(){ return warmShouldRunAdminSweep_() ? 7 : 0; }

  function warmAdminTabNames_(){
    return { diaryInbox:1, lettersInbox:1, cmrInbox:1, sdrInbox:1, swrInbox:1, dcrInbox:1, ddrInbox:1, admin:1 };
  }

  function warmFilterAdminTabs_(seq){
    var admin = warmAdminTabNames_();
    return (seq || []).filter(function(x){ return !admin[String((x && x[0]) || '')]; });
  }

  
  // Warm cache storage for priming "first-open" pages (7 Star, Diary Inbox, etc.)
  function warmCacheLoad_(){
    try{
      var raw = localStorage.getItem('slb_warm_cache_v2') || '';
      if(!raw) return {v:1, items:{}};
      var obj = JSON.parse(raw);
      if(!obj || typeof obj !== 'object') return {v:1, items:{}};
      if(!obj.items || typeof obj.items !== 'object') obj.items = {};
      return obj;
    }catch(_e){ return {v:1, items:{}}; }
  }
  function warmCacheSave_(obj){
    try{ localStorage.setItem('slb_warm_cache_v2', JSON.stringify(obj)); }catch(_e){}
  }
  function warmCacheKey_(action, payload){
    try{
      payload = payload || {};
      if(payload && typeof payload === 'object'){
        // shallow stable signature, scoped to the authenticated callsign
        var keys = Object.keys(payload).filter(function(k){ return k !== '__warm_capture'; }).sort();
        var parts = [];
        for(var i=0;i<keys.length;i++){
          var k = keys[i];
          parts.push([k, payload[k]]);
        }
        return String(warmGetCallsign_() || 'ANON').toUpperCase() + '|' + String(action || '') + '|' + JSON.stringify(parts);
      }
    }catch(_e){}
    return String(warmGetCallsign_() || 'ANON').toUpperCase() + '|' + String(action || '');
  }
  function warmCacheAllowed_(action){
    return ['magic7Bootstrap', 'letterGodsList', 'cultGetTypes'].indexOf(String(action || '')) >= 0;
  }
  function warmCachePut_(action, payload, res, ttlMs){
    if(!warmCacheAllowed_(action)) return;
    try{
      var db = warmCacheLoad_();
      var key = warmCacheKey_(action, payload);
      db.items[key] = { t: Date.now(), ttl: ttlMs||((function(){try{var d=Number(localStorage.getItem('slb_warm_days')||'14'); if(isFinite(d)&&d>0&&d<=90) return d*((function(){try{var d=Number(localStorage.getItem('slb_warm_days')||'14'); if(isFinite(d)&&d>0&&d<=90) return d*24*60*60*1000;}catch(_e){} return 14*24*60*60*1000;})());}catch(_e){} return 14*((function(){try{var d=Number(localStorage.getItem('slb_warm_days')||'14'); if(isFinite(d)&&d>0&&d<=90) return d*24*60*60*1000;}catch(_e){} return 14*24*60*60*1000;})());})()), v: res };
      warmCacheSave_(db);
    }catch(_e){}
  }
var __SLB_WARM_BUSY__ = false;
var __SLB_WARM_TRAP_RELEASE__ = null;
var __SLB_WARM_RETURN_FOCUS__ = null;

  function warmEnsureModal_(){
    var m = document.getElementById('slbWarmModal');
    if(m) return m;

    m = document.createElement('div');
    m.id = 'slbWarmModal';
    m.setAttribute('role','dialog');
    m.setAttribute('aria-modal','true');
    m.setAttribute('aria-labelledby','slbWarmTitle');
    m.setAttribute('aria-hidden','true');
    m.setAttribute('tabindex','-1');
// ensure warmup modal styles exist (fixed overlay, high z-index)
try{
  if(!document.getElementById('slbWarmStyle')){
    var st=document.createElement('style');
    st.id='slbWarmStyle';
    st.textContent =
      // Use svh + safe-area padding so the header/close button is never clipped on short mobile viewports.
      "#slbWarmModal{position:fixed;inset:0;display:none;align-items:center;justify-content:center;z-index:2147482000;background:rgba(0,0,0,.45);padding:16px;padding-top:max(16px,env(safe-area-inset-top));padding-bottom:max(16px,env(safe-area-inset-bottom));}" +
      "#slbWarmModal .slbWarmCard{width:min(520px,calc(100vw - 32px));max-height:calc(100svh - 32px);background:#0f1517;color:#fff;border:1px solid rgba(255,255,255,.12);border-radius:14px;box-shadow:0 18px 60px rgba(0,0,0,.45);display:flex;flex-direction:column;overflow:hidden;}" +
      "#slbWarmModal .slbWarmHead{display:flex;align-items:center;justify-content:space-between;padding:12px 14px;border-bottom:1px solid rgba(255,255,255,.10);}" +
      "#slbWarmModal .slbWarmTitle{font-weight:800;letter-spacing:.2px;}" +
      "#slbWarmModal .slbWarmClose{background:transparent;border:0;color:#fff;font-size:22px;line-height:28px;cursor:pointer;padding:4px 10px;opacity:.9;}" +
      "#slbWarmModal .slbWarmBody{padding:12px 14px;display:flex;flex-direction:column;gap:10px;flex:1;overflow:auto;overscroll-behavior:contain;}" +
      "#slbWarmModal .slbWarmStatus{font-weight:700;opacity:.95;}" +
      "#slbWarmModal .slbWarmHero{border:1px solid rgba(255,255,255,.12);border-radius:12px;overflow:hidden;background:rgba(0,0,0,.28);position:relative;}#slbWarmModal .slbWarmHero:after{content:\"\";position:absolute;inset:0;background:linear-gradient(180deg,rgba(0,0,0,.10),rgba(0,0,0,.35));pointer-events:none;}#slbWarmModal .slbWarmHero img{width:100%;height:min(220px,26svh);object-fit:contain;display:block;opacity:.92;filter:saturate(.95) contrast(.96);transition:opacity .55s ease,transform .55s ease;}#slbWarmModal .slbWarmDoneScreen{display:none;border:1px solid rgba(255,255,255,.12);border-radius:12px;background:#000;min-height:140px;padding:18px;align-items:center;justify-content:center;text-align:center;}#slbWarmModal .slbWarmDoneMsg{font-weight:900;font-size:16px;line-height:1.35;letter-spacing:.2px;}#slbWarmModal.done .slbWarmHero img{opacity:0;transform:scale(.985);}#slbWarmModal.done .slbWarmDoneScreen{display:flex;}#slbWarmModal.done .slbWarmProg,#slbWarmModal.done .slbWarmLog{display:none;}#slbWarmModal .slbWarmActions{display:flex;align-items:center;gap:8px;}#slbWarmModal .slbWarmToggle{background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.16);color:#fff;border-radius:10px;padding:6px 10px;font-weight:800;cursor:pointer;font-size:12px;opacity:.95;}#slbWarmModal .slbWarmToggle:active{transform:translateY(1px);}#slbWarmModal .slbWarmToggle[aria-pressed=\"true\"]{background:rgba(239,94,20,.22);border-color:rgba(239,94,20,.55);}#slbWarmModal .slbWarmLog{font-family:ui-monospace,Consolas,monospace;font-size:12px;line-height:1.35;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.10);border-radius:10px;padding:10px;overflow:auto;min-height:140px;max-height:42vh;white-space:pre-wrap;display:none;}#slbWarmModal.showLog .slbWarmLog{display:block;}" +
      "#slbWarmModal .slbWarmLine.warn{color:#ffd27d;}" +
      "#slbWarmModal .slbWarmFoot{padding:12px 14px;border-top:1px solid rgba(255,255,255,.10);display:flex;justify-content:flex-end;}" +
      "#slbWarmModal .slbWarmDoneBtn{background:#ef5e14;color:#fff;border:0;border-radius:10px;padding:8px 12px;font-weight:800;cursor:pointer;}" +
      "#slbWarmModal .slbWarmDoneBtn:active{transform:translateY(1px);}#slbWarmModal .slbWarmProg{display:flex;align-items:center;gap:10px;}#slbWarmModal .slbWarmProgBar{flex:1;height:10px;background:rgba(255,255,255,.10);border-radius:999px;overflow:hidden;border:1px solid rgba(255,255,255,.12);}#slbWarmModal .slbWarmProgFill{height:100%;width:0%;border-radius:999px;background:linear-gradient(90deg,#ef5e14,#ff8a55,#ef5e14);background-size:240px 100%;animation:slbWarmShine 1.4s linear infinite;transition:width .25s ease;}#slbWarmModal .slbWarmProgText{font-size:12px;opacity:.9;min-width:110px;text-align:right;font-variant-numeric:tabular-nums;}@keyframes slbWarmShine{0%{background-position:-120px 0}100%{background-position:240px 0}}";
    document.head.appendChild(st);
  }
}catch(e){}
    m.innerHTML = ''+
      '<div class="slbWarmCard">'+
        '<div class="slbWarmHead">'+
          '<div class="slbWarmTitle" id="slbWarmTitle">Supercharge</div>'+
          '<div class="slbWarmActions">'+
            '<button class="slbWarmToggle" type="button" aria-pressed="false">Details</button>'+
            '<button class="slbWarmClose" type="button" aria-label="Close">×</button>'+
          '</div>'+
        '</div>'+
        '<div class="slbWarmBody">'+
          '<div class="slbWarmHero"><img id="slbWarmHeroImg" alt="Supercharge" loading="lazy" decoding="async" src="https://cdn.shopify.com/s/files/1/1299/3411/files/SLB_supercharge_tyl_soft_640_small_2d3e4218-5ccb-477a-95e4-cbd71af8d2af.gif?v=1771245063"></div><div class="slbWarmDoneScreen" id="slbWarmDoneScreen"><div class="slbWarmDoneMsg">Supercharge completed!<br>You may now return back to SLB.</div></div>'+
          '<div class="slbWarmStatus" id="slbWarmStatus" role="status" aria-live="polite" aria-atomic="true">Supercharging your SLB…</div>'+ 
          '<div class="slbWarmProg" id="slbWarmProgress" role="progressbar" aria-labelledby="slbWarmStatus" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><div class="slbWarmProgBar"><div class="slbWarmProgFill" id="slbWarmProgFill"></div></div><div class="slbWarmProgText" id="slbWarmProgText">0 / 0 (0%)</div></div>'+          '<div class="slbWarmLog" id="slbWarmLog"></div>'+
        '</div>'+
        '<div class="slbWarmFoot">'+
          '<button class="btn ghost slbWarmDoneBtn" type="button">Close</button>'+
        '</div>'+
      '</div>';
    document.body.appendChild(m);

    function close_(){
      if(__SLB_WARM_BUSY__) return;
      m.style.display = 'none';
      m.setAttribute('aria-hidden','true');
      if(typeof __SLB_WARM_TRAP_RELEASE__ === 'function'){
        try{ __SLB_WARM_TRAP_RELEASE__(true); }catch(_e){}
      }
      __SLB_WARM_TRAP_RELEASE__ = null;
      try{ if(window.SLB && SLB.a11y) SLB.a11y.announce('Supercharge closed'); }catch(_e){}
    }
    m.addEventListener('click', function(e){
      if(e.target === m) close_();
    });
    m.querySelector('.slbWarmClose').addEventListener('click', close_);
    var tg = m.querySelector('.slbWarmToggle');
    if(tg){
      tg.addEventListener('click', function(){
        var on = !m.classList.contains('showLog');
        if(on) m.classList.add('showLog'); else m.classList.remove('showLog');
        tg.setAttribute('aria-pressed', on ? 'true' : 'false');
        tg.textContent = on ? 'Hide details' : 'Details';
      });
    }
    m.querySelector('.slbWarmDoneBtn').addEventListener('click', close_);
    return m;
  }

  function warmSanitizeText_(s){
    try{
      s = String(s==null ? '' : s);
      // Strip ANSI color codes and other control chars that can show as "alien text"
      s = s.replace(/\u001b\[[0-9;]*m/g, '');
      s = s.replace(/[\u0000-\u0008\u000b-\u001f\u007f]/g, '');
      return s;
    }catch(_e){ return String(s||''); }
  }

  function warmLog_(line, kind){
    line = warmSanitizeText_(line);
    var box = document.getElementById('slbWarmLog');
    if(!box) return;
    var div = document.createElement('div');
    div.className = 'slbWarmLine' + (kind ? (' ' + kind) : '');
    div.textContent = line;
    box.appendChild(div);
    box.scrollTop = box.scrollHeight;
  }

  function warmSetStatus_(t){
    var el = document.getElementById('slbWarmStatus');
    if(el) el.textContent = warmSanitizeText_(t);
  }

  function warmShowCompleted_(){
    try{
      var m = document.getElementById('slbWarmModal');
      if(!m) return;
      // fade gif then show a clean completion screen
      requestAnimationFrame(function(){ m.classList.add('done'); });
      var st = document.getElementById('slbWarmStatus');
      if(st) st.textContent = '';
    }catch(_e){}
  }

  var __SLB_WARM_TOTAL__ = 0;
  var __SLB_WARM_DONE__  = 0;

  function warmSetProgress_(done, total){
    try{
      var fill = document.getElementById('slbWarmProgFill');
      var txt  = document.getElementById('slbWarmProgText');
      var prog = document.getElementById('slbWarmProgress');
      total = Number(total||0);
      done  = Number(done||0);
      if(total <= 0){
        if(fill) fill.style.width = '0%';
        if(txt) txt.textContent = '';
        if(prog) prog.setAttribute('aria-valuenow','0');
        return;
      }
      if(done < 0) done = 0;
      if(done > total) done = total;
      var pct = Math.max(0, Math.min(100, Math.round((done/total)*100)));
      if(fill) fill.style.width = pct + '%';
      if(txt) txt.textContent = done + ' / ' + total + ' (' + pct + '%)';
      if(prog){
        prog.setAttribute('aria-valuenow', String(pct));
        prog.setAttribute('aria-valuetext', done + ' of ' + total + ', ' + pct + ' percent');
      }
    }catch(_e){}
  }

  function warmProgInit_(total){
    __SLB_WARM_TOTAL__ = Number(total||0);
    __SLB_WARM_DONE__ = 0;
    warmSetProgress_(__SLB_WARM_DONE__, __SLB_WARM_TOTAL__);
  }

  function warmProgTick_(){
    __SLB_WARM_DONE__++;
    warmSetProgress_(__SLB_WARM_DONE__, __SLB_WARM_TOTAL__);
  }

  function warmSleep_(ms){
    return new Promise(function(res){ setTimeout(res, ms); });
  }

  function warmWithTimeout_(p, ms){
    return Promise.race([
      p,
      new Promise(function(_, rej){
        setTimeout(function(){ rej(new Error('timeout')); }, ms);
      })
    ]);
  }

  // Supercharge speed controls. Default is now a safe "smart" mode:
  // cache active/recent material first, not every heavy historical record.
  function warmIntOpt_(key, def, min, max){
    try{
      var n = Number(localStorage.getItem(key));
      if(isFinite(n) && n >= min) return Math.max(min, Math.min(max, n));
    }catch(_e){}
    return Math.max(min, Math.min(max, Number(def)||min));
  }
  function warmSmartMode_(){
    try{
      var m = String(localStorage.getItem('slb_warm_mode') || '').trim().toLowerCase();
      if(m === 'deep' || m === 'full') return false;
    }catch(_e){}
    return true;
  }
  function warmCheckpointLoad_(){
    try{
      var raw = localStorage.getItem('slb_supercharge_state_v2') || '';
      var data = raw ? JSON.parse(raw) : null;
      return data && typeof data === 'object' ? data : {};
    }catch(_e){ return {}; }
  }
  function warmCheckpointId_(){
    var build = String(window.SLB_BUILD_VERSION || window.__SLB_BUILD_VERSION__ || 'UNKNOWN');
    var callsign = String(warmGetCallsign_() || 'ANON').toUpperCase();
    return build + '|' + callsign;
  }
  function warmCheckpointFresh_(part, maxAgeMs){
    try{
      var data = warmCheckpointLoad_();
      var row = data[warmCheckpointId_()] || {};
      var at = Number(row[String(part || '')] || 0);
      return !!(at && (Date.now() - at) < Number(maxAgeMs || 0));
    }catch(_e){ return false; }
  }
  function warmCheckpointMark_(part){
    try{
      var data = warmCheckpointLoad_();
      var id = warmCheckpointId_();
      var row = data[id] && typeof data[id] === 'object' ? data[id] : {};
      row[String(part || '')] = Date.now();
      data[id] = row;
      var ids = Object.keys(data).sort(function(a,b){
        var av = Math.max(Number(data[a].assets||0), Number(data[a].data||0));
        var bv = Math.max(Number(data[b].assets||0), Number(data[b].data||0));
        return bv - av;
      });
      ids.slice(8).forEach(function(k){ delete data[k]; });
      localStorage.setItem('slb_supercharge_state_v2', JSON.stringify(data));
    }catch(_e){}
  }
  function warmAssetsFreshMs_(){ return 7 * 24 * 60 * 60 * 1000; }
  function warmDataFreshMs_(){
    return warmIntOpt_('slb_warm_refresh_minutes', 30, 5, 720) * 60 * 1000;
  }
  function warmShouldRunAdminSweep_(){
    try{
      var mode = String(localStorage.getItem('slb_warm_mode') || '').trim().toLowerCase();
      var adminMode = String(localStorage.getItem('slb_warm_admin_inbox_mode') || '').trim().toLowerCase();
      return (mode === 'deep' || mode === 'full') && (adminMode === 'deep' || adminMode === 'full');
    }catch(_e){ return false; }
  }
  function warmAdminInboxMode_(){
    // Smart Supercharge should make inboxes open faster, not spend minutes
    // waiting on slow per-person admin lists. Default admin warmup now caches
    // roster/stats only. Optional modes:
    //   localStorage.slb_warm_admin_inbox_mode = 'lists'  -> warm a few lists
    //   localStorage.slb_warm_admin_inbox_mode = 'deep'   -> old wider sweep
    try{
      var m = String(localStorage.getItem('slb_warm_admin_inbox_mode') || '').trim().toLowerCase();
      if(m === 'deep' || m === 'full') return 'deep';
      if(m === 'list' || m === 'lists' || m === 'smart-lists' || m === 'smart_lists') return 'lists';
      if(m === 'off' || m === 'skip' || m === 'none') return 'skip';
    }catch(_e){}
    return warmSmartMode_() ? 'stats' : 'deep';
  }
  function warmShouldWarmAdminLists_(kind){
    var m = warmAdminInboxMode_();
    if(m === 'deep' || m === 'lists') return true;
    try{
      // Per-inbox override for testing, e.g. slb_warm_diary_lists = 1
      var v = String(localStorage.getItem('slb_warm_' + String(kind||'') + '_lists') || '').trim().toLowerCase();
      if(v === '1' || v === 'yes' || v === 'true') return true;
    }catch(_e){}
    return false;
  }
  function warmDefaultActiveMax_(kind){
    // Deep mode keeps the old wider sweep. Optional list mode warms only a few
    // recent callsigns; stats mode skips per-callsign lists entirely.
    var m = warmAdminInboxMode_();
    if(m === 'deep' || !warmSmartMode_()) return 40;
    if(String(kind||'').toLowerCase() === 'diary') return 3;
    return 4;
  }
  function warmDefaultFullMax_(kind, maxLists){
    var m = warmAdminInboxMode_();
    if(m === 'deep' || !warmSmartMode_()) return Number(maxLists)||40;
    return 0;
  }
  function warmGetMaxLists_(kind){
    return warmIntOpt_('slb_warm_' + kind + '_active_max', warmDefaultActiveMax_(kind), 1, 80);
  }
  function warmGetMaxFull_(kind, maxLists){
    return warmIntOpt_('slb_warm_' + kind + '_full_max', warmDefaultFullMax_(kind, maxLists), 0, Math.max(0, Number(maxLists)||0));
  }
  function warmRpcTimeoutMs_(){
    return warmIntOpt_('slb_warm_rpc_timeout_ms', warmSmartMode_() ? 12000 : 20000, 4000, 60000);
  }
  function warmAssetTimeoutMs_(){
    return warmIntOpt_('slb_warm_asset_timeout_ms', warmSmartMode_() ? 8000 : 20000, 3000, 40000);
  }
  function warmCallRpcTimed_(action, payload, ms){
    return warmWithTimeout_(warmCallRpc_(action, payload), ms || warmRpcTimeoutMs_());
  }

  
  function warmNormalizeAssetUrl_(u){
    try{
      u = String(u||'');
      if(!u) return u;
      // Match loader behavior: add &v=BUILD to module URLs so prefetch hits same URL.
      if(u.indexOf('/assets/') !== -1 && (u.indexOf('slb.') !== -1 || u.indexOf('saamlawbank') !== -1)){
        if(u.indexOf('&v=') === -1){
          var bv = (window.SLB_BUILD_VERSION || window.__SLB_BUILD_VERSION__ || 'UNKNOWN');
          if(u.indexOf('?') === -1) u += '?';
          if(u.slice(-1) !== '?' && u.slice(-1) !== '&') u += '&';
          u += 'v=' + encodeURIComponent(String(bv));
        }
      }
    }catch(_e){}
    return u;
  }

function warmCollectAssetUrls_(){
    var urls = [];
    try{
      // main SLB scripts currently on the page
      var scripts = document.querySelectorAll('script[src]');
      scripts.forEach(function(s){
        var u = s.getAttribute('src') || '';
        if(!u) return;
        if(u.indexOf('slb.') !== -1 || u.indexOf('saamlawbank') !== -1) urls.push(warmNormalizeAssetUrl_(u));
      });
      var links = document.querySelectorAll('link[rel="stylesheet"][href]');
      links.forEach(function(l){
        var u = l.getAttribute('href') || '';
        if(!u) return;
        if(u.indexOf('saamlawbank') !== -1 || u.indexOf('slb.') !== -1) urls.push(warmNormalizeAssetUrl_(u));
      });
    }catch(_e){}

    try{
      // extra known module assets (for pre-caching pages not currently loaded)
      var warmBtn = document.getElementById('slbWarmBtn');
      if(warmBtn){
        var u7 = warmBtn.getAttribute('data-magic7-url') || '';
        if(u7) urls.push(warmNormalizeAssetUrl_(u7));
        var uDi = warmBtn.getAttribute('data-diaryinbox-url') || '';
        if(uDi) urls.push(warmNormalizeAssetUrl_(uDi));
        var uLi = warmBtn.getAttribute('data-lettersinbox-url') || '';
        if(uLi) urls.push(warmNormalizeAssetUrl_(uLi));
        var uCmrI = warmBtn.getAttribute('data-cmrinbox-url') || '';
        if(uCmrI) urls.push(warmNormalizeAssetUrl_(uCmrI));
        var uSdrI = warmBtn.getAttribute('data-sdrinbox-url') || '';
        if(uSdrI) urls.push(warmNormalizeAssetUrl_(uSdrI));
        var uSwrI = warmBtn.getAttribute('data-swrinbox-url') || '';
        if(uSwrI) urls.push(warmNormalizeAssetUrl_(uSwrI));
        var uDcrI = warmBtn.getAttribute('data-dcrinbox-url') || '';
        if(uDcrI) urls.push(warmNormalizeAssetUrl_(uDcrI));
        var uDdrI = warmBtn.getAttribute('data-ddrinbox-url') || '';
        if(uDdrI) urls.push(warmNormalizeAssetUrl_(uDdrI));
}
    }catch(_e2){}

    // de-dupe
    var seen = {};
    var out = [];
    urls.forEach(function(u){
      if(seen[u]) return;
      seen[u] = 1;
      out.push(u);
    });
    return out;
  }

  async function warmFetchAssets_(){
    var urls = warmCollectAssetUrls_();
    if(!urls.length){
      warmLog_('No assets detected on this page.', 'warn');
      return;
    }
    warmSetStatus_('Supercharging assets…');
    warmLog_('Assets: '+urls.length);
    var ok=0, bad=0;
    var timeoutMs = warmAssetTimeoutMs_();
    // Assets can be warmed safely in small parallel batches. This avoids waiting
    // 20 seconds one-by-one when one CDN/asset request is slow.
    for(var i=0;i<urls.length;i+=4){
      var batch = urls.slice(i, i+4);
      await Promise.all(batch.map(async function(u, j){
        try{
          await warmWithTimeout_(fetch(u, { credentials:'same-origin', cache:'force-cache' }), timeoutMs);
          ok++;
          warmLog_('✔ '+u);
        }catch(e){
          bad++;
          warmLog_('✖ '+u+' ('+(e && e.message ? e.message : 'fail')+')', 'warn');
        }
        warmProgTick_();
        warmSetStatus_('Supercharging assets… ' + Math.min(urls.length, i+j+1) + '/' + urls.length);
      }));
      await warmSleep_(30);
    }
    warmLog_('Assets warmed: '+ok+' ok, '+bad+' failed.');
    return true;
  }

  async function warmWaitForRpc_(){
    var t0 = Date.now();
    var waitMax = warmSmartMode_() ? 12000 : 60000;
    while(Date.now() - t0 < waitMax){
      if(window.SLB_APP && typeof window.SLB_APP.rpc === 'function') return true;
      await warmSleep_(150);
    }
    return false;
  }

  // Use the main SLB RPC transport for warm-up calls.
  // - Prefer SLB_APP.rpc (supports chunk transport + retry wrapper)
  // - Fallback to TYW.rpc if needed
  // - Keep it silent (no noisy progress UI) during warm-up
  async function warmCallRpc_(action, payload){
    payload = payload || {};
    // Do not leak internal warm capture markers to backend
    try{ if(payload && typeof payload === 'object' && payload.__warm_capture) payload = Object.assign({}, payload), delete payload.__warm_capture; }catch(_e){}

    var fn = null;
    var ctx = null;
    if(window.SLB_APP && typeof window.SLB_APP.rpc === 'function') { fn = window.SLB_APP.rpc; ctx = window.SLB_APP; }
    else if(window.TYW && typeof window.TYW.rpc === 'function') { fn = window.TYW.rpc; ctx = window.TYW; }
    if(!fn) throw new Error('warmCallRpc_: rpc not ready');

    // Keep warm-up silent and out of the global Retry/Reload system.
    // Do not retry without noGlobalRetry; a backend timeout would otherwise create the annoying bar.
    return await fn.call(ctx, action, Object.assign({}, payload || {}, { __slbNoGlobalRetry: true }), { progressMode: 'silent', noGlobalRetry: true, timeoutMs: 20000 });
  }


  function warmAuthCallsign_(){
    try{
      var cs0 = String(sessionStorage.getItem('tyw_callsign')||'').trim().toUpperCase();
      if(cs0) return cs0;
    }catch(_e0){}
    try{
      var raw = localStorage.getItem('ty_auth_v1') || '';
      if(raw){
        var a = JSON.parse(raw);
        var cs1 = String((a && (a.callsign||a.cs)) ? (a.callsign||a.cs) : '').trim().toUpperCase();
        if(cs1) return cs1;
      }
    }catch(_e1){}
    return '';
  }
  function warmPageCacheSet_(name, data){
    if(/admin|inbox|diary|letter|cmr|sdr|swr|dcr|ddr|disciple|roster|dashboard|txn|temple/i.test(String(name||''))) return;
    try{
      var cs = warmAuthCallsign_() || 'ANON';
      var k = 'slb_pagecache_v1_' + cs + ':' + String(name||'');
      localStorage.setItem(k, JSON.stringify({ ts: Date.now(), data: data }));
    }catch(_e){}
  }
  function warmToB64wsUtf8_(str){
    str = String(str==null?'':str);
    try{
      if(window.TextEncoder){
        var bytes = new TextEncoder().encode(str);
        var bin = '';
        var CHUNK = 0x8000;
        for(var i=0;i<bytes.length;i+=CHUNK){ bin += String.fromCharCode.apply(null, bytes.subarray(i, i+CHUNK)); }
        return btoa(bin).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
      }
    }catch(_e){}
    try{ return btoa(unescape(encodeURIComponent(str))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,''); }catch(_e2){ return ''; }
  }
  function warmData_(res){
    try{ return (res && (res.result || res.data || res)) || null; }catch(_e){ return res || null; }
  }
  function warmItems_(res){
    var d = warmData_(res);
    if(Array.isArray(d)) return d;
    if(d && Array.isArray(d.items)) return d.items;
    if(d && Array.isArray(d.stats)) return d.stats;
    if(d && Array.isArray(d.in)) return d.in;
    return [];
  }
  function warmRoster_(res){
    var arr = warmItems_(res);
    return (arr||[]).map(function(x){
      var cs = String((x && (x.callsign||x.callSign||x.cs)) || '').trim().toUpperCase();
      if(!cs) return null;
      var dn = String((x && (x.displayName||x.name||x.fullName||x.legalName)) || '').trim();
      return { callsign: cs, displayName: dn };
    }).filter(Boolean).sort(function(a,b){ return String(a.callsign).localeCompare(String(b.callsign)); });
  }
  function warmDateMs_(iso){
    try{ var d = new Date(String(iso||'')); var t = d.getTime(); return isFinite(t) ? t : 0; }catch(_e){ return 0; }
  }
  function warmDateKeyMs_(dk){
    try{
      dk = String(dk||'');
      var m = /^(\d{4})[-\/]?(\d{2})[-\/]?(\d{2})/.exec(dk);
      if(!m) return 0;
      return new Date(Number(m[1]), Number(m[2])-1, Number(m[3]), 23, 59, 59).getTime() || 0;
    }catch(_e){ return 0; }
  }
  function warmStatMs_(st){
    st = st || {};
    return warmDateMs_(st.lastUpdatedAt || st.updatedAt || st.updated || '') || warmDateKeyMs_(st.lastDateKey || st.dateKey || '');
  }
  function warmActiveDiaryCallsigns_(items, max){
    var now = Date.now();
    max = Math.max(1, Math.min(60, Number(max||24)||24));
    return (items||[]).map(function(x){
      var cs = String((x && (x.callsign||x.callSign||x.cs)) || '').trim().toUpperCase();
      if(!cs) return null;
      var t = warmStatMs_(x||{});
      var active = !!((x && (x.unread || x.pending)) || (t && (now - t) >= 0 && (now - t) <= 14*24*60*60*1000));
      if(!active) return null;
      return { cs: cs, t: t||0, p: (x && x.unread) ? 0 : ((x && x.pending) ? 1 : 2) };
    }).filter(Boolean).sort(function(a,b){ if(a.p!==b.p) return a.p-b.p; return b.t-a.t; }).slice(0,max).map(function(x){ return x.cs; });
  }
  function warmNewestIso_(items){
    var best = 0, iso = '';
    (items||[]).forEach(function(it){
      var v = String((it && (it.updatedAt||it.createdAt||it.modifiedAt)) || '');
      var t = warmDateMs_(v);
      if(t > best){ best = t; iso = v; }
    });
    return iso;
  }
  function warmNewestDateKey_(items){
    var best = 0, dk = '';
    (items||[]).forEach(function(it){
      var v = String((it && it.dateKey) || '');
      var t = warmDateKeyMs_(v);
      if(t > best){ best = t; dk = v; }
    });
    return dk;
  }
  async function warmDiaryInboxCache_(){
    try{
      if(!warmIsAdmin_()){ warmLog_('Diary Inbox cache skipped: not admin.'); return; }
      var adminCs = warmAuthCallsign_();
      if(!adminCs){ warmLog_('Diary Inbox cache skipped: not logged in.', 'warn'); return; }
      warmSetStatus_('Supercharging Diary Inbox cache…');
      warmLog_('Diary Inbox: roster + active 14-day diary cache…');

      var rosterRes = await warmCallRpcTimed_('adminDiscipleList', { includeOut:false, limit:10000 });
      var roster = warmRoster_(rosterRes);
      if(roster.length){ warmPageCacheSet_('diaryInboxRoster_' + adminCs, { items: roster }); }
      warmLog_('✔ diary roster cached: ' + roster.length);

      var statsRes = await warmCallRpcTimed_('diaryInboxStats', { recentOnly:true, activeDays:14, days:14 });
      var stats = warmItems_(statsRes);
      if(stats.length){ warmPageCacheSet_('diaryInboxStats_' + adminCs, { items: stats }); }
      warmLog_('✔ diary active stats cached: ' + stats.length);

      if(warmAdminInboxMode_() === 'skip'){ warmLog_('Diary Inbox smart mode: roster + active stats cached; per-callsign warmup skipped.'); return; }
      if(!warmShouldWarmAdminLists_('diary')){ warmLog_('Diary Inbox smart mode: roster + active stats cached; slow per-callsign diary lists skipped.'); return; }

      var maxLists = warmGetMaxLists_('diary');
      var maxFull = warmGetMaxFull_('diary', maxLists);
      var calls = warmActiveDiaryCallsigns_(stats, maxLists);
      if(!calls.length){ warmLog_('Diary Inbox: no active 14-day callsigns to cache.'); return; }

      var okList = 0, okEntry = 0, bad = 0, timeoutBad = 0;
      for(var i=0;i<calls.length;i++){
        var cs = calls[i];
        try{
          warmSetStatus_('Supercharging Diary Inbox… ' + (i+1) + '/' + calls.length + ' ' + cs);
          var listRes = await warmCallRpcTimed_('diaryList', { callsign: cs, limit:(warmSmartMode_()?120:300), includeRich:false, includeEntryFlags:true }, warmSmartMode_()?6000:undefined);
          var items = warmItems_(listRes);
          if(items && items.length){
            warmPageCacheSet_('diaryList_' + cs, { items: items, savedAt: new Date().toISOString(), newestUpdatedAt: warmNewestIso_(items), newestDateKey: warmNewestDateKey_(items) });
            okList++;
            var dk = String((items[0] && items[0].dateKey) || '').trim();
            if(dk && i < maxFull){
              try{
                var getRes = await warmCallRpcTimed_('diaryGet', { callsign: cs, dateKey: dk }, warmSmartMode_()?6000:undefined);
                var data = warmData_(getRes);
                var it = data && (data.item || data.entry || data);
                if(it && typeof it === 'object'){
                  warmPageCacheSet_('diaryEntry_' + cs + '_' + warmToB64wsUtf8_(dk), { item: it, savedAt: new Date().toISOString(), updatedAt: String(it.updatedAt||it.createdAt||'') });
                  okEntry++;
                }
              }catch(eGet){ warmLog_('• diary latest entry skipped ' + cs + ' (' + (eGet && eGet.message ? eGet.message : 'fail') + ')', 'warn'); }
            }
            warmLog_('✔ diary ' + cs + ' list cached: ' + items.length);
          }else{
            warmLog_('• diary ' + cs + ' no rows returned');
          }
        }catch(eOne){
          bad++;
          if(eOne && /timeout/i.test(String(eOne.message||''))) timeoutBad++;
          warmLog_('✖ diary ' + cs + ' (' + (eOne && eOne.message ? eOne.message : 'fail') + ')', 'warn');
          if(warmSmartMode_() && timeoutBad >= 2){
            warmLog_('Diary Inbox smart mode: stopping per-callsign warmup after 2 timeouts.', 'warn');
            break;
          }
        }
        if(i % 2 === 1) await warmSleep_(80);
      }
      warmLog_('Diary Inbox warmed: ' + okList + ' lists, ' + okEntry + ' latest full entries, ' + bad + ' failed.');
    }catch(e){
      warmLog_('Diary Inbox cache skipped: ' + (e && e.message ? e.message : 'error'), 'warn');
    }
  }

  function warmActiveCmrCallsigns_(items, max){
    var now = Date.now();
    max = Math.max(1, Math.min(80, Number(max||40)||40));
    return (items||[]).map(function(x){
      var cs = String((x && (x.callsign||x.callSign||x.cs)) || '').trim().toUpperCase();
      if(!cs) return null;
      var t = warmStatMs_(x||{});
      var active = !!(t && (now - t) >= 0 && (now - t) <= 14*24*60*60*1000);
      if(!active) return null;
      return { cs: cs, t: t||0 };
    }).filter(Boolean).sort(function(a,b){ return b.t-a.t; }).slice(0,max).map(function(x){ return x.cs; });
  }


  function warmLettersStatsMap_(items){
    var map = {};
    (items||[]).forEach(function(it){
      var cs = String((it && (it.callsign||it.callSign||it.cs)) || '').trim().toUpperCase();
      if(!cs) return;
      var t = warmDateMs_((it && (it.updatedAt||it.modifiedAt||it.createdAt)) || '') || warmDateKeyMs_((it && it.dateKey) || '');
      var cur = map[cs];
      if(!cur || t > warmStatMs_(cur)){
        map[cs] = {
          updatedAt: t || 0,
          lastUpdatedAt: String((it && (it.updatedAt||it.modifiedAt||it.createdAt)) || ''),
          lastDateKey: String((it && it.dateKey) || ''),
          lastEntryId: String((it && (it.entryId||it.entryID||it.id)) || ''),
          count: Number(cur && cur.count || 0) + 1
        };
      }else if(cur){
        cur.count = Number(cur.count||0) + 1;
      }
    });
    return map;
  }

  function warmActiveLettersCallsigns_(items, max){
    var now = Date.now();
    max = Math.max(1, Math.min(80, Number(max||40)||40));
    var seen = {};
    return (items||[]).map(function(x){
      var cs = String((x && (x.callsign||x.callSign||x.cs)) || '').trim().toUpperCase();
      if(!cs || seen[cs]) return null;
      seen[cs] = 1;
      var t = warmDateMs_((x && (x.updatedAt||x.modifiedAt||x.createdAt)) || '') || warmDateKeyMs_((x && x.dateKey) || '') || warmStatMs_(x||{});
      var active = !!(t && (now - t) >= 0 && (now - t) <= 14*24*60*60*1000);
      if(!active) return null;
      return { cs: cs, t: t||0 };
    }).filter(Boolean).sort(function(a,b){ return b.t-a.t; }).slice(0,max).map(function(x){ return x.cs; });
  }

  async function warmLettersInboxCache_(){
    try{
      if(!warmIsAdmin_()){ warmLog_('Letters Inbox cache skipped: not admin.'); return; }
      var adminCs = warmAuthCallsign_();
      if(!adminCs){ warmLog_('Letters Inbox cache skipped: not logged in.', 'warn'); return; }
      warmSetStatus_('Supercharging Letters Inbox cache…');
      warmLog_('Letters Inbox: active 14-day letter cache…');

      var statsRes = await warmCallRpcTimed_('adminLettersList', { limit:900, recentOnly:true, activeDays:14, days:14 });
      var statsItems = warmItems_(statsRes);
      if(!statsItems.length){
        try{
          var statsLegacy = await warmCallRpcTimed_('adminLettersList', { limit:900 });
          statsItems = warmItems_(statsLegacy);
        }catch(_eLegacy){}
      }
      var statsMap = warmLettersStatsMap_(statsItems);
      if(Object.keys(statsMap).length){ warmPageCacheSet_('lettersInboxStats_' + adminCs, { map: statsMap, savedAt: new Date().toISOString() }); }
      warmLog_('✔ Letters active stats cached: ' + Object.keys(statsMap).length);

      if(warmAdminInboxMode_() === 'skip'){ warmLog_('Letters Inbox smart mode: active stats cached; per-callsign warmup skipped.'); return; }
      if(!warmShouldWarmAdminLists_('letters')){ warmLog_('Letters Inbox smart mode: active stats cached; per-callsign letter lists skipped.'); return; }

      var maxLists = warmGetMaxLists_('letters');
      var maxFull = warmGetMaxFull_('letters', maxLists);
      var calls = warmActiveLettersCallsigns_(statsItems, maxLists);
      if(!calls.length){ warmLog_('Letters Inbox: no active 14-day callsigns to cache.'); return; }

      var okList = 0, okEntry = 0, bad = 0, timeoutBad = 0;
      for(var i=0;i<calls.length;i++){
        var cs = calls[i];
        try{
          warmSetStatus_('Supercharging Letters Inbox… ' + (i+1) + '/' + calls.length + ' ' + cs);
          var listRes = await warmCallRpcTimed_('adminLettersList', { filterCallsign: cs, limit:(warmSmartMode_()?120:300), includeRich:false }, warmSmartMode_()?6000:undefined);
          var items = warmItems_(listRes).filter(function(it){ return String((it && it.callsign) || '').trim().toUpperCase() === cs; });
          if(items && items.length){
            warmPageCacheSet_('lettersInboxList_' + cs, { items: items, savedAt: new Date().toISOString(), newestUpdatedAt: warmNewestIso_(items), newestDateKey: warmNewestDateKey_(items) });
            okList++;
            var eid = String((items[0] && (items[0].entryId || items[0].entryID || items[0].id)) || '').trim();
            if(eid && i < maxFull){
              try{
                var getRes = await warmCallRpcTimed_('adminLettersGet', { entryId: eid }, warmSmartMode_()?6000:undefined);
                var data = warmData_(getRes);
                var it = data && (data.item || data.entry || data);
                if(it && typeof it === 'object'){
                  warmPageCacheSet_('lettersInboxEntry_' + cs + '_' + warmToB64wsUtf8_(eid), { item: it, savedAt: new Date().toISOString(), updatedAt: String(it.updatedAt||it.createdAt||'') });
                  okEntry++;
                }
              }catch(eGet){ warmLog_('• Letters latest entry skipped ' + cs + ' (' + (eGet && eGet.message ? eGet.message : 'fail') + ')', 'warn'); }
            }
            warmLog_('✔ Letters ' + cs + ' list cached: ' + items.length);
          }else{
            warmLog_('• Letters ' + cs + ' no rows returned');
          }
        }catch(eOne){
          bad++;
          if(eOne && /timeout/i.test(String(eOne.message||''))) timeoutBad++;
          warmLog_('✖ Letters ' + cs + ' (' + (eOne && eOne.message ? eOne.message : 'fail') + ')', 'warn');
          if(warmSmartMode_() && timeoutBad >= 2){
            warmLog_('Letters Inbox smart mode: stopping per-callsign warmup after 2 timeouts.', 'warn');
            break;
          }
        }
        if(i % 2 === 1) await warmSleep_(80);
      }
      warmLog_('Letters Inbox warmed: ' + okList + ' lists, ' + okEntry + ' latest full entries, ' + bad + ' failed.');
    }catch(e){
      warmLog_('Letters Inbox cache skipped: ' + (e && e.message ? e.message : 'error'), 'warn');
    }
  }

  async function warmCmrInboxCache_(){
    try{
      if(!warmIsAdmin_()){ warmLog_('CMR Inbox cache skipped: not admin.'); return; }
      var adminCs = warmAuthCallsign_();
      if(!adminCs){ warmLog_('CMR Inbox cache skipped: not logged in.', 'warn'); return; }
      warmSetStatus_('Supercharging CMR Inbox cache…');
      warmLog_('CMR Inbox: active 14-day CMR cache…');

      var statsRes = await warmCallRpcTimed_('cmrInboxStats', { recentOnly:true, activeDays:14, days:14 });
      var stats = warmItems_(statsRes);
      if(!stats.length){
        try{
          var statsLegacy = await warmCallRpcTimed_('cmrInboxStats', {});
          stats = warmItems_(statsLegacy);
        }catch(_eLegacy){}
      }
      if(stats.length){ warmPageCacheSet_('cmrInboxStats_' + adminCs, { items: stats, savedAt: new Date().toISOString() }); }
      warmLog_('✔ CMR active stats cached: ' + stats.length);

      if(warmAdminInboxMode_() === 'skip'){ warmLog_('CMR Inbox smart mode: active stats cached; per-callsign warmup skipped.'); return; }
      if(!warmShouldWarmAdminLists_('cmr')){ warmLog_('CMR Inbox smart mode: active stats cached; per-callsign CMR lists skipped.'); return; }

      var maxLists = warmGetMaxLists_('cmr');
      var maxFull = warmGetMaxFull_('cmr', maxLists);
      var calls = warmActiveCmrCallsigns_(stats, maxLists);
      if(!calls.length){ warmLog_('CMR Inbox: no active 14-day callsigns to cache.'); return; }

      var okList = 0, okEntry = 0, bad = 0, timeoutBad = 0;
      for(var i=0;i<calls.length;i++){
        var cs = calls[i];
        try{
          warmSetStatus_('Supercharging CMR Inbox… ' + (i+1) + '/' + calls.length + ' ' + cs);
          var listRes = await warmCallRpcTimed_('cmrList', { callsign: cs, limit:(warmSmartMode_()?120:300), includeRich:false }, warmSmartMode_()?6000:undefined);
          var items = warmItems_(listRes);
          if(items && items.length){
            warmPageCacheSet_('cmrInboxList_' + cs, { items: items, savedAt: new Date().toISOString(), newestUpdatedAt: warmNewestIso_(items), newestDateKey: warmNewestDateKey_(items) });
            okList++;
            var eid = String((items[0] && (items[0].entryId || items[0].entryID || items[0].id)) || '').trim();
            if(eid && i < maxFull){
              try{
                var getRes = await warmCallRpcTimed_('cmrGet', { callsign: cs, entryId: eid, includeRich:'1' }, warmSmartMode_()?6000:undefined);
                var data = warmData_(getRes);
                var it = data && (data.item || data.entry || data);
                if(it && typeof it === 'object'){
                  warmPageCacheSet_('cmrInboxEntry_' + cs + '_' + warmToB64wsUtf8_(eid), { item: it, savedAt: new Date().toISOString(), updatedAt: String(it.updatedAt||it.createdAt||'') });
                  okEntry++;
                }
              }catch(eGet){ warmLog_('• CMR latest entry skipped ' + cs + ' (' + (eGet && eGet.message ? eGet.message : 'fail') + ')', 'warn'); }
            }
            warmLog_('✔ CMR ' + cs + ' list cached: ' + items.length);
          }else{
            warmLog_('• CMR ' + cs + ' no rows returned');
          }
        }catch(eOne){
          bad++;
          if(eOne && /timeout/i.test(String(eOne.message||''))) timeoutBad++;
          warmLog_('✖ CMR ' + cs + ' (' + (eOne && eOne.message ? eOne.message : 'fail') + ')', 'warn');
          if(warmSmartMode_() && timeoutBad >= 2){
            warmLog_('CMR Inbox smart mode: stopping per-callsign warmup after 2 timeouts.', 'warn');
            break;
          }
        }
        if(i % 2 === 1) await warmSleep_(80);
      }
      warmLog_('CMR Inbox warmed: ' + okList + ' lists, ' + okEntry + ' latest full entries, ' + bad + ' failed.');
    }catch(e){
      warmLog_('CMR Inbox cache skipped: ' + (e && e.message ? e.message : 'error'), 'warn');
    }
  }

  function warmActiveReportCallsigns_(items, max){
    var now = Date.now();
    max = Math.max(1, Math.min(80, Number(max||40)||40));
    return (items||[]).map(function(x){
      var cs = String((x && (x.callsign||x.callSign||x.cs)) || '').trim().toUpperCase();
      if(!cs) return null;
      var t = warmStatMs_(x||{});
      var active = !!(t && (now - t) >= 0 && (now - t) <= 14*24*60*60*1000);
      if(!active) return null;
      return { cs: cs, t: t||0 };
    }).filter(Boolean).sort(function(a,b){ return b.t-a.t; }).slice(0,max).map(function(x){ return x.cs; });
  }

  async function warmReportInboxCache_(kind, label){
    try{
      if(!warmIsAdmin_()){ warmLog_(String(label||kind||'Report') + ' Inbox cache skipped: not admin.'); return; }
      kind = String(kind||'').trim().toLowerCase();
      label = String(label||kind.toUpperCase());
      var adminCs = warmAuthCallsign_();
      if(!adminCs){ warmLog_(label + ' Inbox cache skipped: not logged in.', 'warn'); return; }
      warmSetStatus_('Supercharging ' + label + ' Inbox cache…');
      warmLog_(label + ' Inbox: active 14-day cache…');

      var statsAction = kind + 'InboxStats';
      var listAction = kind + 'List';
      var getAction = kind + 'Get';

      var statsRes = await warmCallRpcTimed_(statsAction, { recentOnly:true, activeDays:14, days:14 });
      var stats = warmItems_(statsRes);
      if(!stats.length){
        try{
          var statsLegacy = await warmCallRpcTimed_(statsAction, {});
          stats = warmItems_(statsLegacy);
        }catch(_eLegacy){}
      }
      if(stats.length){ warmPageCacheSet_(kind + 'InboxStats_' + adminCs, { items: stats, savedAt: new Date().toISOString() }); }
      warmLog_('✔ ' + label + ' active stats cached: ' + stats.length);

      if(warmAdminInboxMode_() === 'skip'){ warmLog_(label + ' Inbox smart mode: active stats cached; per-callsign warmup skipped.'); return; }
      if(!warmShouldWarmAdminLists_(kind)){ warmLog_(label + ' Inbox smart mode: active stats cached; per-callsign lists skipped.'); return; }

      var maxLists = warmGetMaxLists_(kind);
      var maxFull = warmGetMaxFull_(kind, maxLists);
      var calls = warmActiveReportCallsigns_(stats, maxLists);
      if(!calls.length){ warmLog_(label + ' Inbox: no active 14-day callsigns to cache.'); return; }

      var okList = 0, okEntry = 0, bad = 0, timeoutBad = 0;
      for(var i=0;i<calls.length;i++){
        var cs = calls[i];
        try{
          warmSetStatus_('Supercharging ' + label + ' Inbox… ' + (i+1) + '/' + calls.length + ' ' + cs);
          var listRes = await warmCallRpcTimed_(listAction, { callsign: cs, limit:(warmSmartMode_()?120:300), includeRich:false }, warmSmartMode_()?6000:undefined);
          var items = warmItems_(listRes);
          if(items && items.length){
            warmPageCacheSet_(kind + 'InboxList_' + cs, { items: items, savedAt: new Date().toISOString(), newestUpdatedAt: warmNewestIso_(items), newestDateKey: warmNewestDateKey_(items) });
            okList++;
            var eid = String((items[0] && (items[0].entryId || items[0].entryID || items[0].id)) || '').trim();
            if(eid && i < maxFull){
              try{
                var getRes = await warmCallRpcTimed_(getAction, { callsign: cs, entryId: eid, includeRich:'1' }, warmSmartMode_()?6000:undefined);
                var data = warmData_(getRes);
                var it = data && (data.item || data.entry || data);
                if(it && typeof it === 'object'){
                  warmPageCacheSet_(kind + 'InboxEntry_' + cs + '_' + warmToB64wsUtf8_(eid), { item: it, savedAt: new Date().toISOString(), updatedAt: String(it.updatedAt||it.modifiedAt||it.createdAt||'') });
                  okEntry++;
                }
              }catch(eGet){ warmLog_('• ' + label + ' latest entry skipped ' + cs + ' (' + (eGet && eGet.message ? eGet.message : 'fail') + ')', 'warn'); }
            }
            warmLog_('✔ ' + label + ' ' + cs + ' list cached: ' + items.length);
          }else{
            warmLog_('• ' + label + ' ' + cs + ' no rows returned');
          }
        }catch(eOne){
          bad++;
          if(eOne && /timeout/i.test(String(eOne.message||''))) timeoutBad++;
          warmLog_('✖ ' + label + ' ' + cs + ' (' + (eOne && eOne.message ? eOne.message : 'fail') + ')', 'warn');
          if(warmSmartMode_() && timeoutBad >= 2){
            warmLog_(label + ' Inbox smart mode: stopping per-callsign warmup after 2 timeouts.', 'warn');
            break;
          }
        }
        if(i % 2 === 1) await warmSleep_(80);
      }
      warmLog_(label + ' Inbox warmed: ' + okList + ' lists, ' + okEntry + ' latest full entries, ' + bad + ' failed.');
    }catch(e){
      warmLog_(String(label||'Report') + ' Inbox cache skipped: ' + (e && e.message ? e.message : 'error'), 'warn');
    }
  }




  function warmRpcPlan_(){
    return [
      ['ping', {}],
      ['annivList', {}],
      ['letterGodsList', {}],
      ['notifyPrefsGet', {}],
      ['cultGetTypes', {}],
      ['magic7Bootstrap', {}],
      ['magic7ToolsTargetsList', {__warm_capture:'magic7Targets'}]
    ];
  }

  function warmTabPlan_(){
    // Normal Supercharge never clicks through SLB pages. Page walking was the
    // biggest fixed-delay source and could trigger heavy inbox initializers.
    // A manual deep diagnostic run remains available through slb_warm_ui_mode=deep.
    try{
      var mode = String(localStorage.getItem('slb_warm_ui_mode') || '').trim().toLowerCase();
      if(mode === 'deep' || mode === 'full'){
        return warmFilterAdminTabs_([
          ['chat', 2200],
          ['cult', 1800],
          ['library', 2000],
          ['stars9Div', 2400],
          ['stars9Review', 2400],
          ['stars7Portal', 2600],
          ['treasury', 2200],
          ['treasures', 2200],
          ['anniv', 2000],
          ['myCabin', 900]
        ]);
      }
    }catch(_e){}
    return [];
  }


	async function warmRpcBatch_(){
    warmSetStatus_('Supercharging data…');
    var ready = await warmWaitForRpc_();
    if(!ready){
      warmLog_('RPC not ready after waiting. Try again after page fully loads.', 'warn');
      return false;
    }

    var token = warmGetToken_();
    var cs = warmGetCallsign_();
    if(!token || !cs){
      warmLog_('Please log in first, then run Supercharge.', 'warn');
      return false;
    }

    var calls = warmRpcPlan_();

    var ok=0, bad=0;
    var spotDone=false;
    for(var i=0;i<calls.length;i++){
      var c = calls[i];
      var act = c[0], payload = c[1];
      try{
        var res = await warmCallRpcTimed_(act, payload);
        ok++;
        warmLog_('✔ rpc '+act);
        try{
          // cache stable-ish results for "instant first paint" on some pages
          if(warmCacheAllowed_(act)){
            warmCachePut_(act, payload, res, ((function(){try{var d=Number(localStorage.getItem('slb_warm_days')||'14'); if(isFinite(d)&&d>0&&d<=90) return d*((function(){try{var d=Number(localStorage.getItem('slb_warm_days')||'14'); if(isFinite(d)&&d>0&&d<=90) return d*24*60*60*1000;}catch(_e){} return 14*24*60*60*1000;})());}catch(_e){} return 14*((function(){try{var d=Number(localStorage.getItem('slb_warm_days')||'14'); if(isFinite(d)&&d>0&&d<=90) return d*24*60*60*1000;}catch(_e){} return 14*24*60*60*1000;})());})()));
          }
        }catch(_eWarmPut){}

        try{
          if(payload && payload.__warm_capture === 'magic7Targets'){
            // extract a targetId for spot-config warm
            var data = (res && (res.result || res.data || res)) || null;
            var first = null;
            if(Array.isArray(data)) first = data[0];
            else if(data && Array.isArray(data.targets)) first = data.targets[0];
            else if(data && Array.isArray(data.items)) first = data.items[0];
            if(first){
              var tid = (first.targetId || first.id || first._id || first.target || first);
              if(tid != null && tid !== ''){
                try{
                  var resSpot = await warmCallRpcTimed_('magic7SpotConfigGet', { targetId: String(tid) });
                  warmLog_('✔ rpc magic7SpotConfigGet');
                  spotDone=true;
                  warmProgTick_();
                  warmSetStatus_('Supercharging data… ' + (i+1) + '/' + (calls.length+1));
                  try{ warmCachePut_('magic7SpotConfigGet', { targetId: String(tid) }, resSpot, ((function(){try{var d=Number(localStorage.getItem('slb_warm_days')||'14'); if(isFinite(d)&&d>0&&d<=90) return d*24*60*60*1000;}catch(_e){} return 14*24*60*60*1000;})())); }catch(_ePut2){}
                }catch(e2){
                  warmLog_('✖ rpc magic7SpotConfigGet ('+(e2 && e2.message ? e2.message : 'fail')+')', 'warn');
                }
              }
            }
          }
        }catch(_eCap){}

      }catch(e){
        bad++;
        warmLog_('✖ rpc '+act+' ('+(e && e.message ? e.message : 'fail')+')', 'warn');
      }
      warmProgTick_();
      warmSetStatus_('Supercharging data… ' + (i+1) + '/' + (calls.length+1));
      await warmSleep_(60);
    }
    if(!spotDone){
      warmLog_('• rpc magic7SpotConfigGet (skipped)');
      warmProgTick_();
      warmSetStatus_('Supercharging data… ' + (calls.length+1) + '/' + (calls.length+1));
    }
    warmLog_('Data warmed: '+ok+' ok, '+bad+' failed.');

    // Normal Supercharge must stay quick. The seven admin inbox sweeps were still
    // running even though the progress counter said zero; that was the regression.
    // Run them only when a deliberate double-deep diagnostic mode is enabled.
    if(warmIsAdmin_() && warmShouldRunAdminSweep_()){
      await warmDiaryInboxCache_();
      warmProgTick_();

      await warmLettersInboxCache_();
      warmProgTick_();

      await warmCmrInboxCache_();
      warmProgTick_();

      await warmReportInboxCache_('sdr', 'SDR');
      warmProgTick_();

      await warmReportInboxCache_('swr', 'SWR');
      warmProgTick_();

      await warmReportInboxCache_('dcr', 'DCR');
      warmProgTick_();

      await warmReportInboxCache_('ddr', 'DDR');
      warmProgTick_();
    }else if(warmIsAdmin_()){
      warmLog_('Admin inbox sweep skipped in normal quick Supercharge.');
    }else{
      warmLog_('Admin inbox caches skipped: this account is not admin.');
    }
    return true;
  }


  function waitMs_(ms){ return new Promise(function(res){ setTimeout(res, ms); }); }

  function clickTab_(tab){
    try{
      var sel = 'button.menuItem[data-tab="'+tab+'"]';
      var btn = document.querySelector(sel);
      if(btn && !btn.disabled){
        btn.click();
        return true;
      }
    }catch(e){}
    return false;
  }

  async function warmTabWalk_(){
    try{
      warmLog_('Supercharging pages…');
      warmSetStatus_('Supercharging pages…');
      // Walk heavy tabs so their own init + caching runs once.
      // Note: these are data-tab keys from the top menu (button.menuItem[data-tab]).
      var seq = warmTabPlan_();

      for(var i=0;i<seq.length;i++){
        var tab = seq[i][0];
        var ms  = seq[i][1];
        warmLog_('• open '+tab+'…');
        clickTab_(tab);
        await waitMs_(ms);
        warmProgTick_();
        warmSetStatus_('Supercharging pages… ' + (i+1) + '/' + seq.length);

        // Extra: inside Admin panel, try to open Treasury Inbox subview if present.
        if(tab === 'admin'){
          try{
            var root = document.getElementById('tywApp') || document.body;
            var btns = root.querySelectorAll('button, a, [role="button"]');
            var target = null;
            for(var j=0;j<btns.length;j++){
              var t = (btns[j].textContent || '').trim();
              if(!t) continue;
              if(/Treasury\s*Inbox/i.test(t)){
                target = btns[j]; break;
              }
            }
            if(target){
              warmLog_('  ↳ open Treasury Inbox…');
              try{ target.click(); }catch(_e){}
              await waitMs_(2200);
            }
          }catch(_e){}
        }
      }

      warmLog_('UI tab warm done.');
    }catch(e){
      warmLog_('UI tab warm skipped: '+(e && e.message ? e.message : 'error'), 'warn');
    }
  }

  async function runWarmUp_(){
    if(__SLB_WARM_BUSY__) return;
    __SLB_WARM_BUSY__ = true;

    var btn = document.getElementById('slbWarmBtn');
    if(btn) btn.classList.add('slbWarmBusy');

    var modal = warmEnsureModal_();
    try{ modal.classList.remove('done'); }catch(_e){}
    __SLB_WARM_RETURN_FOCUS__ = document.activeElement;
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden','false');
    try{
      if(typeof __SLB_WARM_TRAP_RELEASE__ === 'function') __SLB_WARM_TRAP_RELEASE__(false);
      __SLB_WARM_TRAP_RELEASE__ = null;
      if(window.SLB && SLB.a11y && typeof SLB.a11y.trapDialog === 'function'){
        __SLB_WARM_TRAP_RELEASE__ = SLB.a11y.trapDialog(modal, {
          initialFocus: modal.querySelector('.slbWarmClose') || modal,
          returnFocus: __SLB_WARM_RETURN_FOCUS__,
          onEscape: function(){ if(!__SLB_WARM_BUSY__) modal.querySelector('.slbWarmClose').click(); }
        });
        SLB.a11y.announce('Supercharge opened');
      }
    }catch(_e){}

    var logBox = document.getElementById('slbWarmLog');
    if(logBox) logBox.innerHTML = '';
    warmSetStatus_('Supercharging your SLB…');

    var assetsFresh = warmSmartMode_() && warmCheckpointFresh_('assets', warmAssetsFreshMs_());
    var dataFresh = warmSmartMode_() && warmCheckpointFresh_('data', warmDataFreshMs_());
    var tabPlan = warmTabPlan_() || [];

    var _warmTotal = 0;
    try{ if(!assetsFresh) _warmTotal += (warmCollectAssetUrls_()||[]).length; }catch(_e){}
    try{ if(!dataFresh) _warmTotal += (warmRpcPlan_()||[]).length + 1 + warmAdminCacheSteps_(); }catch(_e){}
    try{ _warmTotal += tabPlan.length; }catch(_e){}
    warmProgInit_(_warmTotal);
    warmLog_('Quick Supercharge pre-loads only the useful shared assets and core data.');
    warmLog_(warmSmartMode_() ? 'Mode: quick checkpointed cache.' : 'Mode: deep diagnostic cache.');
    warmLog_('Admin inbox sweeps and page walking are disabled in normal mode.');
    warmLog_('You may close this window after it says Done.');

    try{
      if(assetsFresh){
        warmLog_('Assets already warm for this build; duplicate download skipped.');
      }else if(await warmFetchAssets_()){
        warmCheckpointMark_('assets');
      }

      if(dataFresh){
        warmLog_('Core data was refreshed recently; saved cache kept.');
      }else if(await warmRpcBatch_()){
        warmCheckpointMark_('data');
      }

      if(tabPlan.length) await warmTabWalk_();
      warmSetStatus_('Done.');
      warmLog_('Supercharge finished.');
      warmShowCompleted_();
    }catch(e){
      warmSetStatus_('Stopped.');
      warmLog_('Supercharge stopped: '+(e && e.message ? e.message : 'error'), 'warn');
    }finally{
      __SLB_WARM_BUSY__ = false;
      if(btn) btn.classList.remove('slbWarmBusy');
    }
  }

  
  // expose warmup for inline onclick
  window.SLB_WARMUP_OPEN = function(){ try{ runWarmUp_(); }catch(e){} };
  try{ window.SLB_WARMUP_OPEN_ALIAS = window.SLB_WARMUP_OPEN; }catch(e){}

function bindWarmBtn_(){
    var btn = document.getElementById('slbWarmBtn');
    if(btn && !btn.__warmBound){
      btn.__warmBound = true;
      btn.addEventListener('click', function(e){
        e.preventDefault();
        runWarmUp_();
      });
    }

    var mini = document.getElementById('slbWarmMiniBtn');
    if(mini && !mini.__warmBound){
      mini.__warmBound = true;
      mini.addEventListener('click', function(e){
        e.preventDefault();
        runWarmUp_();
      });
    }
  }

  function watchWarmButtons_(){
    bindWarmBtn_();
    try{ window.addEventListener('slb:auth-ready', bindWarmBtn_); }catch(_e){}
    try{ window.addEventListener('slb:module-loaded', bindWarmBtn_); }catch(_e2){}
    if(window.MutationObserver && document.body){
      var queued = false;
      var mo = new MutationObserver(function(muts){
        var relevant = false;
        for(var i=0;i<muts.length && !relevant;i++){
          var added = muts[i].addedNodes || [];
          for(var j=0;j<added.length;j++){
            var n = added[j];
            if(!n || n.nodeType !== 1) continue;
            if(n.id === 'slbWarmBtn' || n.id === 'slbWarmMiniBtn' ||
               (n.querySelector && n.querySelector('#slbWarmBtn,#slbWarmMiniBtn'))){ relevant = true; break; }
          }
        }
        if(!relevant || queued) return;
        queued = true;
        setTimeout(function(){ queued = false; bindWarmBtn_(); }, 0);
      });
      try{ mo.observe(document.body, {subtree:true, childList:true}); }catch(_e3){}
    }else{
      [300,1200,3500,8000].forEach(function(ms){ setTimeout(bindWarmBtn_, ms); });
    }
  }

  onceReady_(watchWarmButtons_);

})();


/* =========================================================
   ISO timestamp display cleanup (frontend only)
   Converts: 2025-12-29T17:12:31.549Z  ->  2025-12-29 @ 17:12
   This runs on all SLB pages and auto-formats newly inserted rows.
========================================================= */
(function(){
  // ISO string from backend
  var ISO_RE = /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z\b/g;
  // Common JS Date.toString() that can leak into some tables
  // Example: "Fri Feb 20 2026 12:43:17 GMT-0500 (Eastern Standard Time)"
  var GMT_RE = /\b(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun)\s+(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+\d{1,2}\s+\d{4}\s+\d{2}:\d{2}(?::\d{2})?\s+GMT[+-]\d{4}\b/;

  function pad2_(n){ n = Number(n)||0; return (n<10 ? '0' : '') + String(n); }

  function fmtDate_(d){
    try{
      if(!d || isNaN(d.getTime())) return null;
      return d.getFullYear() + '-' + pad2_(d.getMonth()+1) + '-' + pad2_(d.getDate()) + ' @ ' + pad2_(d.getHours()) + ':' + pad2_(d.getMinutes());
    }catch(e){ return null; }
  }

  function fmtIso_(iso){
    try{
      var d = new Date(iso);
      return fmtDate_(d);
    }catch(e){ return null; }
  }

  function fmtGmtStr_(s){
    try{
      var d = new Date(s);
      return fmtDate_(d);
    }catch(e){ return null; }
  }

  function maybeFormatText_(txt){
    if(!txt) return null;
    // ISO timestamps
    if(txt.indexOf('T')!==-1 && txt.indexOf('Z')!==-1 && ISO_RE.test(txt)){
      ISO_RE.lastIndex = 0;
      return txt.replace(ISO_RE, function(m){ return fmtIso_(m) || m; });
    }
    // JS Date.toString() style (single value in a cell)
    if(txt.indexOf('GMT')!==-1 && GMT_RE.test(txt)){
      return fmtGmtStr_(txt) || null;
    }
    return null;
  }

  function formatLeaf_(el){
    if(!el || el.nodeType !== 1) return;
    if(el.dataset && el.dataset.slbIsoFmt==='1') return;
    if(el.childElementCount && el.childElementCount>0) return;
    var t = el.textContent;
    if(!t || t.length>140) return;
    var trimmed = t.trim();
    var out = maybeFormatText_(trimmed);
    if(out && out !== trimmed){
      el.textContent = out;
      try{ el.dataset.slbIsoFmt = '1'; }catch(e){}
    }
  }

  function scan_(root){
    if(!root) return;
    try{ if(root.matches && root.matches('td,th,span,div,a,small,time,code')) formatLeaf_(root); }catch(_e){}
    if(!root.querySelectorAll) return;
    var nodes = root.querySelectorAll('td,th,span,div,a,small,time,code');
    for(var i=0;i<nodes.length;i++) formatLeaf_(nodes[i]);
  }

  function init_(){
    var root = document.getElementById('SaamLawBank') || document.getElementById('tyWealthCourtyard') || document.body;
    scan_(root);
    if(!window.MutationObserver) return;
    var pending = new Set();
    var timer = 0;
    function queue(node){
      if(!node) return;
      if(node.nodeType === 3) node = node.parentElement;
      if(node && node.nodeType === 1) pending.add(node);
      clearTimeout(timer);
      timer = setTimeout(function(){
        var batch = Array.from(pending);
        pending.clear();
        for(var i=0;i<batch.length;i++) scan_(batch[i]);
      }, 80);
    }
    var mo = new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        var m = muts[i];
        if(m.type === 'characterData'){ queue(m.target); continue; }
        var added = m.addedNodes || [];
        for(var j=0;j<added.length;j++) queue(added[j]);
      }
    });
    try{ mo.observe(root, {subtree:true, childList:true, characterData:true}); }catch(e){}
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init_);
  else init_();
})();


/* Cultivation V9: hard dark panel + class toggle. Runs from guard so it wins after theme CSS. */
(function(){
  try{
    if(window.__SLB_CULT_V9_GUARD__) return;
    window.__SLB_CULT_V9_GUARD__ = true;
    function inject(){
      if(document.getElementById('slbCultV9GuardStyle')) return;
      var css = `
#slbCultPanel.slbCultForceDark,
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel{--bg:#0b1113!important;--card:#0f1517!important;--soft:#131c1f!important;--text:#e9eef2!important;--muted:#aab6c0!important;--border2:rgba(226,230,234,.30)!important;--ty-line:rgba(239,94,20,.30)!important;background:#0f1517!important;background-image:none!important;color:#e9eef2!important;border-color:rgba(226,230,234,.22)!important;color-scheme:dark!important;}
#slbCultPanel.slbCultForceDark :is(.slbCultTodayBox,.slbCultFold,.slbProgCard,.tableWrap,.slbRepairGrid>div,.slbCultOvItem,.slbCard),
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel :is(.slbCultTodayBox,.slbCultFold,.slbProgCard,.tableWrap,.slbRepairGrid>div,.slbCultOvItem,.slbCard){background:#131c1f!important;background-image:none!important;color:#e9eef2!important;border-color:rgba(226,230,234,.22)!important;box-shadow:0 10px 24px rgba(0,0,0,.28)!important;}
#slbCultPanel.slbCultForceDark .slbCultTodayBox,
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel .slbCultTodayBox{background:linear-gradient(135deg,rgba(239,94,20,.20),rgba(19,28,31,.96))!important;border:1px solid rgba(239,94,20,.38)!important;}
#slbCultPanel.slbCultForceDark .slbCultFold>summary,
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel .slbCultFold>summary{background:rgba(239,94,20,.16)!important;color:#ffb17a!important;border-bottom:1px solid rgba(239,94,20,.28)!important;}
#slbCultPanel.slbCultForceDark :is(h1,h2,h3,h4,h5,h6,label,summary,td,th,.slbSectionTitle,.slbProgName,.slbCultQuickName,.slbCultRuleQuote),
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel :is(h1,h2,h3,h4,h5,h6,label,summary,td,th,.slbSectionTitle,.slbProgName,.slbCultQuickName,.slbCultRuleQuote){color:#e9eef2!important;}
#slbCultPanel.slbCultForceDark :is(.note,.muted,.sub,.slbProgMeta,.slbCultQuickMeta,.slbCultSaveHint,.slbCultRuleEnglish),
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel :is(.note,.muted,.sub,.slbProgMeta,.slbCultQuickMeta,.slbCultSaveHint,.slbCultRuleEnglish){color:#aab6c0!important;}
#slbCultPanel.slbCultForceDark :is(input:not([type=checkbox]):not([type=radio]),select,textarea),
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel :is(input:not([type=checkbox]):not([type=radio]),select,textarea){background:#0c1214!important;color:#e9eef2!important;border-color:rgba(226,230,234,.30)!important;box-shadow:none!important;color-scheme:dark!important;}
#slbCultPanel.slbCultForceDark :is(input,textarea)::placeholder,
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel :is(input,textarea)::placeholder{color:rgba(233,238,242,.55)!important;}
#slbCultPanel.slbCultForceDark table,
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel table{background:#0f1517!important;color:#e9eef2!important;}
#slbCultPanel.slbCultForceDark thead th,
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel thead th{background:#2a1a10!important;color:#e9eef2!important;border-color:rgba(239,94,20,.32)!important;}
#slbCultPanel.slbCultForceDark tbody td,
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel tbody td{color:#e9eef2!important;border-color:rgba(226,230,234,.16)!important;}
#slbCultPanel.slbCultForceDark tbody tr:nth-child(odd) td,
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel tbody tr:nth-child(odd) td{background:#172125!important;}
#slbCultPanel.slbCultForceDark tbody tr:nth-child(even) td,
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel tbody tr:nth-child(even) td{background:#0f1517!important;}
#slbCultPanel.slbCultForceDark .btn:not(.orange):not(.red):not(.danger),
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel .btn:not(.orange):not(.red):not(.danger){background:rgba(255,255,255,.08)!important;color:#e9eef2!important;border-color:rgba(255,255,255,.16)!important;}
#slbCultPanel.slbCultForceDark :is(.btn.orange,.slbCultQuickBtn:not(.slbCultDoneToday)),
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel :is(.btn.orange,.slbCultQuickBtn:not(.slbCultDoneToday)){background:linear-gradient(180deg,#ff8738,#ef5e14)!important;color:#fff!important;border-color:#ef5e14!important;box-shadow:0 8px 18px rgba(239,94,20,.22)!important;}
#slbCultPanel.slbCultForceDark .slbCultQuickBtn{display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;text-align:center!important;white-space:normal!important;min-height:66px!important;padding:14px 16px!important;border-radius:16px!important;line-height:1.2!important;}
#slbCultPanel.slbCultForceDark .slbCultQuickBtn.slbCultDoneToday,
#slbCultPanel.slbCultForceDark .slbCultQuickBtn.slbCultDoneToday[disabled],
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel .slbCultQuickBtn.slbCultDoneToday,
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel .slbCultQuickBtn.slbCultDoneToday[disabled]{background:#1f2b2f!important;color:#e9eef2!important;border-color:rgba(239,94,20,.58)!important;opacity:1!important;filter:none!important;}
#slbCultPanel.slbCultForceDark .slbCultManageFold>summary,
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel .slbCultManageFold>summary{background:linear-gradient(180deg,#243137 0%,#192226 100%)!important;color:#ffb17a!important;border-color:rgba(239,94,20,.40)!important;box-shadow:0 7px 18px rgba(0,0,0,.22)!important;}
#slbCultPanel.slbCultForceDark .slbCultManageFold>summary:after,
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel .slbCultManageFold>summary:after{color:#d7e0e4!important;}
#slbCultPanel .slbCultRuleBox,#slbCultPanel .slbCultRuleQuote,#slbCultPanel .slbCultRuleEnglish{text-align:center!important;}
#slbCultPanel .slbCultRuleBox{max-width:620px!important;margin:14px auto 0!important;padding:12px 14px!important;}
#slbCultPanel.slbCultForceDark .slbCultRuleBox,
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) #slbCultPanel .slbCultRuleBox{background:rgba(239,94,20,.13)!important;color:#e9eef2!important;border-color:rgba(239,94,20,.42)!important;box-shadow:none!important;}`;
      var st=document.createElement('style'); st.id='slbCultV9GuardStyle'; st.type='text/css'; st.appendChild(document.createTextNode(css)); (document.head||document.documentElement).appendChild(st);
    }
    function isDark(){
      try{ if(document.documentElement && document.documentElement.getAttribute('data-slb-theme')==='dark') return true; }catch(_e){}
      try{ if(String(localStorage.getItem('SLB_THEME')||'').toLowerCase()==='dark') return true; }catch(_e){}
      return false;
    }
    function apply(){
      inject();
      var p=document.getElementById('slbCultPanel') || document.querySelector('[data-panel="cult"]');
      if(!p) return;
      p.classList.toggle('slbCultForceDark', isDark());
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', apply, {once:true}); else apply();
    setTimeout(apply,50); setTimeout(apply,350); setTimeout(apply,1200);
    window.addEventListener('storage', apply);
    try{ new MutationObserver(apply).observe(document.documentElement,{attributes:true,attributeFilter:['data-slb-theme','class']}); }catch(_e){}
  }catch(_e){}
})();


